import { Words } from './../interface/i18n.interface';

export const wordsList: Words = {
    Integrations: {
        pt: 'Integrações',
        en: 'Integrations',
    },
    'Start attendance': {
        pt: 'Iniciar atendimento',
        en: 'Start attendance',
    },
    hasRelationshipWithDoctors: {
        pt: 'Tem relação com médicos',
        en: 'Has relationship with doctors',
    },
    'Run first schedule rule': {
        pt: 'Executar regra de primeiro agendamento',
        en: 'Run first schedule rule',
    },
    'Api username': {
        pt: 'Usuário da api',
        en: 'Api username',
    },
    'Api password': {
        pt: 'Senha da api',
        en: 'Api password',
    },
    Specialities: {
        pt: 'Especialidades',
        en: 'Specialities',
    },
    includeOnly: {
        pt: 'Incluir apenas',
        en: 'Include only',
    },
    Weight: {
        pt: 'Peso',
        en: 'Weight',
    },
    'Uses correlation': {
        pt: 'Usa correlação',
        en: 'Uses correlation',
    },
    'Split Insurance Into Insurance Plans': {
        en: 'Split Insurance Into Insurance Plans',
        pt: 'Dividir convênios em planos',
    },
    'Occupation area': {
        en: 'Occupation area',
        pt: 'Area de atuação',
    },
    Location: {
        en: 'Location',
        pt: 'Localização',
    },
    occupationArea: {
        en: 'Occupation area',
        pt: 'Area de atuação',
    },
    insurance_suggestion: {
        en: 'Suggested insurance',
        pt: 'Sugestão de convênio',
    },
    occupationArea_search: {
        en: 'Occupation area search',
        pt: 'Busca da area de atuação',
    },
    organizationUnitLocation: {
        en: 'Location',
        pt: 'Localização',
    },
    organizationUnitLocation_search: {
        en: 'Location search',
        pt: 'Busca da localização',
    },
    typeOfService: {
        en: 'Type of service',
        pt: 'Tipo de serviço',
    },
    typeOfService_search: {
        en: 'Type of service search',
        pt: 'Busca do tipo de serviço',
    },
    confirmPassive: {
        pt: 'Confirmação pelo bot',
        en: 'Bot confirmation',
    },
    weekly: {
        pt: 'Semanal',
        en: 'weekly',
    },
    'Sync type': {
        pt: 'Tipo de sincronização',
        en: 'Sync type',
    },
    since: {
        pt: 'desde',
        en: 'since',
    },
    daily: {
        pt: 'Diário',
        en: 'daily',
    },
    export: {
        pt: 'Exportar',
        en: 'export',
    },
    confirmAppointment: {
        pt: 'Confirmar horário',
        en: 'Confirm appointment',
    },
    'Send instructions to the patient after scheduling': {
        pt: 'Enviar instruções para o paciente após agendamento',
        en: 'Send instructions to the patient after scheduling',
    },
    'Uses composite code in procedures': {
        pt: 'Usa código composto em procedimentos',
        en: 'Uses composite code in procedures',
    },
    'Update patient gender when scheduling': {
        pt: 'Atualizar sexo do paciente ao agendar',
        en: 'Update patient gender when scheduling',
    },
    'Update patient email when scheduling': {
        pt: 'Atualizar email do paciente ao agendar',
        en: 'Update patient email when scheduling',
    },
    'Update patient phone when scheduling': {
        pt: 'Atualizar telefone do paciente ao agendar',
        en: 'Update patient phone when scheduling',
    },
    'There was an error starting the attendance. Check that the contact or phone number is correct': {
        en: 'There was an error starting the attendance. Check that the contact or phone number is correct',
        pt: 'Ocorreu um erro ao iniciar o atendimento. Verifique se o contato ou número de telefone estão corretos',
    },
    'An error occurred when starting the service. Try again later': {
        pt: 'Ocorreu um erro ao iniciar o atendimento. Tente novamente mais tarde',
        en: 'There was an error starting the attendance. Try again later',
    },
    'Error. Try again in a few minutes': {
        pt: 'Erro. Tente novamente em alguns minutos',
        en: 'Error. Try again in a few minutes',
    },
    'Verify if the fields are correct': {
        pt: 'Verificar se os campos estão corretos',
        en: 'Verify if the fields are correct',
    },
    'Your password has expired. Define a new one below': {
        en: 'Your password has expired. Define a new one below',
        pt: 'A sua senha está expirada. Defina uma nova abaixo',
    },
    'Use procedure instead of specialty in inter appointment validation': {
        en: 'Use procedure instead of specialty in inter appointment validation',
        pt: 'Utilizar procedimento ao invés de especialidade na validação de interconsulta',
    },
    'Does not allow patient scheduling for the same day': {
        en: 'Does not allow patient scheduling for the same day',
        pt: 'Não permite agendamento do paciente para um mesmo dia',
    },
    'Does not allow patient scheduling for the same day/doctor': {
        en: 'Does not allow patient scheduling for the same day/doctor',
        pt: 'Não permite agendamento do paciente para um mesmo dia/médico',
    },
    'The password was entered incorrectly 5 times. try again in 10 minutes': {
        en: 'The password was entered incorrectly 5 times. try again in 10 minutes',
        pt: 'A senha foi digitada incorretamente 5 vezes. Tente novamente em 10 minutos',
    },
    'No attendance so far': {
        en: 'No attendance so far',
        pt: 'Nenhum atendimento até o momento',
    },
    'Set a new permanent password': {
        pt: 'Defina uma nova senha definitiva',
        en: 'Set a new permanent password',
    },
    'Unable to display contact information': {
        en: 'Unable to display contact information',
        pt: 'Não foi possível exibir informações do contato',
    },
    'Contact blocked successfully!': {
        en: 'Contact blocked successfully!',
        pt: 'Contato bloqueado com sucesso!',
    },
    'Contact unlocked successfully!': {
        en: 'Contact unlocked successfully!',
        pt: 'Contato desbloqueado com sucesso!',
    },
    "We didn't find any blocked contacts!": {
        en: "We didn't find any blocked contacts!",
        pt: 'Não encontramos nenhum contato bloqueado!',
    },
    'Filter blocked contacts': {
        en: 'Filter blocked contacts',
        pt: 'Filtrar contatos bloqueados',
    },
    'Template is being used for active messages': {
        en: 'Template is being used for active messages',
        pt: 'O Template está sendo usado para mensagens ativas',
    },
    'Remove filter': {
        en: 'Remove filter',
        pt: 'Remover filtro',
    },
    'Blocked contact': {
        en: 'Blocked contact',
        pt: 'Contato bloqueado',
    },
    Blocked: {
        en: 'Blocked',
        pt: 'Bloqueados',
    },
    'Type at least 4 characters to search by contact or click blocked!': {
        en: 'Type at least 4 characters to search by contact or click blocked!',
        pt: 'Digite pelo menos 4 caracteres para efetuar a busca por contato ou clique em bloqueados!',
    },
    'Are you sure you want to unblock this contact?': {
        en: 'Are you sure you want to unblock this contact?',
        pt: 'Tem certeza que deseja desbloquear este contato?',
    },
    'Are you sure you want to block this contact?': {
        en: 'Are you sure you want to block this contact?',
        pt: 'Tem certeza que deseja bloquear este contato?',
    },
    'Block contact': {
        en: 'Block contact',
        pt: 'Bloquear contato',
    },
    'Unblock contact': {
        en: 'Unblock contact',
        pt: 'Desbloquear contato',
    },
    'This contact is blocked!': {
        en: 'This contact is blocked.',
        pt: 'Este contato está bloqueado.',
    },
    'Send type of service on schedule': {
        en: 'Send type of service on schedule',
        pt: 'Enviar tipo de atendimento no agendamento',
    },
    'Use procedure without speciality relation': {
        en: 'Use procedure without speciality relation',
        pt: 'Usar procedimento sem relação de especialidade',
    },
    morning: {
        pt: 'Manhã',
        en: 'Morning',
    },
    afternoon: {
        pt: 'Tarde',
        en: 'Afternoon',
    },
    indifferent: {
        pt: 'Indiferente',
        en: 'Indifferent',
    },
    'Period of day': {
        pt: 'Período do dia',
        en: 'Period of day',
    },
    'Select period': {
        pt: 'Selecione um período',
        en: 'Select period',
    },
    'Maximum age': {
        en: 'Maximum age',
        pt: 'Idade máxima',
    },
    'Minimum age': {
        en: 'Minimum age',
        pt: 'Idade mínima',
    },
    Speciality: {
        pt: 'Especialidade',
        en: 'Speciality',
    },
    'Email not exists': {
        en: 'Email not exists',
        pt: 'Email inexistente',
    },
    'Workspaces you have access to. Click to browse': {
        pt: 'Clique para navegar',
        en: 'Click to browse',
    },
    Workspaces: {
        pt: 'Áreas de trabalho',
        en: 'Workspaces',
    },
    Procedures: {
        pt: 'Procedimentos',
        en: 'Procedures',
    },
    'You do not have access to this page on your': {
        en: 'You do not have access to this page on your',
        pt: 'Você não tem acesso a esta página em sua',
    },
    'current location': {
        en: 'current location',
        pt: 'localização atual',
    },
    'Go to': {
        en: 'Go to',
        pt: 'Ir para',
    },
    Next: {
        en: 'Next',
        pt: 'Próximo',
    },
    "You don't have access to any workspace": {
        en: "You don't have access to any workspace",
        pt: 'Você não tem acesso a nenhum workspace',
    },
    'Organization units': {
        pt: 'Unidades',
        en: 'Organization units',
    },
    'Error. Please try again later or talk to your supervisor': {
        en: 'Error. Please try again later or talk to your supervisor',
        pt: 'Erro. Tente novamente mais tarde ou fale com seu supervisor',
    },
    'Try again in a few minutes': {
        en: 'Try again in a few minutes',
        pt: 'Tente novamente em alguns minutos',
    },
    'This field must contain only letters (A-Z), numbers (0-9), underscores (_), and dashes (-). Special characters are not permitted.':
        {
            en: 'This field must contain only letters (A-Z), numbers (0-9), underscores (_), and dashes (-). Special characters are not permitted.',
            pt: 'Este campo deve conter apenas letras (A-Z), números (0-9), sublinhados (_) e travessões (-). Caracteres especiais não são permitidos.',
        },
    'This field must contain only letters (A-Z), numbers (0-9), and underscores (_). It cannot start with a number. Special characters are not permitted.':
        {
            en: 'This field must contain only letters (A-Z), numbers (0-9), and underscores (_). It cannot start with a number. Special characters are not permitted.',
            pt: 'Este campo deve conter apenas letras (A-Z), números (0-9) e sublinhados (_). Não pode começar com um número. Caracteres especiais não são permitidos.',
        },
    'Used to trigger this interaction by an action in another interaction': {
        en: 'Used to trigger this interaction by an action in another interaction',
        pt: 'Usado para desencadear esta interação por uma ação em outra interação',
    },
    'Add to campaign': {
        en: 'Add to campaign',
        pt: 'Adicionar a campanha',
    },
    'Enter the trigger action': {
        en: 'Enter the trigger action',
        pt: 'Digite a ação da trigger',
    },
    'Action Name': {
        en: 'Action Name',
        pt: 'Nome da Ação',
    },
    'The action field is required': {
        en: 'The action field is required',
        pt: 'O campo ação é obrigatório',
    },
    'Spaces are not allowed': {
        en: 'Spaces are not allowed',
        pt: 'Não são permitidos espaços',
    },
    'Profile configuration': {
        en: 'Profile configuration',
        pt: 'Configuração de perfil',
    },
    'When enabling, the user will not be able to edit profile information': {
        en: 'When enabling, the user will not be able to edit profile information',
        pt: 'Ao habilitar usuário não poderá editar as informações do perfil',
    },
    'Error saving file!': {
        en: 'Error saving file!',
        pt: 'Erro ao salvar o arquivo!',
    },
    'Select file': {
        en: 'Select file',
        pt: 'Selecione um arquivo',
    },
    'This message contains file': {
        en: 'This message contains file',
        pt: 'Esta mensagem contém arquivo',
    },
    'Template is inactive': {
        en: 'Template is inactive',
        pt: 'Template inativo',
    },
    'Template sent successfully': {
        en: 'Template sent successfully',
        pt: 'Template enviado com sucesso',
    },
    'Add quick reply button': {
        en: 'Add quick reply button',
        pt: 'Adicionar botão de resposta rápida',
    },
    'Add URL button': {
        en: 'Add URL button',
        pt: 'Adicionar botão de URL',
    },
    'Add URL': {
        en: 'Add URL',
        pt: 'Adicione a URL',
    },
    'Quick reply': {
        en: 'Quick reply',
        pt: 'Resposta rápida',
    },
    Buttons: {
        en: 'Buttons',
        pt: 'Botões',
    },
    'Show message preview': {
        en: 'Show message preview',
        pt: 'Mostrar visualização da mensagem',
    },
    'Channel not found, contact your supervisor': {
        en: 'Channel not found, contact your supervisor',
        pt: 'Canal não encontrado, entre em contato com seu supervisor',
    },
    'Message can only be sent with a file of this type (image) or without any file!': {
        en: 'Message can only be sent with a file of this type (image) or without any file!',
        pt: 'Mensagem só poderá ser enviada com arquivo do tipo (imagem) ou sem nenhum arquivo!',
    },
    'Understand more about the templates': {
        en: 'Understand more about the templates',
        pt: 'Entenda mais sobre os templates',
    },
    'Select a status': {
        en: 'Select a status',
        pt: 'Selecione um status',
    },
    'Understand more about auto assign': {
        en: 'Understand more about auto assign',
        pt: 'Entenda mais sobre o auto atribuir',
    },
    'Understand more about permissions': {
        en: 'Understand more about permissions',
        pt: 'Entenda mais sobre as permissões',
    },
    Id: {
        pt: 'Id',
        en: 'Id',
    },
    reason: {
        pt: 'Motivos não agendamento',
        en: 'Reason',
    },
    'Error on delete entity': {
        pt: 'Erro ao deletar entidade',
        en: 'Error on delete entity',
    },
    'Error on delete agent': {
        pt: 'Erro ao deletar agente',
        en: 'Error on delete agent',
    },
    Insurances: {
        pt: 'Convênios',
        en: 'Insurances',
    },
    Doctors: {
        pt: 'Médicos',
        en: 'Doctors',
    },
    'Choose doctor': {
        pt: 'Escolher médico',
        en: 'Choose doctor',
    },
    'Appointment types': {
        pt: 'Tipos de agendamento',
        en: 'Appointment types',
    },
    'No integration available.': {
        pt: 'Nenhuma integração disponível.',
        en: 'No integration available.',
    },
    Save: {
        pt: 'Salvar',
        en: 'Save',
    },
    'Edit profile informations': {
        pt: 'Editar informações do perfil',
        en: 'Edit profile informations',
    },
    New: {
        pt: 'Novo',
        en: 'New',
    },
    new: {
        pt: 'Novo',
        en: 'New',
    },
    'New entity': {
        pt: 'Nova entidade',
        en: 'New entity',
    },
    'Edit entity': {
        pt: 'Editar entidade',
        en: 'Edit entity',
    },
    'Edit actions': {
        pt: 'Editar ações',
        en: 'Edit actions',
    },
    Name: {
        pt: 'Nome',
        en: 'Name',
    },
    'Friendly name': {
        pt: 'Nome de exibição',
        en: 'Display name',
    },
    'Health integration created': {
        pt: 'Integração de saúde criada',
        en: 'Health integration created',
    },
    'We get an error, try again': {
        pt: 'Houve um erro, tente novamente',
        en: 'We get an error, try again',
    },
    'Health integration updated': {
        pt: 'Integração de saúde atualizada',
        en: 'Health integration updated',
    },
    'Code integration': {
        pt: 'Código da integração',
        en: 'Code integration',
    },
    Environment: {
        pt: 'Ambiente',
        en: 'Environment',
    },
    production: {
        pt: 'Produção',
        en: 'Production',
    },
    test: {
        pt: 'Teste',
        en: 'Test',
    },
    Slug: {
        pt: 'Slug',
        en: 'Slug',
    },
    Avatar: {
        pt: 'Avatar',
        en: 'Avatar',
    },
    'Remove photo': {
        pt: 'Remover foto',
        en: 'Remove photo',
    },
    'Add photo': {
        pt: 'Adicionar foto',
        en: 'Add photo',
    },
    'Change photo': {
        pt: 'Alterar foto',
        en: 'Change photo',
    },
    'Edit profile': {
        pt: 'Editar perfil',
        en: 'Edit profile',
    },
    Language: {
        pt: 'Idioma',
        en: 'Language',
    },
    'Expand all': {
        pt: 'Expandir',
        en: 'Expand all',
    },
    'Collapse all': {
        pt: 'Recolher',
        en: 'Collapse all',
    },
    'Go back workspaces': {
        pt: 'Voltar para workspaces',
        en: 'Go back workspaces',
    },
    'Create bot': {
        pt: 'Criar bot',
        en: 'Create bot',
    },
    requestAcceptance: {
        pt: 'Solicitar aceite',
        en: 'Request acceptance',
    },
    preload: {
        pt: 'Carregar dados do paciente',
        en: 'Preload patient data',
    },
    removeAcceptance: {
        pt: 'Remover vínculo',
        en: 'Remove vincule',
    },
    Loadmore: {
        pt: 'Carregar mais...',
        en: 'Load more...',
    },
    'New bot': {
        pt: 'Novo bot',
        en: 'New bot',
    },
    'Clone bot': {
        pt: 'Clonar bot',
        en: 'Clone bot',
    },
    Back: {
        pt: 'Voltar',
        en: 'Back',
    },
    Entities: {
        pt: 'Entidades',
        en: 'Entities',
    },
    Users: {
        pt: 'Usuários',
        en: 'Users',
    },
    Profile: {
        pt: 'Perfil',
        en: 'Profile',
    },
    Logout: {
        pt: 'Sair',
        en: 'Logout',
    },
    Search: {
        pt: 'Buscar',
        en: 'Search',
    },
    characters: {
        pt: 'caracteres',
        en: 'characters',
    },
    Label: {
        pt: 'Rótulo',
        en: 'Label',
    },
    'Enter at least 4 characters to search.': {
        pt: 'Digite ao menos 4 caracteres para efetuar a busca.',
        en: 'Enter at least 4 characters to search.',
    },
    'Only messages typed by the attendant or patient will be searched.': {
        pt: 'Apenas mensagens digitados pelo atendente ou paciente serão buscados.',
        en: 'Only messages typed by the attendant or patient will be searched.',
    },
    'Search by conversation ID. Ex: #22554.': {
        pt: 'Pesquise pelo ID da conversa. Ex: #22554.',
        en: 'Search by conversation ID. Ex: #22554.',
    },
    'Create new channel': {
        pt: 'Criar novo canal',
        en: 'Create new channel',
    },
    Channels: {
        pt: 'Canais',
        en: 'Channels',
    },
    Others: {
        pt: 'Outros',
        en: 'Others',
    },
    Cancel: {
        pt: 'Cancelar',
        en: 'Cancel',
    },
    'Delete bot': {
        pt: 'Deletar bot',
        en: 'Delete bot',
    },
    'Bot deleted': {
        pt: 'Bot deletado',
        en: 'Bot deleted',
    },
    'Error. Try again': {
        pt: 'Erro. Tente novamente',
        en: 'Error. Try again',
    },
    'Confirm delete': {
        pt: 'Confirmar exclusão',
        en: 'Confirm delete',
    },
    'Are you sure you want to delete the bot?': {
        pt: 'Tem certeza de que deseja excluir o bot?',
        en: 'Are you sure you want to delete the bot?',
    },
    'Go back bot': {
        pt: 'Voltar para o bot',
        en: 'Go back bot',
    },
    Interaction: {
        pt: 'Interação',
        en: 'Interaction',
    },
    Reference: {
        pt: 'Referência',
        en: 'Reference',
    },
    Container: {
        pt: 'Container',
        en: 'Container',
    },
    'Fallback context': {
        pt: 'Fallback',
        en: 'Fallback context',
    },
    'Select a interaction to reference': {
        pt: 'Selecione uma interação para referenciar',
        en: 'Select a interaction to reference',
    },
    'Interaction name': {
        pt: 'Nome da interação',
        en: 'Interaction name',
    },
    'New container': {
        pt: 'Novo container',
        en: 'New container',
    },
    'New integration': {
        pt: 'Nova integração',
        en: 'New integration',
    },
    'New interaction': {
        pt: 'Nova interação',
        en: 'New interaction',
    },
    'This field is required': {
        pt: 'Campo obrigatório',
        en: 'This field is required',
    },
    'Bot responses': {
        pt: 'Resposta do bot',
        en: 'Bot responses',
    },
    'User says': {
        pt: 'Usuário diz',
        en: 'User says',
    },
    'Save input to attribute': {
        pt: 'Salvar entrada no atributo',
        en: 'Save input to attribute',
    },
    'Validation entity': {
        pt: 'Entidade de validação',
        en: 'Validation entity',
    },
    Entity: {
        pt: 'Entidade',
        en: 'Entity',
    },
    'User field says it is invalid!': {
        pt: 'O campo do usuário diz que está inválido!',
        en: 'User field says it is invalid!',
    },
    'Some bot responses are invalid!': {
        pt: 'Algumas respostas do bot são inválidas!',
        en: 'Some bot responses are invalid!',
    },
    'The "parameter" naming is not allowed.': {
        pt: 'A  nomenclatura "parameter" não é permitido.',
        en: 'The "parameter" naming is not allowed.',
    },
    'The selected entity type "Any" is not allowed.': {
        pt: 'O tipo de entidade selecionado "Qualquer" não é permitido.',
        en: 'The selected entity type "Any" is not allowed.',
    },
    'Some response filter is invalid!': {
        pt: 'Algum filtro de resposta é inválido!',
        en: 'Some response filter is invalid!',
    },
    'Close the interaction and open it again': {
        pt: 'Feche a interaction e abra novamente',
        en: 'Close the interaction and open it again',
    },
    'An error occurred while loading the interaction': {
        pt: 'Ocorreu um erro ao carregar a interaction',
        en: 'An error occurred while loading the interaction',
    },
    Advanced: {
        pt: 'Avançado',
        en: 'Advanced',
    },
    Comments: {
        pt: 'Comentários',
        en: 'Comments',
    },
    Tree: {
        pt: 'Árvore',
        en: 'Tree',
    },
    'Drop above': {
        pt: 'Soltar acima de',
        en: 'Drop above',
    },
    'Drop as last child': {
        pt: 'Soltar como último filho de',
        en: 'Drop as last child',
    },
    'Are you sure you want to delete interaction': {
        pt: 'Tem certeza de que deseja excluir a interação',
        en: 'Are you sure you want to delete interaction',
    },
    'Are you sure you want to delete health entity': {
        pt: 'Tem certeza de que deseja excluir a entidade',
        en: 'Are you sure you want to delete health entity',
    },
    Delete: {
        pt: 'Excluir',
        en: 'Delete',
    },
    or: {
        pt: 'ou',
        en: 'or',
    },
    Order: {
        pt: 'Ordem',
        en: 'Order',
    },
    'Bot name': {
        pt: 'Nome do bot',
        en: 'Bot name',
    },
    'Are you sure you want to delete the fallback': {
        pt: 'Tem certeza de que deseja excluir o fallback',
        en: 'Are you sure you want to delete the fallback',
    },
    'Unsaved changes': {
        pt: 'Alterações não salvas',
        en: 'Unsaved changes',
    },
    'without saving': {
        pt: 'sem salvar',
        en: 'without saving',
    },
    'You have unsaved changes. Are you sure you want to leave': {
        pt: 'Você tem alterações não salvas. Você tem certeza de que quer sair',
        en: 'You have unsaved changes. Are you sure you want to leave',
    },
    Yes: {
        pt: 'Sim',
        en: 'Yes',
    },
    No: {
        pt: 'Não',
        en: 'No',
    },
    'Bot settings': {
        pt: 'Configurações do bot',
        en: 'Bot settings',
    },
    'Channel token': {
        pt: 'Token do canal',
        en: 'Channel token',
    },
    'Hexadecimal color': {
        pt: 'Cor hexadecimal',
        en: 'Hexadecimal color',
    },
    Channel: {
        pt: 'Canal',
        en: 'Channel',
    },
    'Expires at': {
        pt: 'Expira ás',
        en: 'Expires at',
    },
    Minutes: {
        pt: 'Minutos',
        en: 'Minutes',
    },
    Hours: {
        pt: 'Horas',
        en: 'Hours',
    },
    Days: {
        pt: 'Dias',
        en: 'Days',
    },
    'do not expire': {
        pt: 'Não expirar',
        en: 'do not expire',
    },
    'do not suspend': {
        pt: 'Não suspender',
        en: 'do not suspend',
    },
    'Expiration time': {
        pt: 'Tempo de expiração',
        en: 'Expiration time',
    },
    'Suspend conversation until': {
        pt: 'Suspender conversa até',
        en: 'Suspend conversation until',
    },
    'Send message to open conversation': {
        pt: 'Enviar mensagem para conversa aberta',
        en: 'Send message to open conversation',
    },
    Equals: {
        pt: 'Igual á',
        en: 'Equal to',
    },
    'Not equals': {
        pt: 'Diferente de',
        en: 'Different from',
    },
    Empty: {
        pt: 'Vazio',
        en: 'Empty',
    },
    'Not contains': {
        pt: 'Não contém o texto',
        en: 'Does not contain text',
    },
    Contains: {
        pt: 'Contém o texto',
        en: 'Contains the text',
    },
    "It's on the list": {
        pt: 'Está dentro da lista',
        en: "It's on the list",
    },
    'Not on the list': {
        pt: 'Não está dentro da lista',
        en: 'Not on the list',
    },
    Observations: {
        pt: 'Observações',
        en: 'Observations',
    },
    'Greater than': {
        pt: 'Maior que',
        en: 'Greater than',
    },
    'Less than': {
        pt: 'Menor que',
        en: 'Less than',
    },
    'Greater or equal': {
        pt: 'Maior ou igual',
        en: 'Greater or equal',
    },
    Operator: {
        pt: 'Operador',
        en: 'Operator',
    },
    Attribute: {
        pt: 'Atributo',
        en: 'Attribute',
    },
    Value: {
        pt: 'Valor',
        en: 'Value',
    },
    Type: {
        pt: 'Tipo',
        en: 'Type',
    },
    'Content is not json format': {
        pt: 'O conteúdo não possui formato JSON',
        en: 'Content is not JSON format',
    },
    'No selected interaction': {
        pt: 'Nenhuma interação selecionada',
        en: 'No selected interaction',
    },
    Filters: {
        pt: 'Filtros',
        en: 'Filters',
    },
    'Copy to interaction': {
        pt: 'Copiar para interação',
        en: 'Copy to interaction',
    },
    Entries: {
        pt: 'Entradas',
        en: 'Entries',
    },
    'Show attributes': {
        pt: 'Exibir atributos',
        en: 'Show attributes',
    },
    'Filter entries': {
        pt: 'Filtrar entradas',
        en: 'Filter entries',
    },
    'Filter attribute': {
        pt: 'Filtrar atributo',
        en: 'Filter attribute',
    },
    Synonyms: {
        pt: 'Sinônimos',
        en: 'Synonyms',
    },
    'Attribute name': {
        pt: 'Nome do atributo',
        en: 'Attribute name',
    },
    'Attribute value': {
        pt: 'Valor do atributo',
        en: 'Attribute value',
    },
    'Add Entry': {
        pt: 'Adicionar entrada',
        en: 'Add Entry',
    },
    'Show Attributes': {
        pt: 'Mostrar atributos',
        en: 'Show Attributes',
    },
    'My filters': {
        pt: 'Meus filtros',
        en: 'My filters',
    },
    'Go to Demo': {
        pt: 'Ir para Demo',
        en: 'Go to Demo',
    },
    'Go to WhatsApp': {
        pt: 'Ir para o WhatsApp',
        en: 'Go to WhatsApp',
    },
    'Copy whatsapp link': {
        pt: 'Copiar link do whatsapp',
        en: 'Copy whatsapp link',
    },
    Entry: {
        pt: 'Entrada',
        en: 'Entry',
    },
    'Fill synonym and press enter to add': {
        pt: 'Insira um sinônimo e pressione Enter para adicionar',
        en: 'Fill synonym and press enter to add',
    },
    'Entity attributes': {
        pt: 'Atributos da entidade',
        en: 'Entity attributes',
    },
    'Attribute type': {
        pt: 'Tipo do atributo',
        en: 'Attribute type',
    },
    'Entry reference value': {
        pt: 'Insira um valor de referência',
        en: 'Entry reference value',
    },
    'Image url': {
        pt: 'Link da imagem',
        en: 'Image url',
    },
    'This field must be a valid URL': {
        pt: 'Este campo deve ter um link válido',
        en: 'This field must be a valid URL',
    },
    'Video url': {
        pt: 'Link do vídeo',
        en: 'Video url',
    },
    Title: {
        pt: 'Título',
        en: 'Title',
    },
    'Sub title': {
        pt: 'Subtítulo',
        en: 'Sub title',
    },
    Text: {
        pt: 'Texto',
        en: 'Text',
    },
    'Add button': {
        pt: 'Add botão',
        en: 'Add button',
    },
    Height: {
        pt: 'Altura',
        en: 'Height',
    },
    'Import several': {
        pt: 'Importar vários',
        en: 'Import several',
    },
    Image: {
        pt: 'Imagem',
        en: 'Image',
    },
    Video: {
        pt: 'Vídeo',
        en: 'Video',
    },
    'Button title': {
        pt: 'Título do botão',
        en: 'Button title',
    },
    'Button title that will appear on bot attendance card': {
        pt: 'Título do botão que aparecerá no cartão de atendimento do bot',
        en: 'Button title that will appear on bot attendance card',
    },
    'Goto interaction': {
        pt: 'Ir para interação',
        en: 'Goto interaction',
    },
    Button: {
        pt: 'Botão',
        en: 'Button',
    },
    'Send typing': {
        pt: 'Enviar digitação',
        en: 'Send typing',
    },
    'Send an activity simulating bot typing': {
        pt: 'Envia uma atividade simulando a digitação do bot',
        en: 'Send an activity simulating bot typing',
    },
    'Not implemented yet': {
        pt: 'Ainda não implementado',
        en: 'Not implemented yet',
    },
    'Click a bot answers and actions here to make your chatbot responsive': {
        pt: 'Clique nas responses ou actions para tornar seu chatbot responsivo',
        en: 'Click a bot answers and actions here to make your chatbot responsive',
    },
    Clone: {
        pt: 'Clonar',
        en: 'Clone',
    },
    Copy: {
        pt: 'Copiar',
        en: 'Copy',
    },
    'Successfully copied': {
        pt: 'Copiado com sucesso',
        en: 'successfully copied',
    },
    'Copy to another bot': {
        pt: 'Copiar para outro bot',
        en: 'Copy to another bot',
    },
    'Go to the bot where the change was made?': {
        pt: 'Ir para o bot onde a alteração foi feita?',
        en: 'Go to the bot where the change was made?',
    },
    'Add new question': {
        pt: 'Adicionar nova questão',
        en: 'Add new question',
    },
    'Error messages': {
        pt: 'Mensagens de erro',
        en: 'Error messages',
    },
    'go to fallback': {
        pt: 'ir para fallback',
        en: 'go to fallback',
    },
    'Show next messages': {
        pt: 'Mostrar próximas mensagens',
        en: 'Show next messages',
    },
    times: {
        pt: 'vezes',
        en: 'times',
    },
    Once: {
        pt: 'Uma vez',
        en: 'Once',
    },
    'Select option': {
        pt: 'Selecione uma opção',
        en: 'Select option',
    },
    'Ask again': {
        pt: 'Perguntar novamente',
        en: 'Ask again',
    },
    time: {
        pt: 'vez',
        en: 'time',
    },
    "Don't ask": {
        pt: 'Não perguntar',
        en: "Don't ask",
    },
    'Type your question': {
        pt: 'Digite sua pergunta',
        en: 'Type your question',
    },
    'show next messages': {
        pt: 'exibir próximas mensagens',
        en: 'show next messages',
    },
    'Save answer to attribute': {
        pt: 'Salvar pergunta no atributo',
        en: 'Save answer to attribute',
    },
    'If attribute exists': {
        pt: 'Se atributo existir',
        en: 'If attribute exists',
    },
    'Required answer': {
        pt: 'Pergunta obrigatória',
        en: 'Required answer',
    },
    'Action on failure': {
        pt: 'Ação em caso de falha',
        en: 'Action on failure',
    },
    'Ask user': {
        pt: 'Perguntar ao usuário',
        en: 'Ask user',
    },
    'Validation type': {
        pt: 'Tipo de validação',
        en: 'Validation type',
    },
    Case: {
        pt: 'Caso',
        en: 'Case',
    },
    Default: {
        pt: 'Padrão',
        en: 'Default',
    },
    Random: {
        pt: 'Aleatório',
        en: 'Random',
    },
    'Add case': {
        pt: 'Adicionar caso',
        en: 'Add case',
    },
    'Random text': {
        pt: 'Texto aleatório',
        en: 'Random text',
    },
    'Value of attribute': {
        pt: 'Valor do atributo',
        en: 'Value of attribute',
    },
    'Random text to show to user when case condition is satisfied': {
        pt: 'Texto aleatório exibido ao usuário quando a condição do caso for atendida',
        en: 'Random text to show to user when case condition is satisfied',
    },
    'Default text to send to user when no cases satisfy your condition': {
        pt: 'Texto padrão enviado ao usuário quando nenhum caso atender a condição',
        en: 'Default text to send to user when no cases satisfy your condition',
    },
    'End conversation is used to close a conversation': {
        pt: 'É utilizada para encerrar um atendimento',
        en: 'End attendance is used to close a attendance',
    },
    'When used, ends the ongoing conversation': {
        pt: 'Quando usado, finaliza a conversa em andamento',
        en: 'When used, ends the ongoing attendance',
    },
    'Show rating after close attendance': {
        pt: 'Exibe uma avaliação de satisfação ao encerrar',
        en: 'Show rating after close attendance',
    },
    'Text displayed on service satisfaction survey card': {
        pt: 'Texto exibido na avaliação de satisfação',
        en: 'Text displayed on service satisfaction survey card',
    },
    'Rating title': {
        pt: 'Título da avaliação',
        en: 'Rating title',
    },
    'Rating description': {
        pt: 'Descrição da avaliação',
        en: 'Rating description',
    },
    'Disable workspace - If this button is enabled, the workspace cannot be used by any user linked to it.': {
        pt: 'Desabilitar workspace - Caso este botão esteja ativado, o workspace não poderá ser usado por nenhum usuário vinculado a este.',
        en: 'Disable workspace - If this button is enabled, the workspace cannot be used by any user linked to it.',
    },
    'Rating - If this button is enabled, the functionality will be available.': {
        pt: 'Avaliação - Caso este botão esteja ativado, a funcionalidade estará disponível.',
        en: 'Rating - If this button is enabled, the functionality will be available.',
    },
    'Api Channel - If this button is activated, the Api channel functionality will be available.': {
        pt: 'Canal Api - Caso este botão esteja ativado, a funcionalidade de canal Api estará disponível.',
        en: 'Api Channel - If this button is activated, the Api channel functionality will be available.',
    },
    'Enable Integrations Module - If this button is enabled, the integrations module will be visible to the customer.':
        {
            pt: 'Habilitar módulo de integrações - Se este botão estiver ativado, o módulo de integrações ficará visível para o cliente.',
            en: 'Enable Integrations Module - If this button is enabled, the integrations module will be visible to the customer.',
        },
    'Broadcast list - If this button is activated, the broadcast list module will be available.': {
        pt: 'Lista de transmissão - Se este botão estiver ativado, o módulo de Lista de transmissão estará disponível.',
        en: 'Broadcast list - If this button is activated, the broadcast list module will be available.',
    },
    'Help Center - If this button is enabled, the help center will be visible for this workspace.': {
        pt: 'Central de ajuda - Caso este botão esteja ativado, a central de ajuda será visível para este workspace.',
        en: 'Help Center - If this button is enabled, the help center will be visible for this workspace.',
    },
    'Enable billing module - If this button is enabled, the billing module will be visible to the customer.': {
        pt: 'Habilitar módulo de cobranças - Se este botão estiver ativado, o módulo de cobranças será visível para o cliente.',
        en: 'Enable billing module - If this button is enabled, the billing module will be visible to the customer.',
    },
    'Confirmation description': {
        pt: 'Descrição de confirmação após avaliação',
        en: 'Confirmation description',
    },
    'Confirmation title': {
        pt: 'Título de confirmação após avaliação',
        en: 'Confirmation title',
    },
    'Thank you text displayed after review': {
        pt: 'Texto de agradecimento após conclusão da avaliação',
        en: 'Thank you text displayed after review',
    },
    'Select scope': {
        pt: 'Selecionar escopo',
        en: 'Select scope',
    },
    Scope: {
        pt: 'Escopo',
        en: 'Scope',
    },
    'Define conversation scope': {
        pt: 'Define o escopo do atendimento',
        en: 'Define attendance scope',
    },
    'Message to the user': {
        pt: 'Mensagem para o usuário',
        en: 'Message to the user',
    },
    'Send random text to user (Optional)': {
        pt: 'Envia uma mensagem aleatória para o usuário (opcional)',
        en: 'Send random text to user (Optional)',
    },
    'Take a print of the screen of the website where webchat is on': {
        pt: 'Tira um print da tela em que o webchat está',
        en: 'Take a print of the screen of the website where webchat is on',
    },
    Action: {
        pt: 'Ação',
        en: 'Action',
    },
    remove: {
        pt: 'remover',
        en: 'remove',
    },
    'remove all': {
        pt: 'remover todos',
        en: 'remove all',
    },
    add: {
        pt: 'adicionar',
        en: 'add',
    },
    'Goback responses are used to return to interaction that called it': {
        pt: 'As respostas do Goback são usadas para retornar à interação que á chamou ',
        en: 'Goback responses are used to return to interaction that called it',
    },
    'When go back response is executed, the subsequent responses will be ignored': {
        pt: 'Quando a resposta de retorno é executada, as respostas subsequentes serão ignoradas',
        en: 'When go back response is executed, the subsequent responses will be ignored',
    },
    'Select one of the options': {
        pt: 'Selecione uma das opções',
        en: 'Select one of the options',
    },
    'just this interaction': {
        pt: 'Apenas esta interação',
        en: 'just this interaction',
    },
    'Navigate to the selected interaction': {
        pt: 'Navegar até a interação selecionada',
        en: 'Navigate to the selected interaction',
    },
    'Hide inactive': {
        pt: 'Ocultar inativos',
        en: 'Hide inactive',
    },
    'This interaction and your children': {
        pt: 'Esta interação e seus filhos',
        en: 'This interaction and your children',
    },
    'Copy interaction to another bot': {
        pt: 'Copiar interação para outro bot',
        en: 'Copy interaction to another bot',
    },
    'Interaction successfully copied!': {
        pt: 'Interação copiada com sucesso!',
        en: 'Interaction successfully copied!',
    },
    'There was an error copying this interaction, please try again!': {
        pt: 'Ocorreu algum erro ao copiar esta interação, por favor tente novamente!',
        en: 'There was an error copying this interaction, please try again!',
    },
    'Choose a bot': {
        pt: 'Escolha um bot',
        en: 'Choose a bot',
    },
    'Choose an trigger': {
        pt: 'Escolha uma trigger',
        en: 'Choose an trigger',
    },
    'Choose an interaction': {
        pt: 'Selecione uma interação',
        en: 'Choose an interaction',
    },
    'If you choose other bot the conversation will be redirected to interaction of this bot!': {
        pt: 'Se você escolher outro bot, o atendimento será redirecionada para a interação desse bot!',
        en: 'If you choose other bot the attendance will be redirected to interaction of this bot!',
    },
    set: {
        pt: 'setar',
        en: 'set',
    },
    value: {
        pt: 'valor',
        en: 'value',
    },
    Method: {
        pt: 'Método',
        en: 'Method',
    },
    'Header name': {
        pt: 'Nome do header',
        en: 'Header name',
    },
    'Header value': {
        pt: 'Valor do header',
        en: 'Header value',
    },
    'Enter url': {
        pt: 'Digite a url',
        en: 'Enter url',
    },
    'Type of attribute': {
        pt: 'Tipo do atributo',
        en: 'Type of attribute',
    },
    'Save http response to attribute': {
        pt: 'Salvar resposta no atributo',
        en: 'Save http response to attribute',
    },
    Number: {
        pt: 'Número',
        en: 'Number',
    },
    Date: {
        pt: 'Data',
        en: 'Date',
    },
    'Start date': {
        pt: 'Data de inicio',
        en: 'Start date',
    },
    'End date': {
        pt: 'Data final',
        en: 'End date',
    },
    Any: {
        pt: 'Qualquer',
        en: 'Any',
    },
    Custom: {
        pt: 'Customizado',
        en: 'Custom',
    },
    System: {
        pt: 'Sistema',
        en: 'System',
    },
    Genre: {
        pt: 'Gênero',
        en: 'Genre',
    },
    'Bot attributes': {
        pt: 'Atributos do bot',
        en: 'Bot attributes',
    },
    'Default attributes': {
        pt: 'Atributos padrão',
        en: 'Default attributes',
    },
    'Enable channel': {
        pt: 'Ativar canal',
        en: 'Enable channel',
    },
    'Enable animation on avatar image': {
        pt: 'Habilitar animação na imagem do avatar',
        en: 'Enable animation on avatar image',
    },
    'enable or disable webchat': {
        pt: 'ativa ou desativa o webchat',
        en: 'enable or disable webchat',
    },
    'After open chat, a chat initiation confirmation will appear': {
        pt: 'Após o bate-papo aberto, uma confirmação de iniciação será exibida',
        en: 'After open chat, a chat initiation confirmation will appear',
    },
    'Start with confirm': {
        pt: 'Inicia com confirmação',
        en: 'Start with confirm',
    },
    'Keep alive': {
        pt: 'Sempre vivo',
        en: 'Keep alive',
    },
    'restore conversation even after chat is closed': {
        pt: 'restaura o atendimento mesmo após o encerramento do bate-papo',
        en: 'restore attendance even after chat is closed',
    },
    'Display a speech bubble in webchat': {
        pt: 'Exibe um balão de fala no webchat',
        en: 'Display a speech bubble in webchat',
    },
    'Show Tooltip': {
        pt: 'Exibir tooltip',
        en: 'Show Tooltip',
    },
    'Select value': {
        pt: 'Selecione um valor',
        en: 'Select value',
    },
    'Required field': {
        pt: 'Campo obrigatório',
        en: 'Required field',
    },
    'Service username': {
        pt: 'Usuário do serviço',
        en: 'Service username',
    },
    'Service password': {
        pt: 'Senha do serviço',
        en: 'Service password',
    },
    'Birth date': {
        pt: 'Data de nascimento',
        en: 'Birth date',
    },
    'Procedure name': {
        pt: 'Nome do procedimento',
        en: 'Procedure name',
    },
    'Medical covenant': {
        pt: 'Convênio médico',
        en: 'Medical insurance',
    },
    Telephone: {
        pt: 'Telefone',
        en: 'Telephone',
    },
    'Service endpoint': {
        pt: 'Endpoint do serviço',
        en: 'Service endpoint',
    },
    Specialty: {
        pt: 'Especialidade',
        en: 'Specialty',
    },
    Resource: {
        pt: 'Recurso',
        en: 'Resource',
    },
    'Fill in with equivalent attributes': {
        pt: 'Preencha com os atributos equivalentes',
        en: 'Fill in with equivalent attributes',
    },
    'Fill in with equivalent attributes for rescheduling': {
        pt: 'Preencha com os atributos equivalentes para reagendamento',
        en: 'Fill in with equivalent attributes for rescheduling',
    },
    'According to the answer, redirect to': {
        pt: 'De acordo com a resposta, redirecionar para',
        en: 'According to the answer, redirect to',
    },
    'Empty result': {
        pt: 'Resultado vazio',
        en: 'Empty result',
    },
    'Blocked patient cpfs': {
        pt: 'CPFs de pacientes bloqueados',
        en: 'Blocked patient cpfs',
    },
    'If the received result is empty': {
        pt: 'Se o resultado recebido for vazio',
        en: 'If the received result is empty',
    },
    'Select a interaction': {
        pt: 'Selecione uma interação',
        en: 'Select a interaction',
    },
    'In case of error redirect to': {
        pt: 'Em caso de erro redirecionar para',
        en: 'In case of error redirect to',
    },
    Error: {
        pt: 'Erro',
        en: 'Error',
    },
    Correlate: {
        pt: 'Correlacionar',
        en: 'Correlate',
    },
    Synchronize: {
        pt: 'Sincronizar',
        en: 'Synchronize',
    },
    'Synchronize request sended': {
        pt: 'Requisição de sincronização enviada',
        en: 'Synchronize request sended',
    },
    Transboard: {
        pt: 'Transbordar',
        en: 'Transboard',
    },
    'Transfer to an transboard interaction': {
        pt: 'Transferir para uma interação com transbordo',
        en: 'Transfer to an transboard interaction',
    },
    Carousel: {
        pt: 'Carrossel',
        en: 'Carousel',
    },
    Question: {
        pt: 'Pergunta',
        en: 'Question',
    },
    'Quick Reply': {
        pt: 'Resposta rápida',
        en: 'Quick Reply',
    },
    Goto: {
        pt: 'Ir para',
        en: 'Goto',
    },
    'Go back': {
        pt: 'Voltar para',
        en: 'Go back',
    },
    'End conversation': {
        pt: 'Finalizar atendimento',
        en: 'End attendance',
    },
    'Suspend attendance': {
        pt: 'Suspender atendimento',
        en: 'Suspend attendance',
    },
    'Service suspended': {
        pt: 'Atendimento suspenso',
        en: 'Service suspended',
    },
    Per: {
        pt: 'Por',
        en: 'Per',
    },
    'Choose date and time': {
        pt: 'Escolher data e hora',
        en: 'Choose date and time',
    },
    'Guide status': {
        pt: 'Status da guia',
        en: 'Guide status',
    },
    'Medical guide': {
        pt: 'Guia médico',
        en: 'Medical guide',
    },
    'Beneficiary Guide': {
        pt: 'Guia Beneficiário',
        en: 'Beneficiary Guide',
    },
    'Medical appointment': {
        pt: 'Consulta médica',
        en: 'Medical appointment',
    },
    'Recognizer scope': {
        pt: 'Escopo de reconhecimento',
        en: 'Recognizer scope',
    },
    'Phone number attribute': {
        pt: 'Atributo do número de telefone',
        en: 'Phone number attribute',
    },
    'Purchase requisition attribute': {
        pt: 'Atributo da requisição de compra',
        en: 'Purchase requisition attribute',
    },
    'Switch text': {
        pt: 'Mudar texto',
        en: 'Switch text',
    },
    'Search supplier': {
        pt: 'Busca fornecedor',
        en: 'Search supplier',
    },
    'Search id': {
        pt: 'Buscar id',
        en: 'Search id',
    },
    'Driver started': {
        pt: 'Driver iniciado',
        en: 'Driver started',
    },
    'Wait a moment': {
        pt: 'Aguarde alguns instantes',
        en: 'Wait a moment',
    },
    'Driver started. Request a Qr code as soon as you want': {
        pt: 'Driver iniciado. Solicite um Qr code assim que quiser',
        en: 'Driver started. Request a Qr code as soon as you want',
    },
    'Your whatsApp driver is starting': {
        pt: 'Seu driver do whatsApp está sendo iniciado',
        en: 'Your whatsApp driver is starting',
    },
    'This operation may take more than 1 minute': {
        pt: 'Esta operação pode levar mais de 1 minuto',
        en: 'This operation may take more than 1 minute',
    },
    'The operation timed out. Try again later': {
        pt: 'A operação atingiu tempo limite. Tente novamente mais tarde',
        en: 'The operation timed out. Try again later',
    },
    'Request qr code': {
        pt: 'Solicitar qr code',
        en: 'Request qr code',
    },
    Battery: {
        pt: 'Bateria',
        en: 'Battery',
    },
    'User found': {
        pt: 'Usuário encontrado',
        en: 'User found',
    },
    'No entities found': {
        pt: 'Nenhuma entidade encontrada',
        en: 'No entities found',
    },
    'Error publishing to entities': {
        pt: 'Erro ao publicar às entidades',
        en: 'Error publishing to entities',
    },
    'Last entities sync': {
        pt: 'Última sincronização de entidades',
        en: 'Last entities sync',
    },
    'Error clearing integration cache': {
        pt: 'Erro ao limpar o cache de integração',
        en: 'Error clearing integration cache',
    },
    'Successfully cleared integration cache': {
        pt: 'Cache de integração limpo com sucesso',
        en: 'Successfully cleared integration cache',
    },
    'Failed to update integration rules.': {
        pt: 'Falha ao atualizar as regras de integração.',
        en: 'Failed to update integration rules.',
    },
    'Error on load entities': {
        pt: 'Erro ao carregar entidades',
        en: 'Error on load entities',
    },
    'Error on update entity': {
        pt: 'Erro ao atualizar entidade',
        en: 'Error on update entity',
    },
    'Error on create entity': {
        pt: 'Erro ao criar entidade',
        en: 'Error on create entity',
    },
    'Error on create attribute': {
        pt: 'Erro ao criar atributo',
        en: 'Error on create attribute',
    },
    'Create entities': {
        pt: 'Criar entidades',
        en: 'Create entities',
    },
    'Entity creation': {
        pt: 'Criação de entidades',
        en: 'Entity creation',
    },
    'Paste the name of the entities to be created, or enter manually.': {
        pt: 'Cole o nome das entidades a serem criadas, ou insira manualmente.',
        en: 'Paste the name of the entities to be created, or enter manually.',
    },
    correlation: {
        pt: 'Correlação',
        en: 'Correlation',
    },
    'Import exams for confirmation': {
        pt: 'Importar exames para confirmação',
        en: 'Import exams for confirmation',
    },
    'Use the agreement suggestion step': {
        pt: 'Utilizar etapa de sugestão de convênio',
        en: 'Use the agreement suggestion step',
    },
    'Entity saved': {
        pt: 'Entidade salva',
        en: 'Entity saved',
    },
    'Entities in the flow': {
        pt: 'Entidades no fluxo',
        en: 'Entities in the flow',
    },
    'Disabled in ERP': {
        pt: 'Desativada no ERP',
        en: 'Disabled in ERP',
    },
    'Changes made must be published to be updated in the online schedule': {
        pt: 'As alterações feitas devem ser publicadas para serem atualizadas no agendamento online',
        en: 'Changes made must be published to be updated in the online schedule',
    },
    'Unpublished change': {
        pt: 'Alteração não publicada',
        en: 'Unpublished change',
    },
    'Publish flow': {
        pt: 'Publicar fluxo',
        en: 'Publish flow',
    },
    'Publish flow production': {
        pt: 'Publicar fluxo para produção',
        en: 'Publish flow production',
    },
    'Open online booking': {
        pt: 'Abrir agendamento online',
        en: 'Open online booking',
    },
    Messaging: {
        pt: 'Mensagens',
        en: 'Messaging',
    },
    'Click here to edit': {
        pt: 'Clique aqui para editar',
        en: 'Click here to edit',
    },
    'Go to conversation': {
        pt: 'Ir para conversa',
        en: 'Go to conversation',
    },
    'Show only with calls': {
        pt: 'Mostrar apenas com atendimentos',
        en: 'Show only with calls',
    },
    'show selected': {
        pt: 'Mostrar selecionados',
        en: 'Show selected',
    },
    'invert selection': {
        pt: 'Inverter seleção',
        en: 'Invert selection',
    },
    'Clear Selection': {
        pt: 'Limpar seleção',
        en: 'Clear Selection',
    },
    'Select a category': {
        pt: 'Selecione uma categoria',
        en: 'Select a category',
    },
    'View calls from this agent': {
        pt: 'Ver atendimentos deste agente',
        en: 'View calls from this agent',
    },
    Awaiting: {
        en: 'Awaiting',
        pt: 'Aguardando',
    },

    'Finished on the day': {
        pt: 'Finalizados no dia',
        en: 'Finished on the day',
    },
    'Revert changes': {
        pt: 'Reverter alterações',
        en: 'Revert changes',
    },
    'Publish changes': {
        pt: 'Publicar alterações',
        en: 'Publish changes',
    },
    'Flow inactive.': {
        pt: 'Fluxo inativo.',
        en: 'Flow inactive.',
    },
    'Clone flow': {
        pt: 'Clonar fluxo',
        en: 'Clone flow',
    },
    Permissions: {
        pt: 'Permissões',
        en: 'Permissions',
    },
    Permission: {
        pt: 'Permissão',
        en: 'Permission',
    },
    'No permissions enabled': {
        pt: 'Nenhuma permissão habilitada',
        en: 'No permissions enabled',
    },
    'registered users, being': {
        pt: 'usuários cadastrados, sendo',
        en: 'registered users, being',
    },
    inactive: {
        pt: 'inativo',
        en: 'inactive',
    },
    inactives: {
        pt: 'inativos',
        en: 'inactives',
    },
    Inactives: {
        pt: 'Inativos',
        en: 'Inactives',
    },
    'Inactivate flow': {
        pt: 'Inativar fluxo',
        en: 'Inactivate flow',
    },
    'Active flow': {
        pt: 'Ativar fluxo',
        en: 'Active flow',
    },
    'Are you sure you want to delete the flow?': {
        pt: 'Tem certeza que deseja excluir o fluxo?',
        en: 'Are you sure you want to delete the flow?',
    },
    'Find users in workspace': {
        pt: 'Encontrar usuários no workspace',
        en: 'Find users in workspace',
    },
    'There are no users to display here': {
        pt: 'Não há nenhum usuário para exibir aqui',
        en: 'There are no users to display here',
    },
    'Attach file': {
        pt: 'Anexar arquivo',
        en: 'Attach file',
    },
    Preview: {
        pt: 'Visualizar',
        en: 'Preview',
    },
    Visible: {
        pt: 'Visível',
        en: 'Visible',
    },
    Extract: {
        pt: 'Extrair',
        en: 'Extract',
    },
    'Extracting...': {
        pt: 'Extraindo...',
        en: 'Extracting...',
    },
    'Error on extract': {
        pt: 'Erro ao extrair',
        en: 'Error on extract',
    },
    'UNREAD MESSAGES': {
        pt: 'MENSAGENS NÃO LIDAS',
        en: 'UNREAD MESSAGES',
    },
    'Assume conversation': {
        pt: 'Assumir atendimento',
        en: 'Assume attendance',
    },
    'Error when assuming the service': {
        pt: 'Erro ao assumir o atendimento',
        en: 'Error when assuming the service',
    },
    'You are not part of the team which this service was assigned. Contact your supervisor': {
        pt: 'Você não faz parte do time ao qual este atendimento foi atribuído. Entre em contato com seu supervisor',
        en: 'You are not part of the team which this service was assigned. Contact your supervisor',
    },
    Assume: {
        pt: 'Assumir',
        en: 'Assume',
    },
    Send: {
        pt: 'Enviar',
        en: 'Send',
    },
    'Select a conversation': {
        pt: 'Selecione um atendimento',
        en: 'Select a attendance',
    },
    'Select a contact': {
        pt: 'Selecione um contato',
        en: 'Select a contact',
    },
    'joined the conversation': {
        pt: 'entrou no atendimento',
        en: 'joined the attendance',
    },
    'assigned conversation to team': {
        en: 'assigned conversation to team',
        pt: 'atribuiu a conversa para o time',
    },
    Status: {
        en: 'Status',
        pt: 'Status',
    },
    'Conversation total': {
        en: 'Conversation total',
        pt: 'Total de conversas',
    },
    'Messages total': {
        en: 'Messages total',
        pt: 'Total de mensagens',
    },
    'Your browser do not support audio recording': {
        en: 'Your browser do not support audio recording',
        pt: 'Seu navegador não suporta gravação de áudio',
    },
    'Auto assign - If this button is activated, the auto assign module will be visible to the customer.': {
        en: 'Auto assign - If this button is activated, the auto assign module will be visible to the customer.',
        pt: 'Auto atribuir - Caso este botão esteja ativado, o módulo de auto atribuir estará visível para o cliente.',
    },
    'Sub permissions on users - If this button is activated, the option to register sub permissions on the user will be available.':
        {
            en: 'Sub permissions on users - If this button is activated, the option to register sub permissions on the user will be available.',
            pt: 'Sub permissão nos usuários - Caso este botão esteja ativado, a opção para cadastrar sub permissões no usuário estará disponível.',
        },
    'Block permission to edit agent profile': {
        en: 'Block permission to edit agent profile',
        pt: 'Bloquear permissão para editar perfil do agente',
    },
    'You cannot edit profile information.': {
        en: 'You cannot edit profile information.',
        pt: 'Você não pode editar as informações do perfil.',
    },
    'Average agent first response time': {
        en: 'Average agent first response time',
        pt: 'Tempo médio da primeira resposta do agente',
    },
    'Average waiting time for service during active hours': {
        en: 'Average waiting time for service during active hours',
        pt: 'Tempo médio de espera para atendimento em horário ativo',
    },
    'Average wait time in active hours': {
        en: 'Average wait time in active hours',
        pt: 'Tempo médio de espera em horário ativo',
    },
    'Median time for user reply': {
        en: 'Median time for user reply',
        pt: 'Tempo médio para resposta do usuário',
    },
    'Median time for agent reply': {
        en: 'Median time for agent reply',
        pt: 'Tempo médio para resposta do agente',
    },
    'Average waiting time for service in active hours of teams': {
        en: 'Average waiting time for service in active hours of teams',
        pt: 'Tempo médio de espera para atendimento em horário ativo dos times',
    },
    'This app need your permission to audio record': {
        en: 'This app need your permission to audio record. Enable it in the browser settings',
        pt: 'Este app precisa de sua permissão para gravar áudio. Habilite nas configurações do navegador',
    },
    'App name': {
        en: 'App name',
        pt: 'Nome do app',
    },
    'returned to the conversation': {
        pt: 'voltou para o atendimento',
        en: 'returned to the attendance',
    },
    'left the conversation': {
        pt: 'saiu do atendimento',
        en: 'left the attendance',
    },
    'assumed the conversation': {
        pt: 'assumiu o atendimento',
        en: 'assumed the attendance',
    },
    'ended the conversation': {
        pt: 'finalizou o atendimento',
        en: 'ended the attendance',
    },
    'Create Contact': {
        pt: 'Criar contato',
        en: 'Create Contact',
    },
    'Search contacts': {
        pt: 'Encontrar contatos',
        en: 'Search contacts',
    },
    'No contacts around here': {
        pt: 'Nenhum contato por aqui',
        en: 'No contacts around here',
    },
    'Create contact': {
        pt: 'Criar contato',
        en: 'Create contact',
    },
    'Conversation details': {
        pt: 'Detalhes do atendimento',
        en: 'Attendance details',
    },
    'Contact details': {
        pt: 'Detalhes do contato',
        en: 'Contact details',
    },
    'Contact history': {
        pt: 'Histórico do contato',
        en: 'Contact history',
    },
    'Invalid contact': {
        pt: 'Contato inválido',
        en: 'Invalid contact',
    },
    Warning: {
        pt: 'Aviso',
        en: 'Warning',
    },
    'There is already an open service for this contact on this channel': {
        pt: 'Já existe um atendimento aberto para este contato neste canal',
        en: 'There is already an open service for this contact on this channel',
    },
    'Upload successful.': {
        pt: 'Carregamento bem sucedido.',
        en: 'Upload successful.',
    },
    'Click to upload.': {
        pt: 'Clique para carregar.',
        en: 'Click to upload.',
    },
    'File uploaded successfully.': {
        pt: 'Arquivo enviado com sucesso.',
        en: 'File uploaded successfully.',
    },
    'File upload failed.': {
        pt: 'Falha no upload do arquivo.',
        en: 'File upload failed.',
    },
    Success: {
        pt: 'Sucesso',
        en: 'Success',
    },
    Ignored: {
        pt: 'Ignorado',
        en: 'Ignored',
    },
    ignored: {
        pt: 'Ignorado',
        en: 'Ignored',
    },
    Solved: {
        pt: 'Resolvido',
        en: 'Solved',
    },
    solved: {
        pt: 'Resolvido',
        en: 'Solved',
    },
    'Conversation created': {
        pt: 'Atendimento criado',
        en: 'Attendance created',
    },
    Details: {
        pt: 'Detalhes',
        en: 'Details',
    },
    'Select a channel': {
        pt: 'Selecione um canal',
        en: 'Select a channel',
    },
    'You need a channel like': {
        pt: 'Você precisa de um canal do tipo',
        en: 'You need a channel like',
    },
    'to start a conversation': {
        pt: 'para iniciar um atendimento',
        en: 'to start a attendance',
    },
    'Cell phone': {
        pt: 'Telefone',
        en: 'Cell phone',
    },
    'Identity number': {
        pt: 'Número da identidade',
        en: 'Identity number',
    },
    'No contact conversation history': {
        pt: 'Nenhum histórico de atendimento do contato',
        en: 'No contact attendance history',
    },
    participated: {
        pt: 'participou',
        en: 'participated',
    },
    'Conversations that': {
        pt: 'Atendimentos que',
        en: 'Attendances that',
    },
    Edit: {
        pt: 'Editar',
        en: 'Edit',
    },
    'Start conversation': {
        pt: 'Iniciar atendimento',
        en: 'Start attendance',
    },
    'Phone number required to start a conversation on this channel': {
        pt: 'Necessário número de telefone para iniciar um atendimento neste canal',
        en: 'Phone number required to start a attendance on this channel',
    },
    'New conversation': {
        pt: 'Novo Atendimento',
        en: 'New attendance',
    },
    'No contact information': {
        pt: 'Nenhuma informação do contato',
        en: 'No contact information',
    },
    'Participated in': {
        pt: 'Participou de',
        en: 'Participated in',
    },
    'conversation(s)': {
        pt: 'Atendimentos(s)',
        en: 'Attendance(s)',
    },
    Rating: {
        pt: 'Avaliação',
        en: 'Rating',
    },
    Ratings: {
        pt: 'Avaliações',
        en: 'Ratings',
    },
    stars: {
        pt: 'estrelas',
        en: 'stars',
    },
    star: {
        pt: 'estrela',
        en: 'star',
    },
    'Average between': {
        pt: 'Média entre',
        en: 'Average between',
    },
    'Number of ratings:': {
        pt: 'Número de avaliações:',
        en: 'Number of ratings:',
    },
    'With feedback': {
        pt: 'Com feedback',
        en: 'With feedback',
    },
    'No feedback': {
        pt: 'Sem feedback',
        en: 'No feedback',
    },
    None: {
        pt: 'Nenhuma',
        en: 'None',
    },
    'We identified agents in the table who are no longer on this team.': {
        pt: 'Identificamos agentes na tabela que não estão mais neste time.',
        en: 'We identified agents in the table who are no longer on this team.',
    },
    'Only show agents who are active on this team.': {
        pt: 'Mostrar apenas agentes que estão ativos neste time.',
        en: 'Only show agents who are active on this team.',
    },
    'Started in': {
        pt: 'Iniciado em',
        en: 'Started in',
    },
    Files: {
        pt: 'Arquivos',
        en: 'Files',
    },
    'Members in conversation': {
        pt: 'Membros no atendimento',
        en: 'Members in attendance',
    },
    'Reopen conversation': {
        pt: 'Reabrir atendimento',
        en: 'Reopen attendance',
    },
    'Conversation id': {
        pt: 'Identificação do atendimento',
        en: 'Attendance id',
    },
    conversation: {
        pt: 'atendimento',
        en: 'attendance',
    },
    'Mark as unread': {
        pt: 'Marcar como não lida',
        en: 'Mark as unread',
    },
    'Clear filters': {
        pt: 'Limpar filtros',
        en: 'Clear filters',
    },
    'Clear filter': {
        pt: 'Limpar filtro',
        en: 'Clear filter',
    },
    'applied filters': {
        pt: 'filtros aplicados',
        en: 'applied filters',
    },
    'applied filter': {
        pt: 'filtro aplicado',
        en: 'applied filter',
    },
    Reset: {
        pt: 'Limpar',
        en: 'Reset',
    },
    open: {
        pt: 'aberta',
        en: 'open',
    },
    closed: {
        pt: 'finalizada',
        en: 'closed',
    },
    'Filter conversations': {
        pt: 'Filtrar atendimentos',
        en: 'Filter attendances',
    },
    'Assumed by': {
        pt: 'Assumida por',
        en: 'Assumed by',
    },
    'Closed by': {
        pt: 'Finalizada por',
        en: 'Closed by',
    },
    unfinished: {
        pt: 'Não finalizadas',
        en: 'unfinished',
    },
    Apply: {
        pt: 'Aplicar',
        en: 'Apply',
    },
    Me: {
        pt: 'Mim',
        en: 'Me',
    },
    'An error has occurred. Try again': {
        pt: 'Ocorreu um erro. Tente novamente',
        en: 'An error has occurred. Try again',
    },
    'New contact': {
        pt: 'Novo contato',
        en: 'New contact',
    },
    'All users': {
        pt: 'Todos os usuários',
        en: 'All users',
    },
    Unreads: {
        pt: 'Não lidas',
        en: 'Unreads',
    },
    All: {
        pt: 'Todas',
        en: 'All',
    },
    'All of': {
        pt: 'Todos',
        en: 'All of',
    },
    Admin: {
        pt: 'Administrador',
        en: 'Administrator',
    },
    Agent: {
        pt: 'Agente',
        en: 'Agent',
    },
    Agents: {
        pt: 'Agentes',
        en: 'Agents',
    },
    Inactive: {
        pt: 'Inativo',
        en: 'Inactive',
    },
    'Conversation members': {
        pt: 'Membros da conversa',
        en: 'Conversation members',
    },
    'Search conversations': {
        pt: 'Encontrar atendimentos e contatos',
        en: 'Search attendances and contacts',
    },
    'Search message': {
        pt: 'Buscar mensagem',
        en: 'Search message',
    },
    "We didn't find any results, please try again": {
        pt: 'Não encontramos nenhum resultado, tente novamente',
        en: "We didn't find any results, please try again",
    },
    Contacts: {
        pt: 'Contatos',
        en: 'Contacts',
    },
    Conversations: {
        pt: 'Atendimentos',
        en: 'Attendances',
    },
    'Leave conversation': {
        pt: 'Sair do atendimento',
        en: 'Leave attendance',
    },
    'Conversation Ended': {
        pt: 'Atendimento finalizado',
        en: 'Attendance Ended',
    },
    'Conversation cannot be terminated': {
        pt: 'Atendimento não pode ser finalizado',
        en: 'Attendance cannot be terminated',
    },
    'You cannot leave this conversation': {
        pt: 'Você não pode sair deste atendimento',
        en: 'You cannot leave this attendance',
    },
    'You left the conversation': {
        pt: 'Você saiu do atendimento',
        en: 'You left the attendance',
    },
    'is no longer part of the conversation': {
        pt: 'não faz mais parte do atendimento',
        en: 'is no longer part of the attendance',
    },
    'is a active member in conversation': {
        pt: 'é um membro ativo no atendimento',
        en: 'is a active member in conversation',
    },

    'Edit tag': {
        pt: 'Editar etiqueta',
        en: 'Edit tag',
    },
    Color: {
        pt: 'Cor',
        en: 'Color',
    },
    Tags: {
        pt: 'Etiquetas',
        en: 'Tags',
    },
    Tag: {
        pt: 'Etiqueta',
        en: 'Tag',
    },
    'Create tag': {
        pt: 'Criar etiqueta',
        en: 'Create tag',
    },
    'Has integration': {
        pt: 'Contém integração',
        en: 'Has integration',
    },
    'Integration active message': {
        pt: 'Integração mensagem ativa',
        en: 'Integration active message',
    },
    'Active message': {
        pt: 'Mensagem ativa',
        en: 'Active message',
    },
    'Are you sure you want to delete the integration active message?': {
        pt: 'Tem certeza de que deseja excluir a integração de mensagem ativa?',
        en: 'Are you sure you want to delete the integration active message?',
    },
    'Active message successfully created': {
        pt: 'Mensagem ativa criado com sucesso',
        en: 'Active message successfully created',
    },
    'No active message integration found': {
        pt: 'Nenhuma integração de mensagem ativa encontrada',
        en: 'No active message integration found',
    },
    confirmSchedule: {
        pt: 'Confirmação de Agendamento',
        en: 'confirmSchedule',
    },
    avaliableScheduleInList: {
        pt: 'Horário Disponível na Lista',
        en: 'avaliableScheduleInList',
    },
    confirmScheduleWithLinkButtonTitle: {
        pt: 'Botão Confirmação de Agendamentos com Link',
        en: 'confirmScheduleWithLinkButtonTitle',
    },
    Identifier: {
        pt: 'Identificador',
        en: 'Identifier',
    },
    'Active message status': {
        pt: 'Status Mensagem ativa',
        en: 'Active message status',
    },
    'Are you sure you want to delete the status?': {
        pt: 'Tem certeza que deseja excluir o status?',
        en: 'Are you sure you want to delete the status?',
    },
    'Are you sure you want to delete the custom flow? It might be in use in the tree or broadcast list.': {
        pt: 'Tem certeza de que deseja excluir o fluxo personalizado? Pode estar em uso na árvore ou na lista de transmissão.',
        en: 'Are you sure you want to delete the custom flow? It might be in use in the tree or broadcast list.',
    },
    'The custom flow is being used in some integration.': {
        pt: 'O fluxo personalizado esta sendo utilizado em alguma integração.',
        en: 'The custom flow is being used in some integration.',
    },
    'Integration updated successfully': {
        pt: 'Integração atualizada com sucesso',
        en: 'Integration updated successfully',
    },
    'View screenshot': {
        pt: 'Ver screenshot',
        en: 'View screenshot',
    },
    'Duplicated tag': {
        pt: 'Tag duplicada',
        en: 'Duplicated tag',
    },
    'Something went wrong': {
        pt: 'Algo deu errado',
        en: 'Something went wrong',
    },
    'Reassume conversation': {
        pt: 'Reassumir atendimento',
        en: 'Reassume attendance',
    },
    'A contact already exists with the phone number you entered': {
        pt: 'Já existe um contato com o número de telefone que você digitou',
        en: 'A contact already exists with the phone number you entered',
    },
    'The data previously entered will be lost and the conversation linked to this contact': {
        pt: 'Os dados digitados anteriormente serão perdidos e o atendimento vinculado a este contato',
        en: 'The data previously entered will be lost and the attendance linked to this contact',
    },
    Associate: {
        pt: 'Associar',
        en: 'Associate',
    },
    'Back and edit': {
        pt: 'Voltar e editar',
        en: 'Back and edit',
    },
    'This conversation did not generate a contact': {
        pt: 'Este atendimento não gerou um contato',
        en: 'This attendance did not generate a contact',
    },
    'Contact info': {
        pt: 'Informações do contato',
        en: 'Contact info',
    },
    Participants: {
        pt: 'Participantes',
        en: 'Participants',
    },
    'is an active member of the conversation': {
        pt: 'é um membro ativo no atendimento',
        en: 'is an active member of the attendance',
    },
    Example: {
        pt: 'Exemplo',
        en: 'Example',
    },
    'Enter a email': {
        pt: 'Insira um email',
        en: 'Enter a email',
    },
    'Enter a phone number': {
        pt: 'Insira um telefone',
        en: 'Enter a phone number',
    },
    'Enter a name': {
        pt: 'Insira um nome',
        en: 'Enter a name',
    },
    'Contact created': {
        pt: 'O contato foi criado',
        en: 'Contact create',
    },
    'Yes, update': {
        pt: 'Sim, atualizar',
        en: 'Yes, update',
    },
    'A contact already exists with the data entered. Do you want to update with the information already entered?': {
        pt: 'Já existe um contato criado com os dados informados. Deseja atualizar com as informações já digitadas?',
        en: 'A contact already exists with the data entered. Do you want to update with the information already entered?',
    },
    'To create a conversation, you need to select the channel it will be linked to': {
        pt: 'Para criar um atendimento, você precisa selecionar o canal que ela ficará vinculada',
        en: 'To create a attendance, you need to select the channel it will be linked to',
    },
    Contact: {
        pt: 'Contato',
        en: 'Contact',
    },
    'Comercial account': {
        pt: 'Conta comercial',
        en: 'Comercial account',
    },
    in: {
        pt: 'em',
        en: 'in',
    },
    'Create conversation': {
        pt: 'Iniciar atendimento',
        en: 'Start attendance',
    },
    Loading: {
        pt: 'Carregando',
        en: 'Loading',
    },
    'Loading more': {
        pt: 'Carregando mais',
        en: 'Loading more',
    },
    'Enter your message here': {
        pt: 'Insira sua mensagem aqui',
        en: 'Enter your message here',
    },
    Close: {
        pt: 'Finalizar',
        en: 'Close',
    },
    'Show suspended conversations': {
        pt: 'Mostrar conversas suspensas',
        en: 'Show suspended conversations',
    },
    'suspended conversation until': {
        pt: 'suspendeu a conversa até',
        en: 'suspended conversation until',
    },
    Suspend: {
        pt: 'Suspender',
        en: 'Suspend',
    },
    'Suspend until': {
        pt: 'Suspender até',
        en: 'Suspend until',
    },
    suspended: {
        pt: 'suspensa',
        en: 'suspended',
    },
    Leave: {
        pt: 'Sair',
        en: 'Leave',
    },
    'More options': {
        pt: 'Mais opções',
        en: 'More options',
    },
    'Attribute with name': {
        pt: 'Atributo com nome',
        en: 'Attribute with name',
    },
    'Save token in attribute': {
        pt: 'Salvar token no atributo',
        en: 'Save token in attribute',
    },
    'sex attribute of the person': {
        pt: 'Atributo com sexo da pessoa',
        en: 'sex attribute of the person',
    },
    'No account': {
        pt: 'Sem conta',
        en: 'No account',
    },
    'Friendly name to be displayed in a tag': {
        pt: 'Nome amigável para ser exibido em uma tag',
        en: 'Friendly name to be displayed in a tag',
    },
    'Confirm attendance exit?': {
        pt: 'Confirma saída do atendimento?',
        en: 'Confirm attendance exit?',
    },
    'Confirm attendance end?': {
        pt: 'Confirma encerramento do atendimento?',
        en: 'Confirm attendance end?',
    },
    'Updated workspace': {
        pt: 'Workspace atualizado',
        en: 'Updated workspace',
    },
    'Error creating user. Try again.': {
        pt: 'Erro ao criar o usuário. Tente novamente',
        en: 'Error creating user. Try again',
    },
    'Select a agent': {
        en: 'Select a agent',
        pt: 'Selecione um agente',
    },
    'Assessment date': {
        en: 'Assessment date',
        pt: 'Data de avaliação',
    },
    'End date of service': {
        en: 'End date of service',
        pt: 'Data finalização do atendimento',
    },
    'Select tags': {
        en: 'Select tags',
        pt: 'Selecione as etiquetas',
    },
    'Filter tags': {
        en: 'Filter tags',
        pt: 'Filtrar etiquetas',
    },
    'Filter channels': {
        en: 'Filter channels',
        pt: 'Filtrar canais',
    },
    User: {
        pt: 'Usuário',
        en: 'User',
    },
    'Show messages': {
        pt: 'Mostrar mensagens',
        en: 'Show messages',
    },
    'Show rating after close conversation': {
        pt: 'Mandar avaliação após finalizar atendimento',
        en: 'Show rating after close conversation',
    },
    'Is closed by user': {
        pt: 'É finalizado pelo usuário',
        en: 'Is closed by user',
    },
    'Error updating user data. Try again': {
        pt: 'Erro ao atualizar os dados do usuário. Tente novamente',
        en: 'Error updating user data. Try again',
    },
    'If the account was created, go to the interaction': {
        pt: 'Se a conta foi criada, ir até a interação',
        en: 'If the account was created, go to the interaction',
    },
    'if the account does not exist, go to the interaction': {
        pt: 'se a conta não existir, ir até a interação',
        en: 'if the account does not exist, go to the interaction',
    },
    'if the account exists, go to the interaction': {
        pt: 'se a conta existir, ir até a interação',
        en: 'if the account exists, go to the interaction',
    },
    'if an error occurs, go to the interaction': {
        pt: 'se ocorrer um erro, ir até a interação',
        en: 'if an error occurs, go to the interaction',
    },
    'Account does not exist': {
        pt: 'Conta não existe',
        en: 'Account does not exist',
    },
    'Account exists': {
        pt: 'Conta existe',
        en: 'Account exists',
    },
    'Phone battery low': {
        pt: 'Telefone com bateria fraca',
        en: 'Phone battery low',
    },
    'Charge your phone to keep using WhatsApp.': {
        pt: 'Carregue seu telefone para continuar usando o WhatsApp.',
        en: 'Charge your phone to keep using WhatsApp.',
    },
    'Phone without connection.': {
        pt: 'Telefone sem conexão.',
        en: 'Phone without connection.',
    },
    'Make sure your phone has an active Internet connection.': {
        pt: 'Verifique se o telefone possui uma conexão ativa com a Internet.',
        en: 'Make sure your phone has an active Internet connection.',
    },
    Unconnected: {
        pt: 'Não conectado',
        en: 'Unconnected',
    },
    Unauthenticated: {
        pt: 'Não autenticado',
        en: 'Unauthenticated',
    },
    "You're not online": {
        pt: 'Você não está online',
        en: "You're not online",
    },
    "This computer's internet connection appears to be offline.": {
        pt: 'A conexão com a internet deste computador parece estar offline.',
        en: "This computer's internet connection appears to be offline.",
    },
    'Criteria used to find the correct faq value by a value in the bot context': {
        pt: 'Criteria é usado para encontrar o valor correto de faq em um valor no contexto do bot',
        en: 'Criteria used to find the correct faq value by a value in the bot context',
    },
    'Faq value saved': {
        pt: 'Faq value salvo',
        en: 'Faq value saved',
    },
    'Rating settings': {
        pt: 'Configurações da avaliação',
        en: 'Rating settings',
    },
    'Fill in a message that motivates the patient to rate the service': {
        pt: 'Preencha com uma mensagem que motive o paciente a dar uma nota para o atendimento',
        en: 'Fill in a message that motivates the patient to rate the service',
    },
    'How was your service with us?': {
        pt: 'Como foi seu atendimento conosco?',
        en: 'How was your service with us?',
    },
    'Fill in with a message that motivates the patient to give feedback on the service': {
        pt: 'Preencha com uma mensagem que motive o paciente a dar um feedback do atendimento',
        en: 'Fill in with a message that motivates the patient to give feedback on the service',
    },
    'Leave a message for us:': {
        pt: 'Deixe uma mensagem para nós:',
        en: 'Leave a message for us:',
    },
    'Message that will be sent along with the evaluation link for the patient at the end of the service': {
        pt: 'Mensagem que será enviada junto com o link de avaliação para o paciente no fim do atendimento',
        en: 'Message that will be sent along with the evaluation link for the patient at the end of the service',
    },
    'Rate your service on the link below': {
        pt: 'Avalie o seu atendimento no link abaixo',
        en: 'Rate your service on the link below',
    },
    'Link message': {
        pt: 'Mensagem do link',
        en: 'Link message',
    },
    'Send evaluation for all calls from any team': {
        pt: 'Enviar avaliação para todos os atendimentos de qualquer time',
        en: 'Send evaluation for all calls from any team',
    },
    'You can send evaluation at the end of the service for all teams or select the teams that will be sent': {
        pt: 'Pode enviar avaliação no final do atendimento para todos os times ou selecione os times que serão enviados',
        en: 'You can send evaluation at the end of the service for all teams or select the teams that will be sent',
    },
    'Send rating for all calls from any channel': {
        pt: 'Enviar avaliação para todos os atendimentos de qualquer canal',
        en: 'Send rating for all calls from any channel',
    },
    'You can send evaluation at the end of the service for all channels or select the channels that will be sent': {
        pt: 'Pode enviar avaliação no final do atendimento para todos os canais ou selecione os canais que serão enviados',
        en: 'You can send evaluation at the end of the service for all channels or select the channels that will be sent',
    },
    'Select the faq to use': {
        pt: 'Selecione o faq value',
        en: 'Select the faq to use',
    },
    'Select one': {
        pt: 'Selecione um',
        en: 'Select one',
    },
    'Bundled CSV download': {
        pt: 'Download CSV agrupado',
        en: 'Bundled CSV download',
    },
    'Download all received files (except audio)': {
        pt: 'Baixar todos arquivos recebidos (exceto aúdio)',
        en: 'Download all received files (except audio)',
    },
    'Sorry we get an error, verify fields and try again': {
        pt: 'Desculpe, ocorreu um erro, verifique os campos e tente novamente',
        en: 'Sorry we get an error, verify fields and try again',
    },
    'Sorry we get an error, verify interaction and try again! ': {
        pt: 'Desculpe, recebemos um erro, verifique a interação e tente novamente! ',
        en: 'Sorry we get an error, verify interaction and try again! ',
    },
    'Item deleted successfully': {
        pt: 'Item deletado com sucesso',
        en: 'Item deleted successfully',
    },
    'Are you sure you want to delete faq': {
        pt: 'Tem certeza de que deseja excluir o faq value',
        en: 'Are you sure you want to delete faq',
    },
    'List Faq empty': {
        pt: 'Lista vazia',
        en: 'List Faq empty',
    },
    'Delete selected': {
        pt: 'Excluir selecionados',
        en: 'Delete selected',
    },
    Required: {
        pt: 'Obrigatório',
        en: 'Required',
    },
    Roles: {
        pt: 'Permissões',
        en: 'Roles',
    },
    Segment: {
        pt: 'Segmento',
        en: 'Segment',
    },
    Category: {
        pt: 'Categoria',
        en: 'Category',
    },
    Categories: {
        pt: 'Categorias',
        en: 'Categories',
    },
    'Successfully edited': {
        pt: 'Editado com sucesso',
        en: 'Successfully edited',
    },
    'Saved successfully': {
        pt: 'Salvo com sucesso',
        en: 'Saved successfully',
    },
    'Action performed successfully': {
        pt: 'Ação realizada com sucesso',
        en: 'Action performed successfully',
    },
    'Clear integration cache': {
        pt: 'Limpar cache da integração',
        en: 'Clear integration cache',
    },
    Sample: {
        pt: 'Exemplo',
        en: 'Sample',
    },
    Description: {
        pt: 'Descrição',
        en: 'Description',
    },
    'No faq registered': {
        pt: 'Nenhuma pergunta frequente cadastrada',
        en: 'No faq registered',
    },
    'No category selected': {
        pt: 'Nenhuma categoria selecionada',
        en: 'No faq selected',
    },
    'Save all and Continue': {
        pt: 'Salvar tudo e continuar',
        en: 'Save all and Continue',
    },
    'Save all': {
        pt: 'Salvar tudo',
        en: 'Save all',
    },
    'Nothing to show here': {
        pt: 'Entrada',
        en: 'Nothing to show here',
    },
    'No category registered': {
        pt: 'Nenhuma categoria cadastrada',
        en: 'No category registered',
    },
    'Add response': {
        pt: 'Adicionar resposta',
        en: 'Add response',
    },
    Responses: {
        pt: 'Respostas',
        en: 'Responses',
    },
    'Type a number to contact': {
        pt: 'Digite o número do contato',
        en: 'Type a number to contact',
    },
    'Avaliable on whatsapp': {
        pt: 'Disponível para whatsapp',
        en: 'Avaliable on whatsapp',
    },
    'Whatsapp number': {
        pt: 'Número Whatsapp',
        en: 'Whatsapp number',
    },
    'Click here': {
        pt: 'Clique aqui',
        en: 'Click here',
    },
    'to start a conversation.': {
        pt: 'para iniciar um atendimento.',
        en: 'to start a attendance.',
    },
    'Not avaliable on whatsapp': {
        pt: 'Não disponível para whatsapp',
        en: 'Not avaliable on whatsapp',
    },
    'This number is not avaliable to use on whatsapp, try other number.': {
        pt: 'Este número não é disponível para usar whatsapp, tente outro número.',
        en: 'This number is not avaliable to use on whatsapp, try other number.',
    },
    'Could not validate': {
        pt: 'Não foi possível validar',
        en: 'Could not validate',
    },
    'Could not validate this number, try later.': {
        pt: 'Não foi possível validar este número, tente mais tarde.',
        en: 'Could not validate this number, try later.',
    },
    'Have an open conversation': {
        pt: 'Possui atendimento aberto',
        en: 'Has open service',
    },
    'This number have an opened conversation.': {
        pt: 'Este número possui um atendimento em aberto',
        en: 'This number have an opened attendance.',
    },
    'to open a conversation.': {
        pt: 'para abrir um atendimento.',
        en: 'to open a attendance.',
    },
    'You are not authenticated.': {
        pt: 'Você não está autenticado.',
        en: 'You are not authenticated.',
    },
    'You are authenticated in other device.': {
        pt: 'Você está conectado em outro dispositivo.',
        en: 'You are authenticated in other device.',
    },
    'to scan QR Code.': {
        pt: 'para ler o QR Code.',
        en: 'to scan QR Code.',
    },
    'try again': {
        pt: 'tentar novamente.',
        en: 'try again',
    },
    'to use this device.': {
        pt: 'para usar esse dispositivo.',
        en: 'to use this device.',
    },
    'Successfully deleted': {
        pt: 'Excluído com sucesso',
        en: 'Successfully deleted',
    },
    'It is not possible to remove an attribute in use': {
        pt: 'Não é possivel remover um atributo em uso',
        en: 'It is not possible to remove an attribute in use',
    },
    'You have exceeded the maximum integrated messages': {
        pt: 'Você excedeu o máximo de mensagens integradas',
        en: 'You have exceeded the maximum integrated messages',
    },
    'Invalid channel': {
        pt: 'Canal inválido',
        en: 'Invalid channel',
    },
    'If the channel is outside office hours, the bot will continue from an interaction.': {
        pt: 'Se o canal estiver fora do horário de atendimento, o bot continuará a partir de uma interação.',
        en: 'If the channel is outside office hours, the bot will continue from an interaction.',
    },
    'Transfer destination channel Id': {
        pt: 'Id do Canal destino da transferência',
        en: 'Transfer destination channel Id',
    },
    'Transfer destination channel': {
        pt: 'Canal destino da transferência',
        en: 'Transfer destination channel',
    },
    'Channel Id': {
        pt: 'Id do canal',
        en: 'Channel Id',
    },
    'Create channel': {
        pt: 'Criar canal',
        en: 'Create channel',
    },
    'Select a color': {
        pt: 'Selecione uma cor',
        en: 'Select a color',
    },
    'Invalid color': {
        pt: 'Cor inválida',
        en: 'Invalid color',
    },
    'Show QRCode': {
        pt: 'Mostrar QRCode',
        en: 'Show QRCode',
    },
    and: {
        pt: 'e',
        en: 'and',
    },
    Configurations: {
        pt: 'Configurações',
        en: 'Configurations',
    },
    Attributes: {
        pt: 'Atributos',
        en: 'Attributes',
    },
    'Recently accessed': {
        pt: 'Acessado recentemente',
        en: 'Recently accessed',
    },
    'Channel updated successfully': {
        pt: 'Canal atualizado com sucesso',
        en: 'Channel updated successfully',
    },
    General: {
        pt: 'Geral',
        en: 'General',
    },
    Attendance: {
        pt: 'Atendimento',
        en: 'Attendance',
    },
    Attendances: {
        pt: 'Atendimentos',
        en: 'Attendances',
    },
    'General settings': {
        pt: 'Configurações gerais',
        en: 'General settings',
    },
    Settings: {
        pt: 'Configurações',
        en: 'Settings',
    },
    'SSO Settings': {
        pt: 'Configurações SSO',
        en: 'SSO Settings',
    },
    'SSO Name': {
        pt: 'Nome SSO',
        en: 'SSO Name',
    },
    'SSO ID': {
        pt: 'ID SSO',
        en: 'SSO ID',
    },
    plan: {
        pt: 'Plano',
        en: 'Plan',
    },
    planPrice: {
        pt: 'Preço do plano',
        en: 'Plan price',
    },
    planMessageLimit: {
        pt: 'Limite de mensagens do plano',
        en: 'Plan message limit',
    },
    planExceededMessagePrice: {
        pt: 'Preço por mensagem excedida',
        en: 'Exceeded message price',
    },
    planHsmMessageLimit: {
        pt: 'Limite de mensagens Hsm do plano',
        en: 'Exceeded message Hsm',
    },
    planHsmExceedMessagePrice: {
        pt: 'Preço por mensagem Hsm excedida',
        en: 'Hsm exceeded message price',
    },
    planUserLimit: {
        pt: 'Limite de usuários do plano',
        en: 'Plan user limit',
    },
    planUserExceedPrice: {
        pt: 'Preço por usuário excedido',
        en: 'User exceeded price',
    },
    planConversationLimit: {
        pt: 'Limite de atendimentos do plano',
        en: 'Plan conversation limit',
    },
    planConversationExceedPrice: {
        pt: 'Preço por atendimento excedido',
        en: 'Plan conversation exceeded price',
    },
    startAt: {
        pt: 'Data de inicio',
        en: 'Start at',
    },
    accountId: {
        pt: 'Conta',
        en: 'Account',
    },
    dueDate: {
        pt: 'Data de vencimento',
        en: 'Due date',
    },
    'Workspace billing specification': {
        pt: 'Especificações de cobrança',
        en: 'Workspace billing specification',
    },
    'Channel name': {
        pt: 'Nome do canal',
        en: 'Channel name',
    },
    'Expiration of attendance': {
        pt: 'Expiração do atendimento',
        en: 'Expiration of attendance',
    },
    Actions: {
        pt: 'Ações',
        en: 'Actions',
    },
    Definitions: {
        pt: 'Definições',
        en: 'Definitions',
    },
    'Chat title': {
        pt: 'Título do chat',
        en: 'Chat title',
    },
    'Chat color': {
        pt: 'Cor do chat',
        en: 'Chat color',
    },
    'Avatar link': {
        pt: 'Link do avatar',
        en: 'Avatar link',
    },
    'Enable tooltip above the chat start button': {
        pt: 'Habilitar tooltip acima do botão de inicio de chat',
        en: 'Enable tooltip above the chat start button',
    },
    'Text that will be displayed in the tooltip': {
        pt: 'Texto que será exibido no tooltip',
        en: 'Text that will be displayed in the tooltip',
    },
    Behavior: {
        pt: 'Comportamento',
        en: 'Behavior',
    },
    'Start chat as soon as the page loads': {
        pt: 'Iniciar o chat assim que a página for carregada',
        en: 'Start chat as soon as the page loads',
    },
    'Show action for the user to confirm whether to initiate a chat': {
        pt: 'Exibir ação para o usuário confirmar se deseja iniciar um chat',
        en: 'Show action for the user to confirm whether to initiate a chat',
    },
    "Load the user's last conversation if it can be restored": {
        pt: 'Carregar a última conversa do usuário caso seja possível restaurá-la',
        en: "Load the user's last conversation if it can be restored",
    },
    'Create now': {
        pt: 'Criar agora',
        en: 'Create now',
    },
    'No channels registered': {
        pt: 'Nenhum canal cadastrado',
        en: 'No channels registered',
    },
    'Code to place the bot on your website': {
        pt: 'Código para colocar o bot em seu site',
        en: 'Code to place the bot on your website',
    },
    "Copy the snippet and paste it into your site's <head> tag": {
        pt: 'Copie o snippet e cole-o dentro da tag <head> de seu site',
        en: "Copy the snippet and paste it into your site's <head> tag",
    },
    Appearance: {
        pt: 'Aparência',
        en: 'Appearance',
    },
    Code: {
        pt: 'Código',
        en: 'Code',
    },
    Informations: {
        pt: 'Informações',
        en: 'Informations',
    },
    pages: {
        pt: 'páginas',
        en: 'pages',
    },
    Events: {
        pt: 'Eventos',
        en: 'Events',
    },
    'These are the events available for interaction with the whatsApp session': {
        pt: 'Estes são os eventos disponíveis para interação com a sessão do whatsApp',
        en: 'These are the events available for interaction with the whatsApp session',
    },
    'There is no session started, so there is no data on it': {
        pt: 'Não existe nenhum sessão iniciada, logo não existem dados sobre a mesma',
        en: 'There is no session started, so there is no data on it',
    },
    'Last message': {
        pt: 'Última mensagem',
        en: 'Last message',
    },
    Closed: {
        pt: 'Fechado',
        en: 'Closed',
    },
    Sex: {
        pt: 'Sexo',
        en: 'Sex',
    },
    'Select a interval': {
        pt: 'Selecione um intervalo',
        en: 'Select a interval',
    },
    'Select a team': {
        pt: 'Selecione um time',
        en: 'Select a team',
    },
    'Select a user': {
        pt: 'Selecione um usuário',
        en: 'Select a user',
    },
    Saturday: {
        pt: 'Sábado',
        en: 'Saturday',
    },
    'Remove period': {
        pt: 'Remover período',
        en: 'Remove period',
    },
    LoggedIn: {
        pt: 'Logado',
        en: 'Logged In',
    },
    notLoggedIn: {
        pt: 'Não logado',
        en: 'Not Logged In',
    },
    'Init session': {
        pt: 'Iniciar sessão',
        en: 'Init session',
    },
    Refresh: {
        pt: 'Atualizar',
        en: 'Refresh',
    },
    'No attributes created': {
        pt: 'Nenhum atributo criado',
        en: 'No attributes created',
    },
    'This attribute is being used in the following interactions': {
        pt: 'Este atributo está sendo utilizado nas seguintes interações',
        en: 'This attribute is being used in the following interactions',
    },
    'Click to view': {
        pt: 'Clique para ver',
        en: 'Click to view',
    },
    'Expiring attendance': {
        pt: 'Expirar atendimento',
        en: 'Expiring attendance',
    },
    RulesPrice: {
        pt: 'Preço do procedimento / Consulta',
        en: 'Procedure price / Consultation',
    },
    RulesLimit: {
        pt: 'Limite de itens a serem exibidos',
        en: 'Time limit to be displayed',
    },
    RulesAddress: {
        pt: 'Endereço da unidade',
        en: 'Unit address',
    },
    RulesSkipIfOneItem: {
        pt: 'Pular seleção se tiver apenas um item',
        en: 'Skip entity selection if only one item',
    },
    Sequential: {
        pt: 'Sequencial',
        en: 'Sequential',
    },
    RulesSortMethod: {
        pt: 'Forma de apresentação de horários',
        en: 'How to present timetables',
    },
    RulesCanNotCancel: {
        pt: 'Não pode cancelar',
        en: 'cannot cancel',
    },
    RulesCanNotConfirm: {
        pt: 'Não pode confirmar',
        en: 'cannot confirm',
    },
    RulesCanNotView: {
        pt: 'Não pode visualizar',
        en: 'cannot view',
    },
    RulesCanNotReschedule: {
        pt: 'Não pode reagendar',
        en: 'cannot reschedule',
    },
    RulesGuidanceBeforeScheduled: {
        pt: 'Orientação antes do agendamento',
        en: 'Guidance before scheduled',
    },
    RulesGuidanceAfterScheduled: {
        pt: 'Orientação após o agendamento',
        en: 'Guidance after scheduled',
    },
    RulesSkipSelection: {
        pt: 'Pular seleção da entidade atual',
        en: 'Skip current entity selection',
    },
    RulesIfEmptyDataGoto: {
        pt: 'Ir para interação, caso não retorne nenhum resultado',
        en: 'Go to interaction if no result is returned',
    },
    firstEachPeriodDay: {
        pt: 'Primeiro dia de cada período',
        en: 'First day of each period',
    },
    firstEachHourDay: {
        pt: 'Primeiro dia de cada hora',
        en: 'First day of each hour',
    },
    firstEachAnyPeriodDay: {
        pt: 'Primeiro dia de qualquer período',
        en: 'First day of any period',
    },
    combineDatePeriodByOrganization: {
        pt: 'Alternado entre unidades por período',
        en: 'Alternate between units per period',
    },
    default: {
        pt: 'Padrão',
        en: 'Default',
    },
    RulesnoAvailableDatesMessage: {
        pt: 'Mensagem que será enviada ao paciente quando não tiver horários disponíveis',
        en: 'Message that will be sent to the patient when there are no available times',
    },
    RulesSkipIfNoItem: {
        pt: 'Pular seleção se não tiver itens',
        en: 'Skip entity selection if there are no items',
    },
    rulesConfirmationConfirmationGoto: {
        pt: 'Ir para interação, caso confirme',
        en: 'Go to interaction, if confirmed',
    },
    rulesConfirmationConfirmationMessage: {
        pt: 'Mensagem caso confirme',
        en: 'Message if confirmed',
    },
    rulesConfirmationCancelGoto: {
        pt: 'Ir para interação, caso não confirme',
        en: 'Go to interaction, if not confirm',
    },
    rulesConfirmationCancelMessage: {
        pt: 'Mensagem caso não confirme',
        en: 'Message if not confirmed',
    },
    rulesConfirmationRescheduleGoto: {
        pt: 'Ir para interação, caso reagendar',
        en: 'Go to interaction if reschedule',
    },
    rulesConfirmatioSendGuidanceOnConfirmSchedule: {
        pt: 'Enviar orientação ao confirmar agendamento',
        en: 'Send guidance when confirming appointment',
    },
    rulesConfirmationNotActionGoto: {
        pt: 'Ir para interação, caso não possua nenhuma ação',
        en: 'Go to interaction, if you do not have any action',
    },
    rulesConfirmationCancelWithGoto: {
        pt: 'Cancelar e ir para interação',
        en: 'Cancel with go to interaction',
    },
    rulesConfirmationCancelReasonList: {
        pt: 'Selecione os motivos de cancelamento',
        en: 'Select cancel reasons',
    },
    Rescheduling: {
        pt: 'Reagendamento',
        en: 'rescheduling',
    },
    Confirmation: {
        pt: 'Confirmação',
        en: 'Confirmation',
    },
    'Automatically reschedule': {
        pt: 'Reagendamento automático',
        en: 'Automatically reschedule',
    },
    'Go to interaction if any error occurs': {
        pt: 'Ir para interação, caso ocorra algum erro',
        en: 'Go to interaction if any error occurs',
    },
    'Ask if you want to reschedule': {
        pt: 'Perguntar se quer reagendar',
        en: 'Ask if you want to reschedule',
    },
    'Cancel previous appointment after rescheduling': {
        pt: 'Cancelar agendamento anterior após reagendar',
        en: 'Cancel previous appointment after rescheduling',
    },
    Installation: {
        pt: 'Instalação',
        en: 'Installation',
    },
    'Channel deleted successfully': {
        pt: 'Canal deletado com sucesso',
        en: 'Channel deleted successfully',
    },
    'Are you sure you want to delete the channel? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o canal? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the channel? The action cannot be undone',
    },
    'Are you sure you want to delete the payment? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o pagamento? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the payment? The action cannot be undone',
    },
    'The faq corresponds to requests for sending messages using frequently asked questions': {
        pt: 'O faq corresponde aos pedidos de envio de mensagens usando as perguntas frequentes',
        en: 'The faq corresponds to requests for sending messages using frequently asked questions',
    },
    'Criteria will match with selected faq to send message from faq-value to user': {
        pt: 'Os critérios corresponderão ao faq selecionado para enviar mensagem do valor faq para o usuário',
        en: 'Criteria will match with selected faq to send message from faq-value to user',
    },
    Criteria: {
        pt: 'Critério',
        en: 'Criteria',
    },
    'The value of faq value that matches with selected faq and criteria will be saved on this attribute': {
        pt: 'O valor da pergunta frequente correspondente ao faq e aos critérios selecionados serão salvos neste atributo',
        en: 'The value of faq-value that matches with selected faq and criteria will be saved on this attribute',
    },
    'End attendance': {
        pt: 'Finalizar atendimento',
        en: 'End attendance',
    },
    'Remove actions and style from the chat initiator': {
        pt: 'Remover ações e estilo do iniciador do chat',
        en: 'Remove actions and style from the chat initiator',
    },
    'Link a bot to your channel': {
        pt: 'Vincule um bot ao seu canal',
        en: 'Link a bot to your channel',
    },
    'Create a new bot': {
        pt: 'Criar novo bot',
        en: 'Create a new bot',
    },
    'Created bot': {
        pt: 'Bot criado',
        en: 'Created bot',
    },
    'Bot successfully created': {
        pt: 'Bot criado com sucesso',
        en: 'Bot successfully created',
    },
    'Error creating bot': {
        pt: 'Erro ao criar bot',
        en: 'Error creating bot',
    },
    'There was an error creating the bot, please try again': {
        pt: 'Ocorreu um erro ao criar o bot, tente novamente',
        en: 'There was an error creating the bot, please try again',
    },
    'Linked Bot': {
        pt: 'Bot vinculado',
        en: 'Linked Bot',
    },
    'Integration code': {
        pt: 'Código de integração',
        en: 'Integration code',
    },
    Insurance: {
        pt: 'Convênio',
        en: 'Insurance',
    },
    'Insurance number': {
        pt: 'Número do convênio',
        en: 'Insurance number',
    },
    'Information on how to use variables in the message': {
        pt: 'Informações de como usar variáveis na mensagem',
        en: 'Information on how to use variables in the message',
    },
    'Standard variables:': {
        pt: 'Variáveis padrão:',
        en: 'Standard variables:',
    },
    'It will be filled with the name of the agent that will use the template.': {
        pt: 'Será preenchido com o nome do agente que utilizará o template.',
        en: 'It will be filled with the name of the agent that will use the template.',
    },
    'It will be filled with the ID of the conversation in which the template was used. Ex: #22549': {
        pt: 'Será preenchido com o ID da conversa em que foi utilizado o template. Ex: #22549',
        en: 'It will be filled with the ID of the conversation in which the template was used. Ex: #22549',
    },
    'It will be filled with the name of the patient in the conversation that the template is used.': {
        pt: 'Será preenchido com o nome do paciente na conversa que for utilizado o template.',
        en: 'It will be filled with the name of the patient in the conversation that the template is used.',
    },
    "It will be filled in with the patient's phone number in the conversation using the template.": {
        pt: 'Será preenchido com o telefone do paciente na conversa que for utilizado o template.',
        en: "It will be filled in with the patient's phone number in the conversation using the template.",
    },
    '*These variables do not need to be edited when using the template, they will be automatically filled by the system!':
        {
            pt: '*Estás variáveis não precisam ser editadas na hora da utilização do template elas serão automaticamente preenchidas pelo sistema!',
            en: '*These variables do not need to be edited when using the template, they will be automatically filled by the system!',
        },
    'Editable variables:': {
        pt: 'Variáveis editáveis:',
        en: 'Editable variables:',
    },
    'use editable variables when you need to implement custom texts in a template.': {
        pt: 'utilize de variáveis editáveis quando necessitar implementar textos personalizados em um template.',
        en: 'use editable variables when you need to implement custom texts in a template.',
    },
    "*Don't forget to edit these variables.": {
        pt: '*Não se esqueça de editar estas variáveis.',
        en: "*Don't forget to edit these variables.",
    },
    'Editable variable terms:': {
        pt: 'Termos das variáveis editáveis:',
        en: 'Editable variable terms:',
    },
    'Select if this variable is mandatory to submit the template.': {
        pt: 'Selecione caso está variável seja de preenchimento obrigatório para o envio do template.',
        en: 'Select if this variable is mandatory to submit the template.',
    },
    'Fill in with the name you put in the custom variable in the message.': {
        pt: 'Preencha com o nome que você colocou na variável personalizada da mensagem.',
        en: 'Fill in with the name you put in the custom variable in the message.',
    },
    'Fill in the field that will be shown to fill in the template before submitting. Ex: patient name': {
        pt: 'Preencha com o campo que será mostrado para preencher no template antes de enviar. Ex: Nome do paciente',
        en: 'Fill in the field that will be shown to fill in the template before submitting. Ex: patient name',
    },
    'Select which type this variable will have to be filled.': {
        pt: 'Selecione qual será o tipo que está variável terá que ser preenchida.',
        en: 'Select which type this variable will have to be filled.',
    },
    Mandatory: {
        pt: 'Obrigatório',
        en: 'Mandatory',
    },
    'Will only match this attribute if is equal to entity': {
        pt: 'Só corresponderá a este atributo se for igual à entidade',
        en: 'Will only match this attribute if is equal to entity',
    },
    'User says will be saved in attribute': {
        pt: 'O usuário diz que será salvo no atributo',
        en: 'User says will be saved in attribute',
    },
    'Value:': {
        pt: 'Valor:',
        en: 'Value:',
    },
    'Type:': {
        pt: 'Tipo:',
        en: 'Type:',
    },
    'Insurance plan': {
        pt: 'Plano do convênio',
        en: 'Insurance plan',
    },
    Procedure: {
        pt: 'Procedimento',
        en: 'Procedure',
    },
    'Procedure type': {
        pt: 'Tipo de procedimento',
        en: 'Procedure type',
    },
    'Organization unit': {
        pt: 'Unidade de organização',
        en: 'Organization unit',
    },
    'Check account': {
        pt: 'Checar conta',
        en: 'Check account',
    },
    'Parameters to search for available times': {
        pt: 'Parâmetros para buscar os horários disponíveis',
        en: 'Parameters to search for available times',
    },
    'Days from today': {
        pt: 'Dias a partir de hoje',
        en: 'Days from today',
    },
    'Appointment not confirmed goto': {
        pt: 'Goto de agendamento não confirmado',
        en: 'Appointment not confirmed goto',
    },
    'Until day': {
        pt: 'Até o dia',
        en: 'Until day',
    },
    'Number of days from the initial date informed': {
        pt: 'Quantidade de dias a partir da data inicial informada',
        en: 'Number of days from the initial date informed',
    },
    'Result limit': {
        pt: 'Limite de resultados',
        en: 'Result limit',
    },
    Randomize: {
        pt: 'Randomizar',
        en: 'Randomize',
    },
    'Randomize schedules': {
        pt: 'Randomizar horários',
        en: 'Randomize schedules',
    },
    'Number of days to search': {
        pt: 'Quantidade de dias a serem buscados',
        en: 'Number of days to search',
    },
    'Number of days that will pass from today to start searching for timetables': {
        pt: 'Quantidade de dias que serão passados a partir de hoje para iniciar a busca de horários',
        en: 'Number of days that will pass from today to start searching for timetables',
    },
    'Select the steps to be performed': {
        pt: 'Selecione as etapas que devem ser executadas',
        en: 'Select the steps to be performed',
    },
    Steps: {
        pt: 'Etapas',
        en: 'Steps',
    },
    Gender: {
        pt: 'Gênero',
        en: 'Gender',
    },
    'Account created': {
        pt: 'Conta criada',
        en: 'Account created',
    },
    Phone: {
        pt: 'Telefone',
        en: 'Phone',
    },
    Accounts: {
        pt: 'Contas',
        en: 'Accounts',
    },
    'Account not exists': {
        pt: 'Conta não existe',
        en: 'Account not exists',
    },
    'Existing account': {
        pt: 'Conta existente',
        en: 'Existing account',
    },
    'Are you sure you want to delete the bot? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o bot? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the bot? The action cannot be undone',
    },
    'Are you sure you want to delete the user? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o usuário? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the user? The action cannot be undone',
    },
    Download: {
        pt: 'Baixar',
        en: 'Download',
    },
    Downloading: {
        pt: 'Baixando',
        en: 'Downloading',
    },
    'Share service': {
        pt: 'Compartilhar atendimento',
        en: 'Share service',
    },
    Online: {
        pt: 'Online',
        en: 'Online',
    },
    Add: {
        pt: 'Adicionar',
        en: 'Add',
    },
    Offline: {
        pt: 'Desconectado',
        en: 'Offline',
    },
    Disconnect: {
        pt: 'Desconectar',
        en: 'Disconnect',
    },
    'Left the conversation': {
        pt: 'Saiu do atendimento',
        en: 'Left the attendance',
    },
    Configuration: {
        pt: 'Configuração',
        en: 'Configuration',
    },
    'Api key': {
        pt: 'Chave da api',
        en: 'Api key',
    },
    'Phone number': {
        pt: 'Número do celular',
        en: 'Phone number',
    },
    Closure: {
        pt: 'Encerramento',
        en: 'Closure',
    },
    'Standard conversation end message': {
        pt: 'Mensagem padrão de encerramento de conversa',
        en: 'Standard conversation end message',
    },
    'Phone number is not valid': {
        pt: 'Número inválido',
        en: 'Phone number is not valid',
    },
    'Contact list': {
        pt: 'Lista de contatos',
        en: 'Contact list',
    },
    'Not allowing the patient to confirm their appointment through the bot': {
        pt: 'Não permitir que o paciente confirme seu agendamento através do bot',
        en: 'Not allowing the patient to confirm their appointment through the bot',
    },
    'Disallow active confirmation sending for this flow': {
        pt: 'Não permitir o envio de confirmação ativa para este fluxo',
        en: 'Disallow active confirmation sending for this flow',
    },
    'Disallow automatic rescheduling of this entity in the bot flow': {
        pt: 'Não permitir o reagendamento automático desta entidade no fluxo do bot',
        en: 'Disallow automatic rescheduling of this entity in the bot flow',
    },
    'Disallow automatic cancellation of this entity within the bot flow': {
        pt: 'Não permita o cancelamento automático desta entidade dentro do fluxo do bot',
        en: 'Disallow automatic cancellation of this entity within the bot flow',
    },
    'Search times by days': {
        pt: 'Buscar horários a partir de dias.',
        en: 'Search times by days',
    },
    'There is no contact created.': {
        pt: 'Não existe nenhum contato criado.',
        en: 'There is no contact created.',
    },
    'No contacts found': {
        pt: 'Nenhum contato encontrado',
        en: 'No contacts found',
    },
    'Choose a workspace': {
        pt: 'Escolha um workspace',
        en: 'Choose a workspace',
    },
    'Choose a channel': {
        pt: 'Escolha um canal',
        en: 'Choose a channel',
    },
    'Import contacts': {
        pt: 'Importar contatos',
        en: 'Import contacts',
    },
    'I agree to the whatsApp': {
        pt: 'Eu concordo com os',
        en: 'I agree to the whatsApp',
    },
    'Terms of Service': {
        pt: 'Termos de serviço',
        en: 'Terms of Service',
    },
    'Privacy policy': {
        pt: 'Política de privacidade',
        en: 'Privacy policy',
    },
    'How to register your privacy policy': {
        pt: 'Como cadastrar sua política de privacidade',
        en: 'How to register your privacy policy',
    },
    'Privacy policy text': {
        pt: 'Texto da política de privacidade',
        en: 'Privacy policy text',
    },
    'Accept button text': {
        pt: 'Texto do botão aceitar',
        en: 'Accept button text',
    },
    'Decline button text': {
        pt: 'Texto do botão recusar',
        en: 'Decline button text',
    },
    'Shipping channels': {
        pt: 'Canais para envio',
        en: 'Shipping channels',
    },
    'Confirm save': {
        pt: 'Confirmar atualização',
        en: 'Confirm save',
    },
    Accept: {
        pt: 'Aceitar',
        en: 'Accept',
    },
    Refuse: {
        pt: 'Recusar',
        en: 'Refuse',
    },
    Register: {
        pt: 'Cadastro',
        en: 'Register',
    },
    'Privacy policy created successfully': {
        pt: 'Política de privacidade criada com sucesso',
        en: 'Privacy policy created successfully',
    },
    'Privacy policy updated successfully': {
        pt: 'Política de privacidade atualizada com sucesso',
        en: 'Privacy policy updated successfully',
    },
    'Select channels': {
        pt: 'Selecionar canais',
        en: 'Select channels',
    },
    'Changing the text of the privacy policy will result in a new request for acceptance by all again!': {
        pt: 'A alteração do texto da política de privacidade implicará em uma nova solicitação do aceite para todos novamente!',
        en: 'Changing the text of the privacy policy will result in a new request for acceptance by all again!',
    },
    'Confirm new acceptance request': {
        pt: 'Confirmar nova solicitação de aceite',
        en: 'Confirm new acceptance request',
    },
    'Are you sure you want to request acceptance of the privacy policy, this action will cause the privacy policy to be accepted again!':
        {
            pt: 'Tem certeza de que deseja solicitar aceite na política de privacidade, essa ação fará com que a política de privacidade tenha que ser aceita novamente!',
            en: 'Are you sure you want to request acceptance of the privacy policy, this action will cause the privacy policy to be accepted again!',
        },
    'Request accept again': {
        pt: 'Solicitar aceite novamente',
        en: 'Request accept again',
    },
    'Are you sure you want to update, this action will cause the privacy policy to have to be accepted again!': {
        pt: 'Tem certeza de que deseja atualizar, essa ação fará com que a política de privacidade tenha que ser aceita novamente!',
        en: 'Are you sure you want to update, this action will cause the privacy policy to have to be accepted again!',
    },
    'Are you sure you want to delete this privacy policy?': {
        pt: 'Tem certeza que deseja excluir esta política de privacidade?',
        en: 'Are you sure you want to delete this privacy policy?',
    },
    'It was not possible to save, as it has channels that are already being used in another privacy policy.': {
        pt: 'Não foi possível salvar, pois possui canais que já estão sendo utilizados em outra politica de privacidade.',
        en: 'It was not possible to save, as it has channels that are already being used in another privacy policy.',
    },
    'Qr code requested': {
        pt: 'Qr code solicitado',
        en: 'Qr code requested',
    },
    Sended: {
        pt: 'Enviado',
        en: 'Sended',
    },
    'Invalid number': {
        pt: 'Número inválido',
        en: 'Invalid number',
    },
    'Time exceeded for validation': {
        pt: 'Tempo excedido para validação',
        en: 'Time exceeded for validation',
    },
    'Time exceeded for validation. Try again': {
        pt: 'Tempo excedido para validação. Tentar novamente',
        en: 'Time exceeded for validation. Try again',
    },
    'Contact already exists, ': {
        pt: 'O contato já existe, ',
        en: 'Contact already exists, ',
    },
    'see contact': {
        pt: 'ver contato',
        en: 'see contact',
    },
    'Valid number': {
        pt: 'Número válido',
        en: 'Valid number',
    },
    'User successfully saved': {
        pt: 'Usuário salvo com sucesso',
        en: 'User successfully saved',
    },
    Create: {
        pt: 'Criar',
        en: 'Create',
    },
    'Attendance will start on the channel': {
        pt: 'O atendimento será iniciado no canal',
        en: 'Attendance will start on the channel',
    },
    'You need to validate the number to continue.': {
        pt: 'Necessário validar o número para continuar.',
        en: 'You need to validate the number to continue.',
    },
    Authenticating: {
        pt: 'Autenticando',
        en: 'Authenticating',
    },
    'Appointment type': {
        pt: 'Tipo de agendamento',
        en: 'Appointment type',
    },
    'Unity filial': {
        pt: 'Unidade filial',
        en: 'Organization unity',
    },
    'Week day': {
        pt: 'Dia da semana',
        en: 'Week day',
    },
    'Started appointment': {
        pt: 'Agendamento iniciado',
        en: 'Started appointment',
    },
    'Ended appointment': {
        pt: 'Agendamento finalizado',
        en: 'Ended appointment',
    },
    'Restart appointment': {
        pt: 'Reiniciar agendamento',
        en: 'Restart appointment',
    },
    'Appointment step': {
        pt: 'Step da marcação',
        en: 'Appointment step',
    },
    'Show notification of new attendance': {
        pt: 'Exibir notificação de novo atendimento',
        en: 'Show notification of new attendance',
    },
    'The number is already present in the contact list': {
        pt: 'O numero já esta presente na lista de contatos',
        en: 'The number is already present in the contact list',
    },
    'Submit a review at the end of the call': {
        pt: 'Enviar avaliação no fim do atendimento',
        en: 'Submit a review at the end of the call',
    },
    'Navigate to article': {
        pt: 'Navegar para o artigo',
        en: 'Navigate to article',
    },
    'Click to open article': {
        pt: 'Clique para abrir o artigo',
        en: 'Click to open article',
    },
    'At least one of the fields must be filled in!': {
        pt: 'Pelo menos um dos campos deve estar preenchido!',
        en: 'At least one of the fields must be filled in!',
    },
    Source: {
        pt: 'Fonte',
        en: 'Source',
    },
    Appointment: {
        pt: 'Consulta',
        en: 'Appointment',
    },
    appointment: {
        pt: 'Agendamento',
        en: 'Appointment',
    },
    reuseAppointments: {
        pt: 'Reutilizar agendamento',
        en: 'Reuse appointment',
    },
    Flow: {
        pt: 'Fluxo',
        en: 'Flow',
    },
    Weigth: {
        pt: 'Peso',
        en: 'Weigth',
    },
    Plan: {
        en: 'Plan',
        pt: 'Plano',
    },
    'When empty will go to interaction': {
        pt: 'Quando estiver vazio ir até a interação',
        en: 'When empty will go to interaction',
    },
    'Bot and agent': {
        pt: 'Bot e agente',
        en: 'Bot and agent',
    },
    'Account exists, data mismatch': {
        pt: 'Conta existe porém os dados estão incorretos',
        en: 'Account exists, data mismatch',
    },
    'If the account exists but data mismatch': {
        pt: 'Se a conta existe mas os dados estão incorretos ',
        en: 'If the account exists but data mismatch',
    },
    'Is empty goto': {
        pt: 'Ir para quando estiver vazio',
        en: 'Is empty goto',
    },
    'Action ignored goto': {
        pt: 'Ir para quando ação ignorada',
        en: 'Action ignored goto',
    },
    'Cannot found any user': {
        pt: 'Nenhum usuário encontrado',
        en: 'Cannot found any user',
    },
    'Error on load users': {
        pt: 'Erro ao carregar usuários',
        en: 'Error on load users',
    },
    'Cannot found any team': {
        pt: 'Nenhum time encontrado',
        en: 'Cannot found any team',
    },
    'Error on update flow': {
        pt: 'Erro ao atualizar fluxo',
        en: 'Error on update flow',
    },
    Organization: {
        pt: 'Organização',
        en: 'Organization',
    },
    'Error on save flow': {
        pt: 'Erro ao salvar fluxo',
        en: 'Error on save flow',
    },
    'Flow saved': {
        pt: 'Fluxo salvo',
        en: 'Flow saved',
    },
    'Search entity': {
        pt: 'Busca de entidade',
        en: 'Search entity',
    },
    'Add step': {
        pt: 'Adicionar passo',
        en: 'Add step',
    },
    'Select entity': {
        pt: 'Selecione uma entidade',
        en: 'Select entity',
    },
    'Error on load flows': {
        pt: 'Erro ao carregar fluxos',
        en: 'Error on load flows',
    },
    Doctor: {
        pt: 'Médico',
        en: 'Doctor',
    },
    'Service group': {
        pt: 'Grupo de serviço',
        en: 'Service group',
    },
    Group: {
        pt: 'Grupo',
        en: 'Group',
    },
    'Day period': {
        pt: 'Período do dia',
        en: 'Day period',
    },
    'If filled will lead to an transboard interaction': {
        pt: 'Se preenchido, irá a uma interação de transbordo',
        en: 'If filled will lead to an transboard interaction',
    },
    'Invalid credentials': {
        en: 'Invalid credentials',
        pt: 'Credenciais inválidas',
    },
    'Invalid email or password': {
        en: 'Invalid email or password',
        pt: 'E-mail ou senha inválidas',
    },
    'Email not valid': {
        pt: 'Email inválido',
        en: 'Email not valid',
    },
    Email: {
        pt: 'Email',
        en: 'Email',
    },
    Password: {
        pt: 'Senha',
        en: 'Password',
    },
    'Search attendances, messages': {
        en: 'Search attendances, messages',
        pt: 'Buscar atendimentos, mensagens',
    },
    'Error creating user.': {
        pt: 'Erro ao criar usuário.',
        en: 'Error creating user.',
    },
    'Email in use': {
        pt: 'Email em uso',
        en: 'Email in use',
    },
    'Try entering another email address': {
        pt: 'Tente preencher outro endereço de e-mail',
        en: 'Try entering another email address',
    },
    'Create user': {
        pt: 'Criar usuário',
        en: 'Create user',
    },
    'User limit of the contracted plan has been reached! \nNew users will be billed on the next invoice.': {
        pt: 'Limite de usuários do plano contratado foi atingido! \nNovos usuários serão cobrados na próxima fatura.',
        en: 'User limit of the contracted plan has been reached! \nNew users will be billed on the next invoice.',
    },
    'amount contracted in the plan': {
        pt: 'quantidade contratada no plano',
        en: 'amount contracted in the plan',
    },
    "When changing the user's permission, the user limit will be exceeded, resulting in an increase for the next invoice.":
        {
            pt: 'Ao alterar a permissão do usuário, o limite de usuários será ultrapassado, resultando num acréscimo para proxima fatura.',
            en: "When changing the user's permission, the user limit will be exceeded, resulting in an increase for the next invoice.",
        },
    'Enter an email to get it': {
        pt: 'Digite um email para buscá-lo',
        en: 'Enter an email to get it',
    },
    Messages: {
        pt: 'Mensagens',
        en: 'Messages',
    },
    'No messages found': {
        pt: 'Nenhuma mensagem encontrada',
        en: 'No messages found',
    },
    Rotate: {
        pt: 'Girar',
        en: 'Rotate',
    },
    'Error sending, click to retry': {
        pt: 'Erro no envio, clique para tentar novamente',
        en: 'Error sending, click to retry',
    },
    'Load messages': {
        pt: 'Carregar mensagens',
        en: 'Load messages',
    },
    'There was an error loading messages': {
        pt: 'Ocorreu um erro ao carregar as mensagens',
        en: 'There was an error loading messages',
    },
    'Try again': {
        pt: 'Tente novamente',
        en: 'Try again',
    },
    'Try again later': {
        pt: 'Tente novamente mais tarde',
        en: 'Try again later',
    },
    Nobody: {
        pt: 'Ninguém',
        en: 'Nobody',
    },
    Official: {
        pt: 'Oficial',
        en: 'Official',
    },
    Historic: {
        pt: 'Histórico',
        en: 'Historic',
    },
    'Enter a name to trigger the template': {
        pt: 'Digite um nome para acionar o template',
        en: 'Enter a name to trigger the template',
    },
    'Template name': {
        pt: 'Nome do template',
        en: 'Template name',
    },
    Message: {
        pt: 'Mensagem',
        en: 'Message',
    },
    'Template message': {
        pt: 'Mensagem do template',
        en: 'Template message',
    },
    'Text can be changed after selected': {
        pt: 'Texto poderá ser alterado após selecionado',
        en: 'Text can be changed after selected',
    },
    "It's an official whatsapp template field": {
        pt: 'É um campo template do whatsapp oficial',
        en: "It's an official whatsapp template field",
    },
    'Create template': {
        pt: 'Criar novo modelo',
        en: 'Create template',
    },
    'Creating template': {
        pt: 'Criando novo modelo',
        en: 'Creating template',
    },
    'Existing templates': {
        pt: 'Modelos existentes',
        en: 'Existing templates',
    },
    'Editing template': {
        pt: 'Editando modelo',
        en: 'Editing template',
    },
    'Template successfully created': {
        pt: 'Modelo criado com sucesso',
        en: 'Template successfully created',
    },
    'Template updated successfully': {
        pt: 'Template atualizado com sucesso',
        en: 'Template updated successfully',
    },
    'Are you sure you want to delete the template?': {
        pt: 'Tem certeza de que deseja excluir o modelo?',
        en: 'Are you sure you want to delete the template?',
    },
    'Template messages': {
        pt: 'Mensagens modelo',
        en: 'Template messages',
    },
    Editable: {
        pt: 'Editável',
        en: 'Editable',
    },
    'No templates found': {
        pt: 'Nenhum template encontrado',
        en: 'No templates found',
    },
    'Official template': {
        pt: 'Template oficial',
        en: 'Official template',
    },
    'Unofficial template': {
        pt: 'Template não oficial',
        en: 'Unofficial template',
    },
    'Non-editable template': {
        pt: 'Template não editável',
        en: 'Non-editable template',
    },
    'Editable template': {
        pt: 'Template editável',
        en: 'Editable template',
    },
    'Utility template': {
        pt: 'Template de Utilidade',
        en: 'Utility template',
    },
    'Marketing template': {
        pt: 'template de marketing',
        en: 'Marketing template',
    },
    'Official template awaiting approval from Whatsapp': {
        pt: 'Template oficial aguardando aprovação do Whatsapp',
        en: 'Official template awaiting approval from Whatsapp',
    },
    'Official template has not been approved by Whatsapp, contact support': {
        pt: 'Template oficial não foi aprovado pelo Whatsapp, entre em contato com o suporte',
        en: 'Official template has not been approved by Whatsapp, contact support',
    },
    'Select the type of template you want to create': {
        pt: 'Selecione o tipo do template que deseja criar',
        en: 'Select the type of template you want to create',
    },
    'Unofficial template that assists in sending prompt messages in customer service.': {
        pt: 'Template não oficial que auxilia no envio de mensagens prontas no atendimento.',
        en: 'Unofficial template that assists in sending prompt messages in customer service.',
    },
    'Official template, requires approval by Whatsapp so that it can be used to create new appointments or start a new session.':
        {
            pt: 'Template oficial, necessita de aprovação pelo Whatsapp para que possa ser usado na criação de novos atendimentos ou inicio de uma nova sessão.',
            en: 'Official template, requires approval by Whatsapp so that it can be used to create new appointments or start a new session.',
        },
    'Fill in this field or select a file': {
        pt: 'Preencha este campo ou selecione um arquivo',
        en: 'Fill in this field or select a file',
    },
    'There are variables that have not yet been filled in': {
        pt: 'Existem variáveis que ainda não foram preenchidas',
        en: 'There are variables that have not yet been filled in',
    },
    'Invalid message, variables at the beginning or end of the text are not allowed': {
        pt: 'Mensagem inválida, não é permitido variáveis no inicio ou fim do texto',
        en: 'Invalid message, variables at the beginning or end of the text are not allowed',
    },
    'It is not possible to edit messages in official templates, if you have questions click on the link below': {
        pt: 'Não é possível editar mensagem em templates oficiais, caso tenha dúvidas clique no link abaixo',
        en: 'It is not possible to edit messages in official templates, if you have questions click on the link below',
    },
    'Template information outdated': {
        pt: 'Informações do template desatualizadas',
        en: 'Template information outdated',
    },
    'Variable has not yet been edited': {
        pt: 'Variável ainda não foi editada',
        en: 'Variable has not yet been edited',
    },
    'The attribute has not yet been edited': {
        pt: 'O atributo ainda não foi editado',
        en: 'The attribute has not yet been edited',
    },
    'Populate with custom variable': {
        pt: 'Preencher com variável personalizada',
        en: 'Populate with custom variable',
    },
    'select default variable': {
        pt: 'Selecionar variável padrão',
        en: 'select default variable',
    },
    'Add variable': {
        pt: 'Adicionar variável',
        en: 'Add variable',
    },
    'Add an example for variable': {
        pt: 'Adicione um exemplo para variável',
        en: 'Add an example for variable',
    },
    'Remove variable': {
        pt: 'Remover variável',
        en: 'Remove variable',
    },
    'Example that will be sent instead of the variable for WhatsApp approval': {
        pt: 'Exemplo que sera enviado no lugar da variável para aprovação do Whatsapp',
        en: 'Example that will be sent instead of the variable for WhatsApp approval',
    },
    'Field name': {
        pt: 'Nome do campo',
        en: 'Field name',
    },
    'Name that will be displayed when filling out': {
        pt: 'Nome que será exibido quando for preencher',
        en: 'Name that will be displayed when filling out',
    },
    'Variable value for identification': {
        pt: 'Valor da variável para identificação',
        en: 'Variable value for identification',
    },
    'Default variable': {
        pt: 'Variável padrão',
        en: 'Default variable',
    },
    'Automatically filled in by the system when sending the template': {
        pt: 'Preenchida automaticamente pelo sistema na hora do envio do template',
        en: 'Automatically filled in by the system when sending the template',
    },
    'Fill in the fields or select one of the standard system variables': {
        pt: 'Preencha os campos ou selecione uma das variáveis padrão do sistema',
        en: 'Fill in the fields or select one of the standard system variables',
    },
    'Variable editing': {
        pt: 'Edição de variável',
        en: 'Variable editing',
    },
    Rejected: {
        pt: 'Reprovado',
        en: 'Rejected',
    },
    'Try to resubmit the template': {
        pt: 'Tentar nova submissão do template',
        en: 'Try to resubmit the template',
    },
    'Submit template for Whatsapp approval': {
        pt: 'Submeter template para aprovação do Whatsapp',
        en: 'Submit template for Whatsapp approval',
    },
    'Delete template from this channel': {
        pt: 'Deletar template deste canal',
        en: 'Delete template from this channel',
    },
    'template status': {
        pt: 'Status do template',
        en: 'Template status',
    },
    'Not submitted for approval': {
        pt: 'Não enviado para aprovação',
        en: 'Not submitted for approval',
    },
    'allow step back': {
        pt: 'Permitir voltar etapa',
        en: 'allow step back',
    },
    Approved: {
        pt: 'Aprovado',
        en: 'Approved',
    },
    Disapproved: {
        pt: 'Reprovado',
        en: 'Disapproved',
    },
    Deleted: {
        pt: 'Deletado',
        en: 'Deleted',
    },
    Disabled: {
        pt: 'Desabilitado',
        en: 'Disabled',
    },
    'Template inactive': {
        pt: 'Template inativo',
        en: 'Template inactive',
    },
    'Active template': {
        pt: 'Template ativo',
        en: 'Active template',
    },
    'Template category': {
        pt: 'Categoria de template',
        en: 'Template category',
    },
    'Search for templates by name or message': {
        pt: 'Pesquise templates por nome ou mensagem',
        en: 'Search for templates by name or message',
    },
    'There are channels that the template is awaiting approval on Whatsapp': {
        pt: 'Possui canais que o template esta aguardando aprovação no Whatsapp',
        en: 'There are channels that the template is awaiting approval on Whatsapp',
    },
    'It has channels that the template was disapproved by Whatsapp': {
        pt: 'Possui canais que o template foi reprovado pelo Whatsapp',
        en: 'It has channels that the template was disapproved by Whatsapp',
    },
    'An error occurred while submitting the template for some channel': {
        pt: 'Ocorreu um erro na submissão do template para algum canal',
        en: 'An error occurred while submitting the template for some channel',
    },
    'It has channels that the template was deleted in Whatsapp': {
        pt: 'Possui canais que o template foi deletado no Whatsapp',
        en: 'It has channels that the template was deleted in Whatsapp',
    },
    'There are channels that the template has had an error in the submission': {
        pt: 'Possui canais que o template ocorreu algum erro na submissão',
        en: 'There are channels that the template has had an error in the submission',
    },
    'It has channels that the template was disabled in Whatsapp': {
        pt: 'Possui canais que o template foi desabilitado no Whatsapp',
        en: 'It has channels that the template was disabled in Whatsapp',
    },
    'It has channels that the template was approved by Whatsapp': {
        pt: 'Possui canais que o template foi aprovado pelo Whatsapp',
        en: 'It has channels that the template was approved by Whatsapp',
    },
    'Template submission required. Select one by typing "/".': {
        pt: 'Obrigatório envio de template. Selecione um digitando "/".',
        en: 'Template submission required. Select one by typing "/".',
    },
    'You do not have permission to edit this template': {
        pt: 'Você não tem permissão para editar este template',
        en: 'You do not have permission to edit this template',
    },
    'Workspace tags': {
        pt: 'Tags do workspace',
        en: 'Workspace tags',
    },
    Photo: {
        pt: 'Foto',
        en: 'Photo',
    },
    File: {
        pt: 'Arquivo',
        en: 'File',
    },
    'Save as most used channel': {
        pt: 'Salvar como canal mais utilizado',
        en: 'Save as most used channel',
    },
    'If selected, this channel will be used as the default for starting new conversations': {
        pt: 'Se selecionado,  este canal será utilizado como padrão para inicio de novas conversas',
        en: 'If selected, this channel will be used as the default for starting new conversations',
    },
    Start: {
        pt: 'Iniciar',
        en: 'Start',
    },
    'No channels found': {
        pt: 'Nenhum canal encontrado',
        en: 'No channels found',
    },
    'No channels available to validate the number': {
        pt: 'Nenhum canal disponível para validar o número',
        en: 'No channels available to validate the number',
    },
    'We were unable to create a conversation for this contact': {
        pt: 'Não foi possível criar uma conversa para este contato',
        en: 'We were unable to create a conversation for this contact',
    },
    "We didn't find any results, please try again with another term": {
        pt: 'Não encontramos nenhum resultado, tente novamente com outro termo',
        en: "We didn't find any results, please try again with another term",
    },
    "Type a message or press '/' to select a template": {
        pt: "Digite uma mensagem ou pressione '/' para selecionar um modelo",
        en: "Type a message or press '/' to select a template",
    },
    'Send message to input field.': {
        pt: 'Enviar mensagem para o campo de entrada.',
        en: 'Send message to input field.',
    },
    'Longer wait': {
        pt: 'Maior espera',
        en: 'Longer wait',
    },
    Creation: {
        pt: 'Criação',
        en: 'Creation',
    },
    'Last notification': {
        pt: 'Ultima notificação',
        en: 'Last notification',
    },
    Priority: {
        pt: 'Prioridade',
        en: 'Priority',
    },
    'Teams resume': {
        en: 'Teams resume',
        pt: 'Resumo dos Times',
    },
    'Take action if': {
        pt: 'Realizar ações caso',
        en: 'Take action if',
    },
    'Future Scheduling': {
        pt: 'Agendamento Futuro',
        en: 'Future Scheduling',
    },
    'Only messages': {
        en: 'Only messages',
        pt: 'Apenas mensagens',
    },
    'Only validate attendance': {
        en: 'Only validate attendance',
        pt: 'Apenas validar período de atendimento',
    },
    'show recent times': {
        en: 'show recent times',
        pt: 'Mostrar horários recentes',
    },
    'If this option is activated, the most recent times of the base will be shown': {
        en: 'If this option is activated, the most recent times of the base will be shown',
        pt: 'Se acionado está opção serão mostrados os horários mais recentes da base',
    },
    Team: {
        en: 'Team',
        pt: 'Time',
    },
    Week: {
        en: 'Week',
        pt: 'Semana',
    },
    Day: {
        en: 'Day',
        pt: 'Dia',
    },
    Hour: {
        en: 'Hour',
        pt: 'Hora',
    },
    Minute: {
        en: 'Minute',
        pt: 'Minuto',
    },
    Months: {
        en: 'Months',
        pt: 'Mês',
    },
    'Agents resume': {
        en: 'Agents resume',
        pt: 'Resumo dos Agentes',
    },
    'Average Agent Response Time': {
        en: 'Average Agent Response Time',
        pt: 'Tempo médio de resposta do agente',
    },
    'Average Patient Response Time': {
        en: 'Average Patient Response Time',
        pt: 'Tempo Médio de Resposta do Paciente',
    },
    'Total assumed by agent': {
        en: 'Total assumed by agent',
        pt: 'Total assumido pelo agente',
    },
    'Finalized agents': {
        en: 'Agents resume',
        pt: 'Resumo dos Agentes',
    },
    'Agents (assumed)': {
        en: 'Agents (assumed)',
        pt: 'Agentes (assumidos)',
    },
    'Agents (finalized)': {
        en: 'Agents (finalized)',
        pt: 'Agentes (finalizado)',
    },
    'Messages by agent': {
        en: 'Messages by agent',
        pt: 'Mensagens por agente',
    },
    'Messages by tags': {
        en: 'Messages by tags',
        pt: 'Mensagens por etiqueta',
    },
    'Awaiting agent': {
        en: 'Awaiting agent',
        pt: 'Aguardando atendimento',
    },
    'In attendance': {
        en: 'In attendance',
        pt: 'Em atendimento',
    },
    Teams: {
        pt: 'Times',
        en: 'Teams',
    },
    'Auto Assign created successfully': {
        pt: 'Atribuição automática criada com sucesso',
        en: 'Auto Assign created successfully',
    },
    'Auto Assign updated successfully': {
        pt: 'Atribuição automática atualizada com sucesso',
        en: 'Auto Assign updated successfully',
    },
    'Error updating the user. Try again': {
        pt: 'Erro ao atualizar o usuário. Tente novamente',
        en: 'Error updating the user. Try again',
    },
    'User updated successfully': {
        pt: 'Usuário atualizado com sucesso',
        en: 'User updated successfully',
    },
    'Last synced': {
        pt: 'Última atualização',
        en: 'Last synced',
    },
    'Synchronization effected. Follow the progress through the status field': {
        pt: 'Sincronização efetuada. Acompanhe o andamento através do campo status',
        en: 'Synchronization effected. Follow the progress through the status field',
    },
    'Last entities synced': {
        pt: 'Última atualização de entidades',
        en: 'Last entities synced',
    },
    'Published entities': {
        pt: 'Entidades publicadas',
        en: 'Published entities',
    },
    Correlations: {
        pt: 'Correlações',
        en: 'Correlations',
    },
    'Extract request sended': {
        pt: 'Solicitação de extração enviada. Aguarde alguns minutos.',
        en: 'Extract request sended. Wait a few minutes.',
    },
    'The import of entities is already being executed': {
        pt: 'A importação de entidades já está sendo executada',
        en: 'The import of entities is already being executed',
    },
    'Synchronize entities': {
        pt: 'Sincronizar entidades',
        en: 'Synchronize entities',
    },
    'Import entities': {
        pt: 'importar entidades',
        en: 'Import entities',
    },
    'Start attendance to view messages': {
        pt: 'Inicie o atendimento para visualizar as mensagens',
        en: 'Start attendance to view messages',
    },
    'Unread messages': {
        pt: 'Mensagens não lidas',
        en: 'Unread messages',
    },
    Exam: {
        pt: 'Exame',
        en: 'Exam',
    },
    'Message to user': {
        pt: 'Mensagem para o usuário',
        en: 'Message to user',
    },
    Comment: {
        pt: 'Comentário',
        en: 'Comment',
    },
    'Create an annotation that will be available only at the attendance': {
        pt: 'Crie uma anotação que ficará disponível apenas no atendimento',
        en: 'Create an annotation that will be available only at the attendance',
    },
    Annotation: {
        pt: 'Anotação',
        en: 'Annotation',
    },
    'It seems that there is no team or you are not allowed to start new attendances. Talk to your supervisor!': {
        pt: 'Parece que não existe nenhum time ou você não tem permissão para iniciar novos atendimentos. Fale com seu supervisor!',
        en: 'It seems that there is no team or you are not allowed to start new attendances. Talk to your supervisor!',
    },
    'There is no channel available to start attendances': {
        pt: 'Não existe nenhum canal disponível para iniciar atendimentos',
        en: 'There is no channel available to start attendances',
    },
    'Invite to the workspace': {
        pt: 'Convidar para o workspace',
        en: 'Invite to the workspace',
    },
    'User already exists in workspace': {
        pt: 'Usuário já existe no workspace',
        en: 'User already exists in workspace',
    },
    'User already exists': {
        pt: 'Usuário já existe',
        en: 'User already exists',
    },
    'Not sent to user': {
        pt: 'Não é enviado para o usuário',
        en: 'Not sent to user',
    },
    Active: {
        pt: 'Ativo',
        en: 'Active',
    },
    Actives: {
        pt: 'Ativos',
        en: 'Actives',
    },
    'Importing messages': {
        pt: 'Importação de mensagens',
        en: 'Importing messages',
    },
    'Whatsapp messages will be imported from a predefined date': {
        pt: 'As mensagens do whatsapp serão importadas a partir de uma data pré-definida',
        en: 'Whatsapp messages will be imported from a predefined date',
    },
    'First period': {
        pt: 'Primeiros do período',
        en: 'First period',
    },
    'First hour': {
        pt: 'Primeiro de cada hora',
        en: 'First hour',
    },
    'No period registered': {
        pt: 'Nenhum período cadastrado',
        en: 'No period registered',
    },
    'Conversation transferred': {
        en: 'Conversation transferred',
        pt: 'Conversa transferida',
    },
    'Conversation could not be transferred': {
        en: 'Conversation could not be transferred',
        pt: 'Não foi possível transferir a conversa',
    },
    Transfer: {
        en: 'Transfer',
        pt: 'Transferir',
    },
    'It seems that there is no team or you are not allowed to make transfers': {
        en: 'It seems that there is no team or you are not allowed to make transfers',
        pt: 'Parece que não existe nenhum time ou você não tem permissão para realizar transferências',
    },
    'There was an error while trying to resend the message': {
        en: 'There was an error while trying to resend the message',
        pt: 'Houve um erro ao tentar reenviar a mensagem',
    },
    'The conversation could not be loaded. Try again': {
        en: 'The conversation could not be loaded. Try again',
        pt: 'Não foi possível carregar a conversa. Tente novamente',
    },
    'Bot published': {
        pt: 'Bot publicado com sucesso',
        en: 'Bot published successfully',
    },
    'Bot interactions publish failed': {
        pt: 'Falha ao publicar interações',
        en: 'Error on publish interactions',
    },
    Publish: {
        pt: 'Publicar',
        en: 'Publish',
    },
    'Very large file. Select a file with a maximum of 10Mb': {
        en: 'Very large file. Select a file with a maximum of 10Mb',
        pt: 'Arquivo muito grande. Selecione um arquivo com no máximo 10Mb',
    },
    Record: {
        en: 'Record',
        pt: 'Gravar',
    },
    Finish: {
        en: 'Finish',
        pt: 'Concluir',
    },
    'Import messages from a specific number': {
        pt: 'Importar mensagens de um número especifico',
        en: 'Import messages from a specific number',
    },
    Import: {
        pt: 'Importar',
        en: 'Import',
    },
    'Battery level': {
        pt: 'Nível de Bateria',
        en: 'Battery level',
    },
    Connected: {
        pt: 'Conectado',
        en: 'Connected',
    },
    Connecting: {
        pt: 'Conectando',
        en: 'Connecting',
    },
    Timestamp: {
        pt: 'Data e Hora',
        en: 'Timestamp',
    },
    'Waiting average time': {
        pt: 'Tempo médio de espera',
        en: 'Waiting average time',
    },
    'Attendance average time': {
        pt: 'Tempo médio de atendimento',
        en: 'Attendance average time',
    },
    Bot: {
        pt: 'Bot',
        en: 'Bot',
    },
    'Sent an image': {
        pt: 'Enviou uma imagem',
        en: 'Sent an image',
    },
    'Sent a video': {
        pt: 'Enviou um video',
        en: 'Sent a video',
    },
    'Sent an audio': {
        pt: 'Enviou um áudio',
        en: 'Sent an audio',
    },
    'Sent a file': {
        pt: 'Enviou um arquivo',
        en: 'Sent a file',
    },
    Conversation: {
        pt: 'Conversa',
        en: 'Conversation',
    },
    'Download conversation': {
        pt: 'Baixar conversa',
        en: 'Download conversation',
    },
    'Sent a message': {
        pt: 'Enviou uma mensagem',
        en: 'Sent a message',
    },
    Integration: {
        pt: 'Integração',
        en: 'Integration',
    },
    'Jump speciality': {
        pt: 'Pular especialidade',
        en: 'Jump speciality',
    },
    'Select a file up to 2MB': {
        pt: 'Selecione um arquivo de até 2MB!',
        en: 'Select a file up to 2MB!',
    },
    'Select a file up to': {
        pt: 'Selecione um arquivo de até',
        en: 'Select a file up to',
    },
    'Real time': {
        pt: 'Tempo real',
        en: 'Real time',
    },
    'Finished of the day': {
        pt: 'Finalizados no dia',
        en: 'Finished of the day',
    },
    'TME average total': {
        pt: 'Total médio TME',
        en: 'TME average total',
    },
    'TMA average total': {
        pt: 'Total médio TMA',
        en: 'TMA average total',
    },
    'Conversation expired. It is necessary to send templates or wait for the user to respond to send messages normally.':
        {
            pt: 'Atendimento expirado. Para enviar mensagens é necessário um template oficial ou aguardar uma nova mensagem do usuário.',
            en: 'Conversation expired. It is necessary to send templates or wait for the user to respond to send messages normally.',
        },
    'Show more': {
        pt: 'Mostrar mais',
        en: 'Show more',
    },
    'Teams that can use the template': {
        pt: 'Times que podem utilizar o template',
        en: 'Teams that can use the template',
    },
    'All teams can use this template': {
        pt: 'Todos os times podem utilizar este template',
        en: 'All teams can use this template',
    },
    'All channels can use this template': {
        pt: 'Todos os canais podem utilizar este template',
        en: 'All channels can use this template',
    },
    'Fill in the fields to proceed with sending the message': {
        en: 'Fill in the fields to proceed with sending the message',
        pt: 'Preencha os campos para prosseguir com o envio da mensagem',
    },
    'Template text cannot be edited': {
        en: 'Template text cannot be edited',
        pt: 'Texto do template não pode ser editado',
    },
    'Allow Whatsapp to change template category': {
        en: 'Allow Whatsapp to change template category',
        pt: 'Permitir que o Whatsapp altere a categoria do template',
    },
    'Select the channels that can use the template': {
        en: 'Select the channels that can use the template',
        pt: 'Selecione os canais que podem utilizar o template',
    },
    'Select the teams that can use the template': {
        en: 'Select the teams that can use the template',
        pt: 'Selecione os times que podem utilizar o template',
    },
    'An error has occurred. Try to validate the number again': {
        en: 'An error has occurred. Try to validate the number again',
        pt: 'Ocorreu um erro. Tente validar o número novamente',
    },
    'An error has occurred. Check the fields': {
        en: 'An error has occurred. Check the fields',
        pt: 'Ocorreu um erro. Verifique os campos',
    },
    'Intent is already being used in this context. Interaction:': {
        en: 'Intent is already being used in this context. Interaction:',
        pt: 'A intenção já está sendo usada neste contexto. Interação:',
    },
    'Edit variables': {
        en: 'Edit variables',
        pt: 'Editar variáveis',
    },
    Variables: {
        en: 'Variables',
        pt: 'Variáveis',
    },
    'Patient code': {
        en: 'Patient code',
        pt: 'Código do paciente',
    },
    'Type of service': {
        en: 'Type of service',
        pt: 'Tipo do serviço',
    },
    return: {
        en: 'Return',
        pt: 'Retorno',
    },
    view: {
        en: 'View',
        pt: 'Visualizar',
    },
    cancel: {
        en: 'Cancel',
        pt: 'Cancelar',
    },
    confirm: {
        en: 'Confirm',
        pt: 'Confirmar',
    },
    Objective: {
        en: 'Objective',
        pt: 'Objetivo',
    },
    'All users will have access to the broadcast list': {
        en: 'All users will have access to the broadcast list',
        pt: 'Todos os usuários tem acesso a lista de transmissão',
    },
    'User access to the broadcast list': {
        en: 'User access to the broadcast list',
        pt: 'Acesso dos usuários a lista de transmissão',
    },
    'Active confirmation': {
        en: 'Active confirmation',
        pt: 'Confirmação ativa',
    },
    'Passive confirmation': {
        en: 'Passive confirmation',
        pt: 'Confirmação passiva',
    },
    'Enable reschedule': {
        en: 'Enable reschedule',
        pt: 'Habilitar reagendar',
    },
    'Disable reschedule': {
        en: 'Disable reschedule',
        pt: 'Desabilitar reagendar',
    },
    "Enables automatic rescheduling of this entity within the bot's flow.": {
        pt: 'Permite reagendamento automático desta entidade no fluxo do bot.',
        en: "Enables automatic rescheduling of this entity within the bot's flow.",
    },
    "Enables automatic cancellation of this entity within the bot's flow.": {
        en: "Enables automatic cancellation of this entity within the bot's flow.",
        pt: 'Possibilita o cancelamento automático desta entidade dentro do fluxo do bot.',
    },
    "Enables automatic scheduling of this entity within the bot's flow.": {
        en: "Enables automatic scheduling of this entity within the bot's flow.",
        pt: 'Permite agendamento automático desta entidade no fluxo do bot.',
    },
    'Allows visualization of the entity.': {
        en: 'Allows visualization of the entity.',
        pt: 'Permite a visualização da entidade.',
    },
    'Name to be displayed in the bot': {
        en: 'Name to be displayed in the bot',
        pt: 'Nome a ser exibido no bot',
    },
    'The higher the number, the closer to the beginning it will be.': {
        en: 'The higher the number, the closer to the beginning it will be.',
        pt: 'Quanto maior o número, mais no início ele estará.',
    },
    'Name imported into ERP': {
        en: 'Name imported into ERP',
        pt: 'Nome importado no ERP',
    },
    'Keywords that, when typed, will match with the entity.': {
        en: 'Keywords that, when typed, will match with the entity.',
        pt: 'Palavras-chave que, ao serem digitadas, encontrarão correspondência com a entidade.',
    },
    'Enable view': {
        en: 'Enable view',
        pt: 'Habilitar visualizar',
    },
    'Disable view': {
        en: 'Disable view',
        pt: 'Desabilitar visualizar',
    },
    'Enable Actively confirm': {
        en: 'Enable Actively confirm',
        pt: 'Habilitar Confirmar ativamente',
    },
    'Enable Confirm passively': {
        en: 'Enable Confirm passively',
        pt: 'Habilitar Confirmar passivamente',
    },
    'Disable Actively confirm': {
        en: 'Disable Actively confirm',
        pt: 'Desabilitar Confirmar ativamente',
    },
    'Disable Confirm passively': {
        en: 'Disable Confirm passively',
        pt: 'Desabilitar Confirmar passivamente',
    },
    'Select an action': {
        en: 'Select an action',
        pt: 'Selecione uma ação',
    },
    'Ignored action': {
        en: 'Ignored action',
        pt: 'Ação ignorada',
    },
    'Can send audio messages': {
        en: 'Can send audio messages',
        pt: 'Enviar mensagens de áudio',
    },
    'Can send official template': {
        en: 'Can send official template',
        pt: 'Enviar template oficial',
    },
    Time: {
        en: 'Time',
        pt: 'Horário',
    },
    Boolean: {
        en: 'Boolean',
        pt: 'Boleano',
    },
    'Requires authentication': {
        en: 'Requires authentication',
        pt: 'Exige autenticação',
    },
    'Hang tags': {
        en: 'Hang tags',
        pt: 'Etiquetas',
    },
    'Create hang tags': {
        en: 'Create hang tags',
        pt: 'Criar etiquetas',
    },
    'Existing tags': {
        en: 'Existing tags',
        pt: 'Etiquetas existentes',
    },
    'No hang tags found': {
        en: 'No hang tags found',
        pt: 'Nenhuma etiqueta encontrada',
    },
    'Creating tag': {
        en: 'Creating tag',
        pt: 'Criando etiqueta',
    },
    'Editing tag': {
        en: 'Editing tag',
        pt: 'Editando etiqueta',
    },
    'Are you sure you want to delete the tag?': {
        pt: 'Tem certeza de que deseja excluir a etiqueta?',
        en: 'Are you sure you want to delete the tag?',
    },
    'Tag successfully created': {
        pt: 'Etiqueta criada com sucesso',
        en: 'Tag successfully created',
    },
    'Tag updated successfully': {
        pt: 'Etiqueta atualizada com sucesso',
        en: 'Tag updated successfully',
    },
    'Find a tag': {
        pt: 'Encontre uma etiqueta',
        en: 'Find a tag',
    },
    Interconsultation: {
        pt: 'Interconsulta',
        en: 'Interconsultation',
    },
    'Interconsultation period': {
        pt: 'Período de interconsulta',
        en: 'Interconsultation period',
    },
    Subplan: {
        pt: 'Subplano',
        en: 'Subplan',
    },
    Subplans: {
        pt: 'Subplanos',
        en: 'Subplans',
    },
    Plans: {
        pt: 'Planos',
        en: 'Plans',
    },
    Synced: {
        pt: 'Sincronizado',
        en: 'Synced',
    },
    Synchronizing: {
        pt: 'Sincronizando',
        en: 'Synchronizing',
    },
    'Check all': {
        pt: 'Selecionar todos',
        en: 'Check all',
    },
    'Invert selection': {
        pt: 'Inverter seleção',
        en: 'Invert selection',
    },
    'Edit all selected': {
        pt: 'Editar todos os selecionados',
        en: 'Edit all selected',
    },
    'Edit in table': {
        pt: 'Editar na tabela',
        en: 'Edit in table',
    },
    'Edit in modal': {
        pt: 'Editar no modal',
        en: 'Edit in  modal',
    },
    Enabled: {
        pt: 'Habilitado',
        en: 'Enabled',
    },
    'Api token': {
        en: 'Api token',
        pt: 'Token de api',
    },
    'Show appointment value': {
        en: 'Show appointment value',
        pt: 'Exibe valor do procedimento',
    },
    Exit: {
        pt: 'Sair',
        en: 'Exit',
    },
    'Find patient': {
        en: 'Find patient',
        pt: 'Encontrar paciente',
    },
    'Enter the platform': {
        en: 'Enter the platform',
        pt: 'Entrar na plataforma',
    },
    Wait: {
        pt: 'Aguarde',
        en: 'Wait',
    },
    'Send image': {
        pt: 'Enviar imagem',
        en: 'Send image',
    },
    Sending: {
        en: 'Sending',
        pt: 'Enviando',
    },
    Unity: {
        en: 'Unity',
        pt: 'Unidade',
    },
    Appointments: {
        en: 'Appointments',
        pt: 'Agendamentos',
    },
    Nothing: {
        en: 'Nothing',
        pt: 'Nenhum',
    },
    'Search another patient': {
        en: 'Search another patient',
        pt: 'Buscar outro paciente',
    },
    'User not registered': {
        en: 'User not registered',
        pt: 'Usuário não cadastrado',
    },
    'Authentication error, try log in again': {
        en: 'Authentication error, try log in again',
        pt: 'Erro de autenticação, tente logar novamente',
    },
    'CPF or birthdate invalid': {
        en: 'CPF or birthdate invalid',
        pt: 'CPF ou data de nascimento inválido',
    },
    'File type': {
        en: 'File type',
        pt: 'Tipo de imagem',
    },
    'Notification sound': {
        en: 'Notification sound',
        pt: 'Som de notificação',
    },
    'Enable message notification sound.': {
        en: 'Enable message notification sound.',
        pt: 'Habilitar som de notificação de mensagem.',
    },
    Sound: {
        en: 'Sound',
        pt: 'Som',
    },
    'Flow synchronized successfully': {
        en: 'Flow synchronized successfully',
        pt: 'Fluxo sincronizado com sucesso',
    },
    'All flows are already published in homologation.': {
        en: 'All flows are already published in homologation.',
        pt: 'Todos os fluxos já estão publicados em homologação.',
    },
    'Are you sure you want to publish the flow to production?': {
        en: 'Are you sure you want to publish the flow to production?',
        pt: 'Tem certeza que deseja fazer a publicação do fluxo para produção?',
    },
    'There are flows that have not yet been published for approval.': {
        en: 'There are flows that have not yet been published for approval.',
        pt: 'Existem fluxos que ainda não foram publicados para homologação.',
    },
    'All streams are already published in production.': {
        en: 'All streams are already published in production.',
        pt: 'Todos os fluxos já estão publicados em produção.',
    },
    'Publish approval flow': {
        en: 'Publish approval flow',
        pt: 'Publicar fluxo para homologação',
    },
    'Change not published for production': {
        en: 'Change not published for production',
        pt: 'Alteração não publicada para produção',
    },
    'Service settings': {
        en: 'Service settings',
        pt: 'Configurações dos atendimentos',
    },
    'Could not get image types': {
        en: 'Could not get image types',
        pt: 'Não foi possível obter os tipos de imagem',
    },
    Service: {
        en: 'Service',
        pt: 'Serviço',
    },
    'Api url': {
        en: 'Api url',
        pt: 'Url da api',
    },
    'Supervisor (All permissions enabled)': {
        pt: 'Supervisor (Todas as permissões habilitadas)',
        en: 'Supervisor (All permissions enabled)',
    },
    'Start attendances': {
        pt: 'Iniciar atendimentos',
        en: 'Start attendances',
    },
    'There was an error loading the workspace teams. Refresh the page': {
        pt: 'Ocorreu um erro ao carregar os times do workspace. Atualize a página',
        en: 'There was an error loading the workspace teams. Refresh the page',
    },
    'An error has occurred': {
        en: 'An error has occurred',
        pt: 'Ocorreu um erro',
    },
    Rules: {
        en: 'Rules',
        pt: 'Regras',
    },
    'Rules confirmation': {
        en: 'Rules confirmation',
        pt: 'Regras confirmação',
    },
    'Edit integrations rules': {
        en: 'Edit integrations rules',
        pt: 'Editar regras de integração',
    },
    'Integration message': {
        pt: 'Mensagens da integração',
        en: 'Integration message',
    },
    'Message configuration': {
        pt: ' Configuração de mensagem',
        en: 'Message configuration',
    },
    'Integrations rules': {
        en: 'Integrations rules',
        pt: 'Regras de integração',
    },
    'Time limit rules': {
        en: 'Time limit rules',
        pt: 'Regras de limite de tempo',
    },
    'List only doctors with available schedules': {
        en: 'List only doctors with available schedules',
        pt: 'Listar apenas médicos com horários disponíveis',
    },
    'Run routine to search for available schedules': {
        en: 'Run routine to search for available schedules',
        pt: 'Executar rotina de buscar agendas disponiveis',
    },
    'Apply interquery in the timetable listing': {
        en: 'Apply interquery in the timetable listing',
        pt: 'Aplicar interconsulta na listagem de horários',
    },
    'Integration rules updated': {
        en: 'Integration rules updated',
        pt: 'Regras da integração atualizadas',
    },
    Continue: {
        en: 'Continue',
        pt: 'Continuar',
    },
    'Copy date': {
        en: 'Copy date',
        pt: 'Copiar data',
    },
    'Copy date to:': {
        en: 'Copy date to:',
        pt: 'Copiar data para:',
    },
    'Cannot assign conversation': {
        en: 'Cannot assign conversation',
        pt: 'Não é possível atribuir conversa',
    },
    'It is not possible to create a bot in this workspace because there is no DialogFlow account.': {
        en: 'It is not possible to create a bot in this workspace because there is no DialogFlow account.',
        pt: 'Não é possível criar um bot neste workspace por não haver uma conta no DialogFlow.',
    },
    'The search text is too long. Use at most': {
        en: 'The search text is too long. Use at most',
        pt: 'O texto da busca é muito grande. Utilize no máximo',
    },
    words: {
        en: 'words',
        pt: 'palavras',
    },
    'Got it': {
        en: 'Got it',
        pt: 'Entendi',
    },
    'No Data': {
        en: 'No Data',
        pt: 'Sem Dados',
    },
    Notifications: {
        en: 'Notifications',
        pt: 'Notificações',
    },
    'Notification List': {
        en: 'Notification List',
        pt: 'Lista de Notificações',
    },
    'Can start conversation': {
        en: 'Can start conversation',
        pt: 'Pode iniciar conversa',
    },
    'Can validate number': {
        en: 'Can validate number',
        pt: 'Pode validar o número',
    },
    'Date limit': {
        en: 'Date limit',
        pt: 'Data limite',
    },
    'Reschedule attribute code': {
        en: 'Reschedule attribute code',
        pt: 'Código do atributo de reagendamento',
    },
    rescheduled: {
        en: 'Rescheduled',
        pt: 'Reagendar',
    },
    schedule: {
        en: 'Schedule',
        pt: 'Agendar',
    },
    Unit: {
        en: 'Unit',
        pt: 'Unidade',
    },
    'Off days': {
        en: 'Off days',
        pt: 'Dias de folga',
    },
    'Offline Integration': {
        en: 'Offline Integration',
        pt: 'Integração Offline',
    },
    'Offline Integrations': {
        en: 'Offline Integrations',
        pt: 'Integrações Offline',
    },
    'The integration is offline': {
        en: 'The integration is offline',
        pt: 'A integração esta offline',
    },
    'The integration is disabled': {
        en: 'The integration is disabled',
        pt: 'A integração está desativada',
    },
    'The integration is online': {
        en: 'The integration is online',
        pt: 'A integração está online',
    },
    Identification: {
        en: 'Identification',
        pt: 'Identificação',
    },
    'Speciality Type': {
        en: 'Speciality Type',
        pt: 'Tipo de especialidade',
    },
    Position: {
        en: 'Position',
        pt: 'Posição',
    },
    creating: {
        en: 'creating',
        pt: 'criando',
    },
    editing: {
        en: 'editing',
        pt: 'editando',
    },
    'Entity not found!!!': {
        en: 'Entity not found!!!',
        pt: 'Entidade não encontrada!!!',
    },
    'Are you sure you want to delete entity': {
        en: 'Are you sure you want to delete entity',
        pt: 'Tem certeza de que deseja excluir a entidade',
    },
    'Entities empty': {
        en: 'Entities empty',
        pt: 'Entidades vazias',
    },
    sun: {
        en: 'sun',
        pt: 'dom',
    },
    mon: {
        en: 'mon',
        pt: 'seg',
    },
    tue: {
        en: 'tue',
        pt: 'ter',
    },
    wed: {
        en: 'wed',
        pt: 'qua',
    },
    thur: {
        en: 'thur',
        pt: 'qui',
    },
    fri: {
        en: 'fri',
        pt: 'sex',
    },
    sat: {
        en: 'sat',
        pt: 'sab',
    },
    'Add comment': {
        en: 'Add comment',
        pt: 'Adicionar Comentário',
    },
    'No comments': {
        en: 'No comments',
        pt: 'Sem comentários',
    },
    'No DialogFlow': {
        en: 'No DialogFlow',
        pt: 'Sem DialogFlow',
    },
    'Add a new comment below.': {
        en: 'Add a new comment below.',
        pt: 'Adicione um novo comentário abaixo.',
    },
    organizationUnit: {
        en: 'Organization',
        pt: 'Unidade',
    },
    organizationUnit_search: {
        en: 'Organization search',
        pt: 'Busca da unidade',
    },
    speciality: {
        en: 'Speciality',
        pt: 'Especialidade',
    },
    speciality_search: {
        en: 'Speciality search',
        pt: 'Busca da especialidade',
    },
    procedure: {
        en: 'Procedure',
        pt: 'Procedimento',
    },
    procedure_search: {
        en: 'Procedure search',
        pt: 'Busca do procedimento',
    },
    appointmentType: {
        en: 'Appointment type',
        pt: 'Tipo agendamento',
    },
    insurance: {
        en: 'Insurance',
        pt: 'Convênio',
    },
    insurance_search: {
        en: 'Insurance search',
        pt: 'Busca do convênio',
    },
    insurancePlan: {
        en: 'Insurance plan',
        pt: 'Plano',
    },
    insurancePlan_search: {
        en: 'Insurance plan search',
        pt: 'Busca do plano',
    },
    insuranceSubPlan: {
        en: 'Insurance sub plan',
        pt: 'Sub plano',
    },
    insuranceSubPlan_search: {
        en: 'Insurance sub plan search',
        pt: 'Busca do Sub plano',
    },
    planCategory: {
        en: 'Category',
        pt: 'Categoria',
    },
    planCategory_search: {
        en: 'Category search',
        pt: 'Busca da categoria',
    },
    group: {
        en: 'Group',
        pt: 'Grupo',
    },
    doctor: {
        en: 'Doctor',
        pt: 'Médico',
    },
    doctor_search: {
        en: 'Doctor search',
        pt: 'Busca do médico',
    },
    chooseDoctor: {
        en: 'Choose doctor',
        pt: 'Escolha de médico',
    },
    choose_doctor: {
        en: 'Choose doctor',
        pt: 'Escolher médico',
    },
    choose_day_period: {
        en: 'Choose period of day',
        pt: 'Escolher período do dia',
    },
    choosePeriodOfDay: {
        en: 'Choose period of day',
        pt: 'Escolher período do dia',
    },
    appointmentValue: {
        en: 'Appointment value question',
        pt: 'Confirma preço agendamento',
    },
    listPatientSchedules: {
        en: 'List patient schedules',
        pt: 'Listar agendamentos paciente',
    },
    reschedule: {
        en: 'Reschedule',
        pt: 'Reagendar',
    },
    omit: {
        en: 'Omit',
        pt: 'Omitir',
    },
    action: {
        en: 'Action',
        pt: 'Ação',
    },
    Step: {
        en: 'Step',
        pt: 'Etapa',
    },
    'Add tag': {
        en: 'Add tag',
        pt: 'Adicionar tag',
    },
    'List available exams': {
        en: 'List available exams',
        pt: 'Listar exames disponíveis',
    },
    'Add attribute': {
        en: 'Add attribute',
        pt: 'Adicionar atributo',
    },
    'Add postback': {
        en: 'Add postback',
        pt: 'Adicionar postback',
    },
    'Add goto': {
        en: 'Add goto',
        pt: 'Adicionar ir para',
    },
    'Add text': {
        en: 'Add text',
        pt: 'Adicionar texto',
    },
    'Add rules': {
        en: 'Add rules',
        pt: 'Adicionar regras',
    },
    'Add rules confirmation': {
        en: 'Add rules confirmation',
        pt: 'Adicionar regras de confirmação',
    },
    'There are no actions, select one to add!': {
        en: 'There are no actions, select one to add!',
        pt: 'Não existe ações, selecione uma para adicionar!',
    },
    'Confirm cancellation': {
        en: 'Confirm cancellation',
        pt: 'Confirmar cancelamento',
    },
    'No flows registered': {
        en: 'No flows registered',
        pt: 'Nenhum fluxo cadastrado',
    },
    'search by entity': {
        en: 'search by entity',
        pt: 'procurar por entidade',
    },
    'New flow': {
        en: 'New flow',
        pt: 'Novo fluxo',
    },
    'Error loading flows': {
        en: 'Error loading flows',
        pt: 'Erro ao carregar os fluxos',
    },
    'Error loading entities': {
        en: 'Error loading entities',
        pt: 'Erro ao carregar entidades',
    },
    'Flow updated successfully': {
        en: 'Flow updated successfully',
        pt: 'Fluxo atualizado com sucesso',
    },
    'Invalid image format, select an image in another format.': {
        en: 'Invalid image format, select an image in another format.',
        pt: 'Formato de imagem invalido, selecione uma imagem em outro formato.',
    },
    Scheduling: {
        en: 'Scheduling',
        pt: 'Agendamento',
    },
    Force: {
        en: 'Force',
        pt: 'Forçar',
    },
    'Correlation in progress': {
        en: 'Correlation in progress',
        pt: 'Correlação em andamento',
    },
    'Move up': {
        en: 'Move up',
        pt: 'Mover para cima',
    },
    'Move down': {
        en: 'Move down',
        pt: 'Mover para baixo',
    },
    'Current password': {
        en: 'Current password',
        pt: 'Senha atual',
    },
    'New password': {
        en: 'New password',
        pt: 'Nova senha',
    },
    'New password confirmation': {
        en: 'New password confirmation',
        pt: 'Confirmar nova senha',
    },
    'Password confirmation': {
        en: 'Password confirmation',
        pt: 'Confirmar senha',
    },
    'Password expiration forces the user to change it on next login.': {
        en: 'Password expiration forces the user to change it on next login.',
        pt: 'A expiração de senha força o usuário a altera-lá no próximo login.',
    },
    'To expire the password, the user': {
        en: 'To expire the password, the user',
        pt: 'Para expirar a senha, o usuário',
    },
    'must know what your current password is': {
        en: 'must know what your current password is',
        pt: 'deve saber qual sua senha atual',
    },
    'If you have lost/forgotten a password, a password change must be carried out.': {
        en: 'If you have lost/forgotten a password, a password change must be carried out.',
        pt: 'Caso tenha perdido/esquecido, uma troca de senha deve ser efetuada.',
    },
    'Continue and force password change': {
        en: 'Continue and force password change',
        pt: 'Continuar e forçar troca de senha',
    },
    'Attention, your password has expired! Look for an administrator to gain access to the password change link.': {
        en: 'Attention, your password has expired! Look for an administrator to gain access to the password change link.',
        pt: 'Atenção sua senha está expirada! Procure um administrador para obter acesso ao link de troca de senha.',
    },

    'Contact your supervisor': {
        en: 'Contact your supervisor',
        pt: 'Entre em contato com seu supervisor',
    },
    'Contact your': {
        en: 'Contact your',
        pt: 'Entre em contato com seu',
    },
    'and request release': {
        en: 'and request release',
        pt: 'e solicite liberação',
    },
    Change: {
        en: 'Change',
        pt: 'Alterar',
    },
    'At least 8 characters': {
        en: 'At least 8 characters',
        pt: 'Pelo menos 8 caracteres',
    },
    'Maximum 20 characters': {
        en: 'Maximum 20 characters',
        pt: 'Máximo de 20 caracteres',
    },
    'Passwords must match': {
        en: 'Passwords must match',
        pt: 'As senhas devem corresponder',
    },
    'invalid current password': {
        en: 'Invalid current password',
        pt: 'Senha atual inválida. Verifique',
    },
    'invalid equal password': {
        en: 'Your new password must be different from your current password',
        pt: 'Sua nova senha tem que ser diferente de sua senha atual',
    },
    'Your password must contain at least one special character': {
        en: 'Your password must contain at least one special character',
        pt: 'Sua senha deve conter pelo menos um caractere especial',
    },
    'Your password expires in less than 5 days, do you want to change it now?': {
        en: 'Your password expires in less than 5 days.',
        pt: 'Sua senha expira em menos de 5 dias.',
    },
    'Change now': {
        en: 'Change now',
        pt: 'Trocar agora',
    },
    'Your password expires in': {
        en: 'Your password expires in ',
        pt: 'Sua senha expira em ',
    },

    'If you do not remember your password, contact your supervisor.': {
        en: 'If you do not remember your password, contact your supervisor.',
        pt: 'Caso não lembre sua senha contate o supervisor.',
    },
    'Change later': {
        en: 'Change later',
        pt: 'Trocar depois',
    },
    Login: {
        en: 'Login',
        pt: 'Entrar',
    },
    'Not enough permission to take action': {
        en: 'Not enough permission to take action',
        pt: 'Sem permissão suficiente para efetuar ação',
    },
    'Change password': {
        en: 'Change password',
        pt: 'Alterar senha',
    },
    Portuguese: {
        en: 'Portuguese',
        pt: 'Português',
    },
    English: {
        en: 'English',
        pt: 'Inglês',
    },
    'You are not allowed to make transfers': {
        en: 'You are not allowed to make transfers',
        pt: 'Você não tem permissão para efetuar transferências',
    },
    'Transfer conversation to another team': {
        pt: 'Transferir conversa para outro time',
        en: 'Transfer conversation to another team',
    },
    'Transfer conversation': {
        pt: 'Transferir atendimento',
        en: 'Transfer conversation',
    },
    'Full name': {
        en: 'Full name',
        pt: 'Nome completo',
    },
    'Groups access': {
        en: 'Groups access',
        pt: 'Grupos de acesso',
    },
    'Auto assign setting': {
        en: 'Auto assign setting',
        pt: 'Configuração auto atribuir',
    },
    'Group access': {
        en: 'Group access',
        pt: 'Grupo de acesso',
    },
    'Find a group access': {
        en: 'Find a group access',
        pt: 'Encontre um grupo de acesso',
    },
    'No access groups found': {
        en: 'No access groups found',
        pt: 'Nenhum grupo de acesso encontrado',
    },
    'User list': {
        en: 'User list',
        pt: 'Lista de usuários',
    },
    'Select one or more users': {
        en: 'Select one or more users',
        pt: 'Selecione um ou mais usuários',
    },
    'Editing group access': {
        en: 'Editing group access',
        pt: 'Editando grupo de acesso',
    },
    'Creating group access': {
        en: 'Creating group access',
        pt: 'Criando grupo de acesso',
    },
    'Are you sure you want to delete the group access?': {
        en: 'Are you sure you want to delete the group access?',
        pt: 'Tem certeza de que deseja excluir o grupo de acesso?',
    },
    'Are you sure you want to delete the contact list?': {
        en: 'Are you sure you want to delete the contact list?',
        pt: 'Tem certeza de que deseja excluir a lista de contatos?',
    },
    'Group access successfully created': {
        en: 'Group access successfully created',
        pt: 'Grupo de acesso criado com sucesso',
    },
    'Group access updated successfully': {
        en: 'Group access updated successfully',
        pt: 'Grupo de acesso atualizado com sucesso',
    },
    'IP list': {
        en: 'IP list',
        pt: 'Lista de IPs',
    },
    Features: {
        en: 'Features',
        pt: 'Recursos',
    },
    'Manage features': {
        en: 'Manage features',
        pt: 'Gerenciar recursos',
    },
    doAppointment: {
        en: 'Appointment time',
        pt: 'Marcação de horário',
    },
    listAppointments: {
        en: 'Appointment list',
        pt: 'Listagem de horários',
    },
    'add/remove tag': {
        en: 'add/remove tag',
        pt: 'adicionar/remover etiqueta',
    },
    'Download table data in csv format to view in Excel.': {
        en: 'Download table data in csv format to view in Excel.',
        pt: 'Baixar dados da tabela em  formato csv para visualizar no Excel.',
    },
    'Download chart data in csv format to view in Excel.': {
        en: 'Download chart data in csv format to view in Excel.',
        pt: 'Baixar dados do gráfico em  formato csv para visualizar no Excel.',
    },
    'Select a period to view in the table.': {
        en: 'Select a period to view in the table.',
        pt: 'Selecione um período para visualizar na tabela.',
    },
    'Select a period to view on the chart.': {
        en: 'Select a period to view on the chart.',
        pt: 'Selecione um período para visualizar no gráfico.',
    },
    'Force password change': {
        pt: 'Forçar troca de senha',
        en: 'Force password change',
    },
    'Expired password': {
        pt: 'Senha expirada',
        en: 'Expired password',
    },
    'Password change will be requested on next login': {
        pt: 'Troca de senha será solicitada no próximo login',
        en: 'Password change will be requested on next login',
    },
    'The password will expire and the user will be forced to update the password': {
        pt: 'A senha será expirada e o usuário forçado a atualizar a senha',
        en: 'The password will expire and the user will be forced to update the password',
    },
    'Password expires in': {
        pt: 'Senha expira em',
        en: 'Password expires in',
    },
    'Link expiry time': {
        pt: 'Tempo de expiração do link',
        en: 'Link expiry time',
    },
    'Disable link after review': {
        pt: 'Desativar link após avaliação',
        en: 'Disable link after review',
    },
    'Usability Settings': {
        pt: 'Configurações de usabilidade',
        en: 'Usability Settings',
    },
    'Disable the link after the rating, the patient will not be able to change the grade after having performed an assessment':
        {
            pt: 'Desative o link após a classificação, o paciente não poderá alterar a nota após ter realizado uma avaliação',
            en: 'Disable the link after the rating, the patient will not be able to change the grade after having performed an assessment',
        },
    'Time for the link to be deactivated, and the patient can no longer rate the service': {
        pt: 'Tempo para que o link seja desativado, e o paciente não possa mais dar nota ao atendimento',
        en: 'Time for the link to be deactivated, and the patient can no longer rate the service',
    },
    at: {
        en: 't',
        pt: 'ás',
    },
    'Medical record': {
        en: 'Medical record',
        pt: 'Prontuário',
    },
    Access: {
        en: 'Access',
        pt: 'Acessar',
    },
    Billing: {
        en: 'Billing',
        pt: 'Cobrança',
    },
    Billings: {
        en: 'Billings',
        pt: 'Cobranças',
    },
    'Billing specifications': {
        en: 'Billing specifications',
        pt: 'Especificações cobrança',
    },
    'Auto assigns': {
        en: 'Auto assigns',
        pt: 'Atribuir automaticamente',
    },
    'Automatically assigned': {
        en: 'Automatically assigned',
        pt: 'Atribuído automaticamente',
    },
    'Search the list': {
        en: 'Search the list',
        pt: 'Procurar na lista',
    },
    'Adding contact list': {
        en: 'Adding contact list',
        pt: 'Adicionando lista de contatos',
    },
    'Name of list': {
        en: 'Name of list',
        pt: 'Nome da lista',
    },
    'Number of contacts': {
        en: 'Number of contacts',
        pt: 'Quantidade de contatos',
    },
    'Which team will transfer as soon as the number starts a service': {
        en: 'Which team will transfer as soon as the number starts a service',
        pt: 'Qual time será transferido assim que o número iniciar um serviço',
    },
    'Channels that will auto-assign': {
        en: 'Channels that will auto-assign',
        pt: 'Canais que irão executar a atribuição automática',
    },
    'Sorry, but the number you entered is already being used for automatic assignment.': {
        en: 'Sorry, but the number you entered is already being used for automatic assignment.',
        pt: 'Desculpe, mas o número que você inseriu já está sendo utilizado na atribuição automática. ',
    },
    'Send as quick replay': {
        en: 'Send as quick replay',
        pt: 'Enviar como resposta rápida',
    },
    'Maximum number of buttons reached': {
        en: 'Maximum number of buttons reached',
        pt: 'Limite máximo de botões atingido',
    },
    'Maximum character limit reached': {
        en: 'Maximum character limit reached',
        pt: 'Limite máximo de caracteres atingido',
    },
    'Customer summary': {
        en: 'Customer summary',
        pt: 'Resumo dos clientes',
    },
    'Generate customer report': {
        en: 'Generate customer report',
        pt: 'Gerar relatório dos clientes',
    },
    'Select for which month the report should be generated:': {
        en: 'Select for which month the report should be generated:',
        pt: 'Selecione para que mês deve ser gerado o relatório:',
    },
    'Do you really want to generate the billet?': {
        en: 'Do you really want to generate the billet?',
        pt: 'Deseja realmente gerar o boleto?',
    },
    'Linked workspaces': {
        en: 'Linked workspaces',
        pt: 'Workspaces vinculados',
    },
    'Ibge city code': {
        en: 'Ibge city code',
        pt: 'Código do ibge da cidade',
    },
    City: {
        en: 'City',
        pt: 'Cidade',
    },
    District: {
        en: 'District',
        pt: 'Bairro',
    },
    State: {
        en: 'State',
        pt: 'Estado',
    },
    'Country code': {
        en: 'Country code',
        pt: 'Código do pais',
    },
    Complement: {
        en: 'Complement',
        pt: 'Complemento',
    },
    Address: {
        en: 'Address',
        pt: 'Endereço',
    },
    'Postal code': {
        en: 'Postal code',
        pt: 'CEP',
    },
    'Fantasy name': {
        en: 'Fantasy name',
        pt: 'Nome fantasia',
    },
    'Corporate name': {
        en: 'Corporate name',
        pt: 'Razão social',
    },
    'Account successfully created': {
        en: 'Account successfully created',
        pt: 'Conta criada com sucesso',
    },
    'Account successfully updated': {
        en: 'Account successfully updated',
        pt: 'Conta atualizada com sucesso',
    },
    'Setup successfully created': {
        en: 'Setup successfully created',
        pt: 'Setup criado com sucesso',
    },
    'Workspace name cannot be empty.': {
        en: 'Workspace name cannot be empty.',
        pt: 'O nome do workspace não pode ser vazio.',
    },
    'Workspace name': {
        en: 'Workspace name',
        pt: 'Nome do workspace',
    },
    'Create setup': {
        pt: 'Criar setup',
        en: 'Create setup',
    },
    'Setup creation': {
        pt: 'Criação de setup',
        en: 'Setup creation',
    },
    Customers: {
        en: 'Customers',
        pt: 'Clientes',
    },
    Customer: {
        en: 'Customer',
        pt: 'Cliente',
    },
    'New customer': {
        en: 'New customer',
        pt: 'Novo cliente',
    },
    'Generate billet': {
        en: 'Generate billet',
        pt: 'Gerar boleto',
    },
    'Generate next charge': {
        en: 'Generate next charge',
        pt: 'Gerar próxima cobrança',
    },
    'Generate next charge for all': {
        en: 'Generate next charge for all',
        pt: 'Gerar próxima cobrança para todos',
    },
    'Generate billet for everyone': {
        en: 'Generate billet for everyone',
        pt: 'Gerar boleto para todos',
    },
    'Select for which month the slips should be generated:': {
        en: 'Select for which month the slips should be generated:',
        pt: 'Selecione para que mês devem ser gerados os boletos:',
    },
    'Select which month the charges should be generated:': {
        en: 'Select which month the charges should be generated:',
        pt: 'Selecione para que mês devem ser geradas as cobranças:',
    },
    'Select in which month the notes should be synced:': {
        en: 'Select in which month the notes should be synced:',
        pt: 'Selecione em qual mês deve ser sincronizadas as notas:',
    },
    'Select for which month the notes should be generated:': {
        en: 'Select for which month the notes should be generated:',
        pt: 'Selecione para que mês devem ser geradas as notas:',
    },
    'Sync notes': {
        en: 'Sync notes',
        pt: 'Sincronizar notas',
    },
    'When a new service appears, emit a sound for those who are logged in': {
        en: 'When a new service appears, emit a sound for those who are logged in',
        pt: 'Som de notificação de nova mensagem na tela de atendimentos',
    },
    'Generate grade': {
        en: 'Generate grade',
        pt: 'Gerar nota',
    },
    'Generate grade for everyone': {
        en: 'Generate grade for everyone',
        pt: 'Gerar nota para todos',
    },
    'There is no grade to generate for the selected month!': {
        en: 'There is no grade to generate for the selected month!',
        pt: 'Não há nenhuma nota a ser gerada para o mês selecionado!',
    },
    paymentDescription: {
        en: 'Billing description',
        pt: 'Descrição da cobrança',
    },
    invoiceDescription: {
        en: 'Note Description',
        pt: 'Descrição da nota',
    },
    'invoiceDescription-msg': {
        en: `Field that describes the service provided. \n'{{MES}}' attribute can be used, to assist in the construction of the message. \nEx: 'Note regarding services provided in the month: {{MES}}'.`,
        pt: `Campo que descreve o serviço prestado. \nPoderá ser usado atributo '{{MES}}', para auxiliar na construção da mensagem. \nEx: 'Nota referente aos serviços prestados no mês: {{MES}}. Quantidade de atendimentos: {{QTD_ATENDIMENTOS}}.'.`,
    },
    'paymentDescription-msg': {
        en: `Field that describes the service provided. \n'{{MES}}' attribute can be used, to assist in the construction of the message. \nEx: 'Bill for services provided in the month: {{MES}}'.`,
        pt: `Campo que descreve o serviço prestado. \nPoderá ser usado atributo '{{MES}}', para auxiliar na construção da mensagem. \nEx: 'Cobrança referente ao serviços prestados no mês: {{MES}}'.`,
    },
    'Contains overdue invoices': {
        en: 'Contains overdue invoices',
        pt: 'Contém faturas vencidas',
    },
    'Last payment': {
        en: 'Last payment',
        pt: 'Último pagamento',
    },
    'Last charge': {
        en: 'Last charge',
        pt: 'Última cobrança',
    },
    Period: {
        en: 'Period',
        pt: 'Período',
    },
    'Payment summary': {
        en: 'Payment summary',
        pt: 'Resumo das faturas',
    },
    Quantity: {
        en: 'Quantity',
        pt: 'Quantidade',
    },
    AwaitingPayment: {
        en: 'Awaiting payment',
        pt: 'Aguardando pagamento',
    },
    OverDue: {
        en: 'Overdue',
        pt: 'Atrasado',
    },
    'Successfully synced': {
        en: 'Successfully synced',
        pt: 'Sincronizado com sucesso',
    },
    'activeMessage-channelConfigToken': {
        en: 'Whatsapp number will be used to send the message.',
        pt: 'Número do whatsapp que será usado para enviar a mensagem.',
    },
    'activeMessage-settingName': {
        en: 'Name that will be shown in the active message settings list.',
        pt: 'Nome que será mostrado na lista de configurações da mensagem ativa.',
    },
    'activeMessage-callbackUrl': {
        en: 'Return url for message events. Call when:\n - Number sent is invalid.\n - "Send message to open conversation" setting is disable,\nand there is already a conversation for the number.',
        pt: 'Url de retorno para eventos da mensagem. Chamada quando:\n - Numero enviado é inválido.\n - Configuração "Enviar mensagem para conversa aberta" estiver desativado,\ne já existir uma conversa para o número.',
    },
    'activeMessage-suspended': {
        en: `The number's conversation will be suspended for the specified time.\nWhen overflowing it will be necessary to filter by suspended conversations to view it.`,
        pt: 'A conversa do número ficará como suspensa pelo tempo determinado.\nNo transbordo será necessário filtrar por conversas suspensas para visualizá-la.',
    },
    'activeMessage-objective': {
        en: `What is the purpose of this active message, where will it be used.`,
        pt: 'Qual o objetivo desta mensagem ativa, onde será utilizada.',
    },
    'activeMessage-expiration': {
        en: 'The conversation will expire at the given time.',
        pt: 'A conversa irá expirar no tempo determinado.',
    },
    'activeMessage-active': {
        en: 'When this option is disabled, the api will not receive the requests.',
        pt: 'Quando desabilitada essa opção, a api não irá receber as solicitações.',
    },
    'activeMessage-sendMessageToOpenConversation': {
        en: 'If this option is disable the api will ignore messages whose number already has an open conversation.\nIn this case the callbackUrl will be called.',
        pt: 'Se desabilitada essa opção a api irá ignorar mensagens cujo número já tenha uma conversa aberta.\nNesse caso o callbackUrl será chamado.',
    },
    'activeMessage-tags': {
        en: 'Tags that will be added to the service created through this active message.',
        pt: 'Etiquetas que serão adicionadas ao atendimento criado através desta mensagem ativa.',
    },
    'activeMessage-templateId': {
        en: 'Template that will be sent when using this active message setting.',
        pt: 'Template que sera enviado quando utilizar essa configuração de mensagem ativa.',
    },
    'activeMessage-action': {
        en: 'Custom flow that will be applied when starting a service',
        pt: 'Fluxo personalizado que será aplicado quando iniciar um atendimento',
    },
    'activeMessage-authorizationHeader': {
        en: 'Authorization configuration of callbackUrl request header',
        pt: 'Configuração authorization do header da requisição de callbackUrl',
    },
    'Add chart': {
        en: 'Add chart',
        pt: 'Adicionar gráfico',
    },
    'Add filter': {
        en: 'Add filter',
        pt: 'Adicionar filtro',
    },
    Field: {
        en: 'Field',
        pt: 'Campo',
    },
    And: {
        en: 'And',
        pt: 'E',
    },
    Condition: {
        en: 'Condition',
        pt: 'Condição',
    },
    'Group by': {
        en: 'Group by',
        pt: 'Agrupar por',
    },
    Dimension: {
        en: 'Dimension',
        pt: 'Dimensão',
    },
    Table: {
        en: 'Table',
        pt: 'Tabela',
    },
    Line: {
        en: 'Line',
        pt: 'Linha',
    },
    Columns: {
        en: 'Columns',
        pt: 'Colunas',
    },
    At: {
        en: 'At',
        pt: 'Às',
    },
    'Hour range': {
        en: 'Hour range',
        pt: 'Intervalo de horas',
    },
    'Type of chart': {
        en: 'Type of chart',
        pt: 'Tipo de gráfico',
    },
    Graphic: {
        en: 'Graphic',
        pt: 'Gráfico',
    },
    'Edit chart': {
        en: 'Edit chart',
        pt: 'Editar gráfico',
    },
    'Clone chart': {
        en: 'Clone chart',
        pt: 'Clonar gráfico',
    },
    'Delete chart': {
        en: 'Delete chart',
        pt: 'Excluir gráfico',
    },
    Unknown: {
        en: 'Unknown',
        pt: 'Desconhecido',
    },
    'Unfinished services': {
        en: 'Unfinished services',
        pt: 'Atendimentos não finalizados',
    },
    'Service without assigned team': {
        en: 'Service without assigned team',
        pt: 'Atendimentos sem time atribuído',
    },
    'Services without linked advertising': {
        en: 'Services without linked advertising',
        pt: 'Atendimentos sem publicidade vinculada',
    },
    'Total attendances': {
        en: 'Total attendances',
        pt: 'Total de atendimentos',
    },
    'Evaluation average': {
        en: 'Evaluation average',
        pt: 'Média da avaliação',
    },
    'Create Dashboard': {
        en: 'Create Dashboard',
        pt: 'Criar Dashboard',
    },
    Visibility: {
        en: 'Visibility',
        pt: 'Visibilidade',
    },
    Public: {
        en: 'Public',
        pt: 'Público',
    },
    Private: {
        en: 'Private',
        pt: 'Privado',
    },
    Include: {
        en: 'Include',
        pt: 'Incluir',
    },
    'It will show service data according to the selected category': {
        en: 'It will show service data according to the selected category',
        pt: 'Mostrará dados de atendimento de acordo com a categoria selecionada',
    },
    'Type of data about calls that appears in the graph': {
        en: 'Type of data about calls that appears in the graph',
        pt: 'Tipo de dado sobre atendimentos que aparece no gráfico',
    },
    'By which field the filter will be applied': {
        en: 'By which field the filter will be applied',
        pt: 'Por qual campo o filtro será aplicado',
    },
    'Which values ​​will be filtered according to the selected field': {
        en: 'Which values ​​will be filtered according to the selected field',
        pt: 'Quais valores estarão sendo filtrados de acordo com o campo selecionado',
    },
    'Everyone can see your Dashboard': {
        en: 'Everyone can see your Dashboard',
        pt: 'Todos podem ver seu Dashboard',
    },
    'Only you can see your Dashboard': {
        en: 'Only you can see your Dashboard',
        pt: 'Apenas você pode ver seu Dashboard',
    },
    'Allow changes by other users.': {
        en: 'Allow changes by other users.',
        pt: 'Permitir que outros usuários façam alterações.',
    },
    'Created by:': {
        en: 'Created by:',
        pt: 'Criado por:',
    },
    'Are you sure you want to delete the Dashboard?': {
        en: 'Are you sure you want to delete the Dashboard?',
        pt: 'Tem certeza de que deseja excluir o Dashboard?',
    },
    'Are you sure you want to delete the chart?': {
        en: 'Are you sure you want to delete the chart?',
        pt: 'Tem certeza de que deseja excluir o gráfico?',
    },
    'Allow push active commit for this entity': {
        en: 'Allow push active commit for this entity',
        pt: 'Permitir envio de confirmação ativa para esta entidade',
    },
    'Address that will be presented to the patient when confirming the selected time': {
        en: 'Address that will be presented to the patient when confirming the selected time',
        pt: 'Endereço que será apresentado ao paciente na confirmação de horário selecionado',
    },
    'Value that will be presented to the patient when confirming the selected time': {
        en: 'Value that will be presented to the patient when confirming the selected time',
        pt: 'Valor que será apresentado ao paciente na confirmação de horário selecionado',
    },
    'Number of days that will be sought to present schedules to the patient': {
        en: 'Number of days that will be sought to present schedules to the patient',
        pt: 'Quantidade de dias que serão buscados para apresentação de horários ao paciente',
    },
    'Allow the patient to confirm their appointment through the bot': {
        en: 'Allow the patient to confirm their appointment through the bot',
        pt: 'Permitir que  o paciente confirme seu agendamento através do bot',
    },
    'You still not': {
        en: 'You still not',
        pt: 'Você ainda não',
    },
    'has no dashboard': {
        en: 'has no dashboard',
        pt: 'possui nenhum dashboard',
    },
    'My reports': {
        en: 'My reports',
        pt: 'Meus relatórios',
    },
    'My Reports - If this button is activated, the My Reports module of the dashboard will be available.': {
        en: 'My Reports - If this button is activated, the My Reports module of the dashboard will be available.',
        pt: 'Meus relatórios - Caso este botão esteja ativado, o módulo meus relatórios do dashboard estará disponível.',
    },
    'Schedules - If this button is activated, the dashboard schedule module will be available.': {
        en: 'Schedules - If this button is activated, the dashboard schedule module will be available.',
        pt: 'Agendamentos - Caso este botão esteja ativado, o módulo de agendamentos do dashboard estará disponível.',
    },
    'Messages - If this button is activated, the dashboard messages module will be available.': {
        en: 'Messages - If this button is activated, the dashboard messages module will be available.',
        pt: 'Mensagens - Caso este botão esteja ativado, o módulo de mensagens do dashboard estará disponível.',
    },
    'User limit message - If this button is activated, when creating a new user it will show a message if the user limit of your contract has been exceeded.':
        {
            en: 'User limit message - If this button is activated, when creating a new user it will show a message if the user limit of your contract has been exceeded.',
            pt: 'Mensagem limite de usuários - Caso este botão esteja ativado, ao criar um novo usuário mostrará uma mensagem, se o limite de usuários de seu contrato foi ultrapassado.',
        },
    'Official template - If this button is activated, it will be possible to create official templates for Whatsapp through the platform.':
        {
            en: 'Official template - If this button is activated, it will be possible to create official templates for Whatsapp through the platform.',
            pt: 'Template oficial - Caso este botão esteja ativado, será possível fazer a criação de templates oficiais para Whatsapp pela plataforma.',
        },
    'Contracted quantity:': {
        en: 'Contracted quantity:',
        pt: 'Quantidade contratada:',
    },
    'Active users:': {
        en: 'Active users:',
        pt: 'Usuários ativos:',
    },
    'The chosen name will help to better identify and organize the workspace that will appear on the platform': {
        en: 'The chosen name will help to better identify and organize the workspace that will appear on the platform',
        pt: 'Nome do cliente na plataforma',
    },
    'General Settings': {
        en: 'General settings',
        pt: 'Configurações gerais',
    },
    'Help center': {
        en: 'Help center',
        pt: 'Central de ajuda',
    },
    Campaigns: {
        en: 'Campaigns',
        pt: 'Campanhas',
    },
    Campaign: {
        en: 'Campaign',
        pt: 'Campanha',
    },
    "You don't have any official approved templates, create one to continue!": {
        en: "You don't have any official approved templates, create one to continue!",
        pt: 'Você não possui nenhum template oficial aprovado, crie um para continuar!',
    },
    'In order to proceed with the creation of the broadcast list, you will have to contact your account manager for the creation of a channel configuration!':
        {
            en: 'In order to proceed with the creation of the broadcast list, you will have to contact your account manager for the creation of a channel configuration!',
            pt: 'Para dar continuidade na criação da lista de transmissão, você tera que entrar em contato com seu gerente de contas para a criação de uma configuração de canal!',
        },
    'Create broadcast lists, to automate the sending of your messages.': {
        en: 'Create broadcast lists, to automate the sending of your messages.',
        pt: 'Crie listas de transmissão, para automatizar o envio de suas mensagens.',
    },
    'Create broadcast list': {
        en: 'Create broadcast list',
        pt: 'Criar lista de transmissão',
    },
    'By continuing with the creation of the broadcast list, you agree with the WhatsApp usage policies.': {
        en: 'By continuing with the creation of the broadcast list, you agree with the WhatsApp usage policies.',
        pt: 'Ao continuar com a criação da lista de transmissão você está de acordo com as políticas de uso do WhatsApp.',
    },
    'Most recent lists': {
        en: 'Most recent lists',
        pt: 'Listas mais recentes',
    },
    'Download the spreadsheet model and add recipient data according to the model columns in CSV or Excel format. And then import.':
        {
            en: 'Download the spreadsheet model and add recipient data according to the model columns in CSV or Excel format. And then import.',
            pt: 'Baixe o modelo de planilha e adicione os dados dos destinatários de acordo com as colunas do modelo, no formato CSV ou Excel. E depois importe.',
        },
    '*Maximum limit of 200 recipients per broadcast list.': {
        en: '*Maximum limit of 200 recipients per broadcast list.',
        pt: '*Limite máximo de 200 destinatários por lista de transmissão.',
    },
    'Delete recipients': {
        en: 'Delete recipients',
        pt: 'Deletar destinatários',
    },
    'Are you sure you want to delete all selected recipients?': {
        en: 'Are you sure you want to delete all selected recipients?',
        pt: 'Tem certeza que deseja excluir todos os destinatários selecionados?',
    },
    'Are you sure you want to delete all recipients from the list?': {
        en: 'Are you sure you want to delete all recipients from the list?',
        pt: 'Tem certeza que deseja excluir todos os destinatários da lista?',
    },
    'File error': {
        en: 'File error',
        pt: 'Erro no arquivo',
    },
    'File does not conform to the model, needs to have the column': {
        en: 'File does not conform to the model, needs to have the column',
        pt: 'Arquivo não está de acordo com o modelo, necessita ter a coluna',
    },
    'completed, please arrange.': {
        en: 'completed, please arrange.',
        pt: 'preenchida, favor arrumar.',
    },
    'Delete all recipients': {
        en: 'Delete all recipients',
        pt: 'Deletar todos os destinatários',
    },
    "It looks like you don't have any broadcast lists. Create your first.": {
        en: "It looks like you don't have any broadcast lists. Create your first.",
        pt: 'Parece que você não tem nenhuma lista de transmissão. Crie sua primeira.',
    },
    'Send now': {
        en: 'Send now',
        pt: 'Enviar agora',
    },
    'Pause sending': {
        en: 'Pause sending',
        pt: 'Pausar envio',
    },
    'Paused broadcast list': {
        en: 'Paused broadcast list',
        pt: 'Lista de transmissão pausada',
    },
    'Continue shipping': {
        en: 'Continue shipping',
        pt: 'Continuar envio',
    },
    'See details': {
        en: 'See details',
        pt: 'Ver detalhes',
    },
    'Shipping:': {
        en: 'Shipping:',
        pt: 'Envio:',
    },
    'Error in sending': {
        en: 'Error in sending',
        pt: 'Erro no envio',
    },
    'Enable confirmation resend': {
        en: 'Enable confirmation resend',
        pt: 'Habilitar reenvio de confirmação',
    },
    'Enable resending of the message for those who did not respond': {
        en: 'Enable resending of the message for those who did not respond',
        pt: 'Habilitar reenvio da mensagem para quem não respondeu',
    },
    'Omit appointment type in description': {
        en: 'Omit appointment type in description',
        pt: 'Omitir tipo de agendamento na descrição',
    },
    'Omit extraction orientation': {
        en: 'Omit extraction orientation',
        pt: 'Omitir orientação da extração',
    },
    'Send on Friday, weekend and Monday': {
        en: 'Send on Friday, weekend and Monday',
        pt: 'Enviar na sexta feira envios de final de semana e segunda',
    },
    'Check if there have been changes to the schedule when resending a message': {
        en: 'Check if there have been changes to the schedule when resending a message',
        pt: 'Checar se houve alterações no agendamento ao reenviar mensagem',
    },
    'Activating this option will make the system handle times in order of arrival.': {
        en: 'Activating this option will make the system handle times in order of arrival.',
        pt: 'Ativar essa opção fará com que o sistema trate os horários por ordem de chegada.',
    },
    'Omit time in group description': {
        en: 'Omit time in group description',
        pt: 'Omitir horário na descrição do grupo',
    },
    'User blocked receiving template': {
        en: 'User blocked receiving template',
        pt: 'Usuário bloqueou o recebimento de template',
    },
    'Template is not active or does not exist for a language and locale': {
        en: 'Template is not active or does not exist for a language and locale',
        pt: 'O template não está com status de ativo ou não existe para um idioma e local',
    },
    'In progress': {
        en: 'Unscheduled',
        pt: 'Não Agendado',
    },
    Draft: {
        en: 'Draft',
        pt: 'Rascunho',
    },
    'Waiting to be sent': {
        en: 'Waiting to be sent',
        pt: 'Aguardando envio',
    },
    Sent: {
        en: 'Sent',
        pt: 'Enviados',
    },
    of: {
        en: 'of',
        pt: 'de',
    },
    contacts: {
        en: 'contacts',
        pt: 'contatos',
    },
    'Send manually': {
        en: 'Send manually',
        pt: 'Enviar manualmente',
    },
    Pause: {
        en: 'Pause',
        pt: 'Pausar',
    },
    'Broadcast list': {
        en: 'Broadcast list',
        pt: 'Lista de transmissão',
    },
    'Broadcast list name': {
        en: 'Broadcast list name',
        pt: 'Nome da lista de transmissão',
    },
    'Broadcast list creation': {
        en: 'Broadcast list creation',
        pt: 'Criação de lista de transmissão',
    },
    'There are no recipients in this broadcast list': {
        en: 'There are no recipients in this broadcast list',
        pt: 'Não existem destinatários nesta lista de transmissão',
    },
    'Select a message that will be sent to recipients in the broadcast list': {
        en: 'Select a message that will be sent to recipients in the broadcast list',
        pt: 'Selecione uma mensagem que será enviada para os destinatários da lista de transmissão',
    },
    'These messages need to be pre-approved by Whatsapp. To create a custom message, contact support.': {
        en: 'These messages need to be pre-approved by Whatsapp. To create a custom message, contact support.',
        pt: 'Estas mensagens precisam ser pré aprovadas pelo Whatsapp. Para criar uma mensagem personalizada, entre em contato com o suporte.',
    },
    Advance: {
        en: 'Advance',
        pt: 'Avançar',
    },
    'Enter a name, and a description that addresses the importance of the broadcast list': {
        en: 'Enter a name, and a description that addresses the importance of the broadcast list',
        pt: 'Digite um nome, e uma descrição que o ajudará a lembrar do que se trata está lista de transmissão.',
    },
    '*Required field to be able to proceed': {
        en: '*Required field to be able to proceed',
        pt: '*Campo obrigatório para que seja possível avançar',
    },
    'Find a message': {
        en: 'Find a message',
        pt: 'Encontre uma mensagem',
    },
    'Template attribute': {
        en: 'Template attribute',
        pt: 'Atributo do template',
    },
    'Add attributes that will be included in calls initiated by the campaign': {
        en: 'Add attributes that will be included in calls initiated by the campaign',
        pt: 'Adicione atributos que serão incluídos aos atendimentos iniciados pela campanha',
    },
    'Are your recipients in a file? Quickly import a file with your recipients, in CSV or Excel format.': {
        en: 'Are your recipients in a file? Quickly import a file with your recipients, in CSV or Excel format.',
        pt: 'Seus destinatários estão em um arquivo? Importe rapidamente um arquivo com seus destinatários, no formato CSV ou Excel.',
    },
    'Or download the template, fill in your data, and then import.': {
        en: 'Or download the template, fill in your data, and then import.',
        pt: 'Ou baixe o modelo, preencha com seus dados, e depois importe.',
    },
    'Download model': {
        en: 'Download model',
        pt: 'Baixar modelo',
    },
    'Download CSV': {
        en: 'Download CSV',
        pt: 'Baixar arquivo CSV',
    },
    'Standard chart': {
        en: 'Standard chart',
        pt: 'Gráfico padrão',
    },
    'Import from a file': {
        en: 'Import from a file',
        pt: 'Importar de um arquivo',
    },
    'Confirm exclusion': {
        en: 'Confirm exclusion',
        pt: 'Confirmar exclusão',
    },
    'Shipping time': {
        en: 'Shipping time',
        pt: 'Horário de envio',
    },
    'If no sending time is defined, it must be sent manually': {
        en: 'If no sending time is defined, it must be sent manually',
        pt: 'Se não for definido nenhum horário de envio, deve-se enviar manualmente',
    },
    'Time interval': {
        en: 'Time interval',
        pt: 'Intervalo de tempo',
    },
    'Set the time interval between sends for each recipient on the broadcast list': {
        en: 'Set the time interval between sends for each recipient on the broadcast list',
        pt: 'Defina o intervalo de tempo entre os envios para cada destinatário da lista de transmissão',
    },
    'Choose through which integration the broadcast list will be sent': {
        en: 'Choose through which integration the broadcast list will be sent',
        pt: 'Escolha através de qual integração será enviada a lista de transmissão',
    },
    'continue later': {
        en: 'continue later',
        pt: 'Continuar depois',
    },
    'Exit without saving': {
        en: 'Exit without saving',
        pt: 'Sair sem salvar',
    },
    'Clone broadcast list': {
        en: 'Clone broadcast list',
        pt: 'Clonar lista de transmissão',
    },
    Resume: {
        en: 'Resume',
        pt: 'Resumo',
    },
    'Are you sure you want to delete the broadcast list?': {
        en: 'Are you sure you want to delete the broadcast list?',
        pt: 'Tem certeza de que deseja excluir a lista de transmissão?',
    },
    'Broadcast list has already been sent': {
        en: 'Broadcast list has already been sent',
        pt: 'Lista de transmissão já foi enviada',
    },
    'Send date': {
        en: 'Send date',
        pt: 'Data de envio',
    },
    'Message sending interval': {
        en: 'Message sending interval',
        pt: 'Intervalo de envio das mensagens',
    },
    simple: {
        en: 'simple',
        pt: 'simples',
    },
    'Synonyms - Tip: you can paste multiple synonyms separated by ;': {
        en: 'Synonyms - Tip: you can paste multiple synonyms separated by ;',
        pt: 'Sinônimos - Dica: você pode colar vários sinônimos separados por ;',
    },
    'Sent with success': {
        en: 'Sent with success',
        pt: 'Enviado com sucesso',
    },
    Exist: {
        en: 'Exist',
        pt: 'Existem',
    },
    'incomplete recipients': {
        en: 'incomplete recipients',
        pt: 'destinatários incompletos',
    },
    recipients: {
        en: 'recipients',
        pt: 'destinatários',
    },
    Recipients: {
        en: 'Recipients',
        pt: 'Destinatários',
    },
    'Shipping settings': {
        en: 'Shipping settings',
        pt: 'Configurações de envio',
    },
    'Delete selected recipients': {
        en: 'Delete selected recipients',
        pt: 'Excluir destinatários selecionados',
    },
    'Execute from of': {
        en: 'Execute from of',
        pt: 'Executar a partir de',
    },
    'Execute until': {
        en: 'Execute until',
        pt: 'Executar até',
    },
    'Execute from this time': {
        en: 'Execute from this time',
        pt: 'Executar a partir deste horário',
    },
    'Execute until time': {
        en: 'Execute until time',
        pt: 'Executar até este horário',
    },
    'Limit of days to list doctors with available appointments': {
        en: 'Limit of days to list doctors with available appointments',
        pt: 'Limite de dias para listar médicos com horários disponíveis',
    },
    'Divide timetable search into periods of X days': {
        en: 'Divide timetable search into periods of X day',
        pt: 'Dividir busca de horários em períodos de X dias',
    },
    'How long in minutes to display first available time': {
        en: 'How long in minutes to display first available time',
        pt: 'Quanto tempo em minutos para exibir primeiro horário disponível',
    },
    'Force time listing for all active units': {
        en: 'Force time listing for all active units',
        pt: 'Forçar listagem de horário de todas unidades ativas',
    },
    'In the list of doctors, display an option at the end to change doctors': {
        en: 'In the list of doctors, display an option at the end to change doctors',
        pt: 'Na listagem de médicos, exibir no final uma opção para trocar de médico',
    },
    'Show option to search for future times in the timetable list': {
        en: 'Show option to search for future times in the timetable list',
        pt: 'Mostrar opção de buscar horários futuros, na listagem de horários',
    },
    conversationId: {
        en: 'Conversation Id',
        pt: 'ID da conversa',
    },
    channelId: {
        en: 'Channel',
        pt: 'Canal',
    },
    timestamp: {
        en: 'Timestamp',
        pt: 'Data/Hora',
    },
    conversationUrl: {
        en: 'Conversation Url',
        pt: 'Link da conversa',
    },
    specialityName: {
        en: 'Speciality',
        pt: 'Especialidade',
    },
    procedureName: {
        en: 'Procedure',
        pt: 'Procedimento',
    },
    appointmentTypeName: {
        en: 'Appointment type',
        pt: 'Tipo de agendamento',
    },
    insuranceName: {
        en: 'Insurance',
        pt: 'Convênio',
    },
    insurancePlanName: {
        en: 'Insurance plan',
        pt: 'Plano do convênio',
    },
    doctorName: {
        en: "Professional's name",
        pt: 'Nome do profissional',
    },
    insuranceCategoryName: {
        en: 'Insurance category',
        pt: 'Categoria do convênio',
    },
    insuranceSubPlanName: {
        en: 'Insurance sub plan',
        pt: 'Sub plano do convênio',
    },
    organizationUnitName: {
        en: 'Organization unit',
        pt: 'Nome da unidade',
    },
    patientCode: {
        en: 'Patient code within the ERP',
        pt: 'Código do paciente dentro do ERP',
    },
    lastPatientAppointmentDate: {
        en: 'Last patient appointment date',
        pt: 'Data da última consulta do paciente',
    },
    nextPatientAppointmentDate: {
        en: 'Next patient appointment date',
        pt: 'Próxima data de consulta do paciente',
    },
    avaliableDateCount: {
        en: 'Avaliable date count',
        pt: 'Número de datas disponíveis',
    },
    occupationAreaName: {
        en: 'Occupation area name',
        pt: 'Nome da área de atuação',
    },
    firstAvaliableDate: {
        en: 'First avaliable date',
        pt: 'Primeira data disponível',
    },
    firstAvaliableDateDistance: {
        en: 'First avaliable date distance',
        pt: 'Tempo para primeira data disponível',
    },
    periodOfDay: {
        en: 'Period od day',
        pt: 'Período do dia',
    },
    appointmentConfirmed: {
        en: 'scheduling attempts',
        pt: 'Tentativa de agendamento',
    },
    appointmentCode: {
        en: 'Appointment code',
        pt: 'Código do agendamento',
    },
    appointmentDate: {
        en: 'Appointment date',
        pt: 'Data do agendamento',
    },
    step: {
        en: 'Scheduling stage',
        pt: 'Etapa do agendamento',
    },
    appointmentStatus: {
        en: 'Appointment status',
        pt: 'Status do agendamento',
    },
    patientAge: {
        en: 'Patient age',
        pt: 'Idade do paciente',
    },
    price: {
        en: 'Procedure price',
        pt: 'Preço do procedimento',
    },
    organizationUnitLocationName: {
        en: 'Unit location code',
        pt: 'Código de localização da unidade',
    },
    typeOfServiceCode: {
        en: 'Service type code',
        pt: 'Código do tipo de serviço',
    },
    typeOfServiceName: {
        en: 'Service type',
        pt: 'Tipo de serviço',
    },
    confirmActive: {
        en: 'Active confirmation',
        pt: 'Confirmação ativa',
    },
    reasonCode: {
        en: 'Reason code',
        pt: 'Código do motivo de não agendamento',
    },
    reasonName: {
        en: 'Reason name',
        pt: 'Nome do motivo de não agendamento',
    },
    reasonText: {
        en: 'Description of the reason for not scheduling',
        pt: 'Descrição do motivo de não agendamento',
    },
    retryAvaliableDateCount: {
        en: 'Retry available date count',
        pt: 'Número de tentativas para datas disponíveis',
    },
    retryFirstAvaliableDate: {
        en: 'Retry first available date',
        pt: 'Primeira data disponível do tentar novamente',
    },
    retryFirstAvaliableDateDistance: {
        en: 'Retry first available date distance',
        pt: 'Tempo para primeira data disponível no tentar novamente',
    },
    retryCount: {
        en: 'Retry count',
        pt: 'Número de tentativas do tentar novamente',
    },
    removed: {
        en: 'removed',
        pt: 'removeu',
    },
    'of conversation': {
        en: 'of conversation',
        pt: 'do atendimento',
    },
    Remove: {
        pt: 'Remover',
        en: 'Remove',
    },
    agent: {
        pt: 'agente',
        en: 'agent',
    },
    'this conversation': {
        pt: 'deste atendimento',
        en: 'this conversation',
    },
    'Remove agent from conversation?': {
        pt: 'Remover agente do atendimento?',
        en: 'Remove agent from conversation?',
    },
    'Without rating': {
        pt: 'Sem avaliação',
        en: 'Without rating',
    },
    Trigger: {
        pt: 'Gatilho',
        en: 'Trigger',
    },
    Triggers: {
        pt: 'Gatilhos',
        en: 'Triggers',
    },
    'The action will trigger another trigger interaction': {
        pt: ' A ação acionará outra interação por gatilhos',
        en: 'The action will trigger another trigger interaction',
    },
    'Enter a trigger': {
        pt: ' Digite um gatilho',
        en: 'Enter a trigger',
    },
    'Enter a action': {
        pt: ' Digite um ação',
        en: 'Enter a action',
    },
    before_end_conversation: {
        pt: 'Antes de finalizar a conversa',
        en: 'Before end conversation',
    },
    active_confirmation_confirm: {
        pt: 'Confirmação ativa - Confirmou',
        en: 'Confirmação ativa - Confirmou',
    },
    active_confirmation_cancel: {
        pt: 'Confirmação ativa - Cancelou',
        en: 'Confirmação ativa - Cancelou',
    },
    'First of day': {
        en: 'First of day',
        pt: 'Primeiros do dia',
    },
    'Period cloned successfully!': {
        pt: 'Período clonado com sucesso!',
        en: 'Period cloned successfully!',
    },
    'Flow executed until': {
        en: 'Flow executed until',
        pt: 'Flow executou até',
    },
    'Flow executing until': {
        en: 'Flow executing until',
        pt: 'Flow executando até',
    },
    'Post disabled by:': {
        pt: 'Publicação desativada por:',
        en: 'Post disabled by:',
    },
    'deactivated publishing this Bot on': {
        pt: 'desativou a publicação deste Bot em',
        en: 'deactivated publishing this Bot on',
    },
    'Disables publishing for everyone except those who turned it off': {
        pt: 'Desabilita o publicar para todos, menos para quem o desativou',
        en: 'Disables publishing for everyone except those who turned it off:',
    },
    'Disable publish': {
        pt: 'Desabilitar publicação',
        en: 'Disable publish',
    },
    'Confirmation Settings List': {
        pt: 'Lista de configurações de confirmação',
        en: 'Confirmation Settings List',
    },
    'Enable Publication': {
        pt: 'Habilitar Publicação',
        en: 'Enable Publication',
    },
    'Publishing disabled': {
        pt: 'Publicação desabilitada',
        en: 'Publishing disabled',
    },
    'This number may not have a WhatsApp account. Please check that the number is correct or see our article for more details on sending errors.':
        {
            pt: 'Este número pode não possuir uma conta no WhatsApp. Verifique se o número está correto ou consulte nosso artigo para mais detalhes sobre erros de envio.',
            en: 'This number may not have a WhatsApp account. Please check that the number is correct or see our article for more details on sending errors.',
        },
    'Are you sure you want to delete the selected entities?': {
        pt: 'Tem certeza que deseja excluir as entidades selecionadas?',
        en: 'Are you sure you want to delete the selected entities?',
    },
    'Change workspace': {
        pt: 'Alterar workspace',
        en: 'Change workspace',
    },
    Confirm: {
        pt: 'Confirmar',
        en: 'Confirm',
    },
    'To schedule': {
        pt: 'Agendar',
        en: 'To schedule',
    },
    Reschedule: {
        pt: 'Reagendar',
        en: 'reschedule',
    },
    'Confirm active': {
        pt: 'Confirmar ativo',
        en: 'Confirm active',
    },
    'Confirm liability': {
        pt: 'Confirmar passivo',
        en: 'confirm liability',
    },
    'To view': {
        pt: 'Visualizar',
        en: 'To view',
    },
    'Click here for more details': {
        pt: 'Clique aqui para mais detalhes',
        en: 'Click here for more details',
    },
    'Cannot do action': {
        pt: 'Não pode realizar a ação',
        en: 'Cannot do action',
    },
    'How long before can confirmation be made (Hours)': {
        pt: 'Quanto tempo antes poderá ser feita confirmação (Horas)',
        en: 'How long before can confirmation be made (Hours)',
    },
    'Time that the first schedule listing will be cached (Minutes)': {
        pt: 'Tempo que o primeiro horário da listagem de horários ficará em cache (Minutos)',
        en: 'Time that the first schedule listing will be cached (Minutes)',
    },
    'Show times after (Days)': {
        pt: 'Mostrar horários após (Dias)',
        en: 'Show times after (Days)',
    },
    'Channel service limit': {
        pt: 'Limite de atendimentos do canal',
        en: 'Channel service limit',
    },
    'Channel message limit': {
        pt: 'Limite de mensagens do canal',
        en: 'Channel message limit',
    },
    'Billing type': {
        pt: 'Tipo de cobrança',
        en: 'Billing type',
    },
    'View only chat history for this team': {
        pt: 'Visualizar apenas histórico de conversas deste time',
        en: 'View only chat history for this team',
    },
    'View team attendance history': {
        pt: 'Ver histórico de atendimentos do time',
        en: 'View team attendance history',
    },
    Pending: {
        pt: 'Pendente',
        en: 'Pending',
    },
    Received: {
        pt: 'Recebido',
        en: 'Received',
    },
    Read: {
        pt: 'Lido',
        en: 'Read',
    },
    Played: {
        pt: 'Reproduzido',
        en: 'Played',
    },
    'The number does not exist on WhatsApp': {
        pt: 'O número não existe no WhatsApp',
        en: 'The number does not exist on WhatsApp',
    },
    'invalid template': {
        pt: 'Template invalido',
        en: 'invalid template',
    },
    'Template message was declined by number': {
        pt: 'Mensagem de template foi recusada pelo número',
        en: 'Template message was declined by number',
    },
    'Invalid media url': {
        pt: 'URL de mídia inválido',
        en: 'Invalid media url',
    },
    'You must fill in the message field with at least 10 characters, along with the file!': {
        pt: 'Necessário o preenchimento do campo mensagem com no mínimo 10 caracteres, junto com o arquivo!',
        en: 'You must fill in the message field with at least 10 characters, along with the file!',
    },
    'Invalid media size': {
        pt: 'Tamanho de mídia inválido',
        en: 'Invalid media size',
    },
    'Limit of days for listing appointments': {
        pt: 'Limite de dias para listar agendamentos',
        en: 'Limit of days for listing appointments',
    },
    'Limit of days to list appointments when you have a doctor selected': {
        pt: 'Limite de dias para listar agendamentos quando tiver médico selecionado',
        en: 'Limit of days to list your appointment when you have a doctor selected',
    },
    'Template is disabled': {
        pt: 'Template está desativado',
        en: 'Template is disabled',
    },
    'Could not send message': {
        pt: 'Não foi possível enviar a mensagem',
        en: 'Could not send message',
    },
    'Skin color': {
        pt: 'Cor de pele',
        en: 'Skin color',
    },
    'Custom flow': {
        pt: 'Fluxo personalizado',
        en: 'Custom flow',
    },
    'Select a flow if you want the bot to continue the conversation when the recipient replies to the message. To create a custom conversation flow, contact support.':
        {
            pt: 'Selecione um fluxo caso deseje que o bot de continuidade na conversa quando o destinatário responder a mensagem. Para criar um fluxo personalizado de conversa entre em contato com o suporte.',
            en: 'Select a flow if you want the bot to continue the conversation when the recipient replies to the message. To create a custom conversation flow, contact support.',
        },
    'Add new list': {
        pt: 'Adicionar nova lista',
        en: 'Add new list',
    },
    'Add Users': {
        pt: 'Adicionar usuários',
        en: 'Add Users',
    },
    'Search teams': {
        pt: 'Buscar times',
        en: 'Search teams',
    },
    'Team not found.': {
        pt: 'Time não encontrado.',
        en: 'Team not found.',
    },
    'There is data pending publication in the flow or entities': {
        pt: 'Existem dados pendentes de publicação no flow ou entidades',
        en: 'There is data pending publication in the flow or entities',
    },
    'Email (Optional)': {
        pt: 'Email (Opcional)',
        en: 'Email (Optional)',
    },
    'No results found': {
        pt: 'Nenhum resultado encontrado',
        en: 'No results found',
    },
    'It is used to reassign a conversation': {
        pt: 'É usado para reatribuir uma conversa',
        en: 'It is used to reassign a conversation',
    },
    'When used, transfers the ongoing conversation to the last team it was assigned to': {
        pt: 'Quando usado, transfere a conversa em andamento para o último time à qual foi atribuída',
        en: 'When used, transfers the ongoing conversation to the last team it was assigned to',
    },
    'Name is required': {
        pt: 'O nome é obrigatório',
        en: 'Name is required',
    },
    'Character max length is 255': {
        pt: 'O comprimento máximo do caractere é 255',
        en: 'Character max length is 255',
    },
    'Character min length is 3': {
        pt: 'O comprimento mínimo do caractere é 3',
        en: 'Character min length is 3',
    },
    'Team is required': {
        pt: 'Um time é necessário',
        en: 'Team is required',
    },
    'Channel is required': {
        pt: 'O canal é obrigatório',
        en: 'Channel is required',
    },
    'Error: One of the numbers provided is invalid to be a phone number': {
        pt: 'Erro: Um dos números fornecidos é inválido para ser um número de telefone',
        en: 'Error: One of the numbers provided is invalid to be a phone number',
    },
    'Error: Duplicate contact found': {
        pt: 'Erro: contato duplicado encontrado',
        en: 'Error: Duplicate contact found',
    },
    'Error: Invalid format. Please separate name and phone number with a comma or semicolon': {
        pt: 'Erro: Formato inválido. Por favor, separe o nome e o número de telefone com uma vírgula ou ponto e vírgula',
        en: 'Error: Invalid format. Please separate name and phone number with a comma or semicolon',
    },
    'Paste here the contacts to be added or enter manually in the format: (name;phone)': {
        pt: 'Cole aqui os contatos a serem adicionados ou insira manualmente no formato: (nome;telefone)',
        en: 'Paste here the contacts to be added or enter manually in the format: (name;phone)',
    },
    UTILITY: {
        pt: 'UTILIDADE',
        en: 'UTILITY',
    },
    AUTHENTICATION: {
        pt: 'AUTENTICAÇÃO',
        en: 'AUTHENTICATION',
    },
    Reminder: {
        pt: 'Lembrete',
        en: 'Reminder',
    },
    Medical_report: {
        pt: 'Laudo médico',
        en: 'Medical report',
    },
    Api_ivr: {
        pt: 'URA',
        en: 'IVR',
    },
    Schedule_notification: {
        pt: 'Notificação de agendamento',
        en: 'Schedule notification',
    },
    'The metric used in this chart has changed:': {
        pt: 'A métrica utilizada neste gráfico teve mudanças:',
        en: 'The metric used in this chart has changed:',
    },
    'This graph had a change in its metrics:': {
        pt: 'Este gráfico teve uma mudança em suas métricas:',
        en: 'This graph had a change in its metrics:',
    },
    'There is already an open service on the channel for this number': {
        pt: 'Já existe atendimento aberto no canal para este número',
        en: 'There is already an open service on the channel for this number',
    },
    'Channel available to start answering the number': {
        pt: 'Canal disponível para iniciar atendimento para o número',
        en: 'Channel available to start answering the number',
    },
    Available: {
        pt: 'Disponível',
        en: 'Available',
    },
    unavailable: {
        pt: 'Indisponível',
        en: 'unavailable',
    },
    'Omit invalids': {
        pt: 'Omitir inválidos',
        en: 'Omit invalids',
    },
    'Omit calls with invalid numbers': {
        pt: 'Omitir atendimentos com número inválido',
        en: 'Omit calls with invalid numbers',
    },
    'reacted with': {
        pt: 'reagiu com',
        en: 'reacted with',
    },
    'to a message': {
        pt: 'a uma mensagem',
        en: 'to a message',
    },
    'Schedule configuration name': {
        pt: 'Nome da configuração de agendamento',
        en: 'Schedule configuration name',
    },
    'Scheduling Settings': {
        pt: 'Configurações de agendamento',
        en: 'Scheduling Settings',
    },
    'Confirmation Settings': {
        pt: 'Configurações confirmação',
        en: 'Confirmation Settings',
    },
    'Schedule search interval (Minutes)': {
        pt: 'Intervalo de busca dos agendamentos (Minutos)',
        en: 'Schedule search interval (Minutes)',
    },
    'Shipping time before appointment date (Hours)': {
        pt: 'Tempo de envio antes da data do agendamento (Horas)',
        en: 'Shipping time before appointment date (Hours)',
    },
    'Group rule': {
        pt: 'Regra do grupo',
        en: 'Group rule',
    },
    'Invalid repeat': {
        pt: 'Repetir inválidos',
        en: 'Invalid repeat',
    },
    'Parameters for ERP': {
        pt: 'Parâmetros para ERP',
        en: 'Parameters for ERP',
    },
    'Reminder Settings': {
        pt: 'Configurações do lembrete',
        en: 'Reminder Settings',
    },
    'Extract at (Minutes)': {
        pt: 'Extraia em (Minutos)',
        en: 'Extract at (Minutes)',
    },
    'Use specialty in exam message': {
        pt: 'Usar especialidade na mensagem de exame',
        en: 'Use specialty in exam message',
    },
    'Send Only Principal Exam': {
        pt: 'Enviar apenas exame principal',
        en: 'Send Only Principal Exam',
    },
    'Extract rule': {
        pt: 'Regra de extração',
        en: 'Extract rule',
    },
    'Shipping List': {
        pt: 'Listagem de envios',
        en: 'Shipping List',
    },
    'Automatic sending': {
        pt: 'Envios automáticos',
        en: 'Automatic sending',
    },
    'User access to the automatic sending list': {
        pt: 'Acesso dos usuários a lista de envios automáticos',
        en: 'User access to the automatic sending list',
    },
    'All users will have access to the list of sending': {
        pt: 'Todos os usuários terão acesso a listagem dos envios',
        en: 'All users will have access to the list of sending',
    },
    'Request completed successfully': {
        pt: 'Solicitação realizada com sucesso',
        en: 'Request completed successfully',
    },
    'Your clone will be available in a few minutes.': {
        pt: 'Seu clone estará disponível em alguns minutos.',
        en: 'Your clone will be available in a few minutes.',
    },
    'Enter a Name': {
        pt: 'Digite um Nome',
        en: 'Enter a Name',
    },
    'Select an item...': {
        pt: 'Selecione um item...',
        en: 'Select an item...',
    },
    'Document number': {
        pt: 'Número do documento',
        en: 'Document number',
    },
    'Doctor data': {
        pt: 'Dados do médico',
        en: 'Doctor data',
    },
    "When you can't find the doctor": {
        pt: 'Quando não encontrar o médico',
        en: "When you can't find the doctor",
    },
    'When the document number is empty': {
        pt: 'Quando o número do documento vier vazio',
        en: 'When the document number is empty',
    },
    'Go to instead of asking for document number': {
        pt: 'Ir para ao invés de perguntar o número do documento',
        en: 'Go to instead of asking for document number',
    },
    Ads: {
        pt: 'Publicidade',
        en: 'Advertising',
    },
    'You do not have permission to access this conversation!': {
        pt: 'Você não possui permissão para acessar este atendimento!',
        en: 'You do not have permission to access this conversation!',
    },
    'Delete Disabled Entities': {
        pt: 'Apagar Entidades Inativas',
        en: 'Delete Disabled Entities',
    },
    'Error on disabled inactive entities': {
        pt: 'Erro ao apagar entidades inativas',
        en: 'Error on disabled inactive entities',
    },
};
